import DataGrid from 'devextreme-react/data-grid';
import React, { useRef } from 'react';
import { Button, Card, Col, Row } from 'reactstrap';

const GrupajHazirlamaV2 = () => {

    const mainGridRef = useRef(null);
    const subGridRef = useRef(null);



    const [mainData, setMainData] = React.useState(initialMainData);
    const [selectedData, setSelectedData] = React.useState([]);
    const [cityList, setCityList] = React.useState([]);

    const handleMainGridSelection = (e) => {
        const selectedRows = e.selectedRowsData;

        if (selectedRows.length === 0) return;

        // Sub grid'e seçilen verileri ekle
        const currentSubData = subGridRef.current.instance.option('dataSource') || [];
        const newSubData = [...currentSubData, ...selectedRows];
        subGridRef.current.instance.option('dataSource', newSubData);

        // Main grid'den seçilen verileri çıkar
        const currentMainData = mainGridRef.current.instance.option('dataSource') || [];
        const newMainData = currentMainData.filter(item =>
            !selectedRows.some(selected => selected.chassis_no === item.chassis_no)
        );
        mainGridRef.current.instance.option('dataSource', newMainData);

        // State'leri de güncelle
        setSelectedData(prev => [...prev, ...selectedRows]);
        setMainData(prev => prev.filter(item =>
            !selectedRows.some(selected => selected.chassis_no === item.chassis_no)
        ));

        // Selection'ı temizle
        mainGridRef.current.instance.clearSelection();
    };

    const handleSubGridSelection = (e) => {
        const selectedRows = e.selectedRowsData;

        if (selectedRows.length === 0) return;

        // Main grid'e seçilen verileri geri ekle
        const currentMainData = mainGridRef.current.instance.option('dataSource') || [];
        const newMainData = [...currentMainData, ...selectedRows];
        mainGridRef.current.instance.option('dataSource', newMainData);

        // Sub grid'den seçilen verileri çıkar
        const currentSubData = subGridRef.current.instance.option('dataSource') || [];
        const newSubData = currentSubData.filter(item =>
            !selectedRows.some(selected => selected.chassis_no === item.chassis_no)
        );
        subGridRef.current.instance.option('dataSource', newSubData);

        // State'leri de güncelle
        setMainData(prev => [...prev, ...selectedRows]);
        setSelectedData(prev => prev.filter(item =>
            !selectedRows.some(selected => selected.chassis_no === item.chassis_no)
        ));

        // Selection'ı temizle
        subGridRef.current.instance.clearSelection();
    };





    return (
        <div>
            <Row>
                <Col md={12} className="mb-3">
                    <Card>
                        <h3>Grupaj Hazırlama V2</h3>

                        <Button color="primary" className="mb-2" onClick={() => {
                            //şehir ve kaç araç var ise listele
                            const city = initialMainData.map(item => ({
                                city_name: item.city_name,
                                count: initialMainData.filter(i => i.city_name === item.city_name).length
                            })).filter((v, i, a) => a.findIndex(t => (t.city_name === v.city_name)) === i);


                            console.log(city);
                            setCityList(city);


                        }} >
                            Listele
                        </Button>
                    </Card>

                </Col>
            </Row>
            <Row>
                <Col md={3} className="mb-3">
                    {/* City Table Component */}
                    <Card className="p-2">

                        <DataGrid
                            dataSource={cityList}

                            showBorders={true}
                            height={400}
                            showColumnLines={true}
                            showRowLines={true}
                            columns={[
                                { dataField: 'city_name', caption: 'Şehir', width: 200 }
                            ]}

                        >
                        </DataGrid>
                    </Card>

                </Col>


                <Col md={9} className="mb-3"><Row>
                    <Col md={12} className="pr-0">
                        <div className="card p-2">
                            {/* City Table Component */}
                            <h5>Main Table</h5>
                            <br />

                            <DataGrid
                                className='user-select-none'
                                ref={mainGridRef}
                                hoverStateEnabled={true}
                                dataSource={mainData}
                                keyExpr="chassis_no"
                                showBorders={true}
                                height={400}
                                showColumnLines={true}
                                showRowLines={true}
                                scrolling={{ mode: 'infinite' }}
                                selection={{ mode: 'multiple', showCheckBoxesMode: 'none' }}
                                onSelectionChanged={handleMainGridSelection}
                                columns={[
                                    { dataField: 'chassis_no', caption: 'Gün', width: 200 },
                                    { dataField: 'process_date', caption: 'FaturaT', width: 200 },
                                    { dataField: 'priority', caption: 'Öncelik', width: 200 },
                                    { dataField: 'chassis_no', caption: 'Şase', width: 150 },
                                    { dataField: 'model', caption: 'Model', width: 200 },
                                    { dataField: 'vehicle_type', caption: 'Tip', width: 200 },
                                    { dataField: 'warehouse_name', caption: 'Nereden', width: 200 },
                                    { dataField: 'zone_name', caption: 'Nereye', width: 200 },
                                    { dataField: 'shipping_info', caption: 'Bilgi', width: 200 },
                                    { dataField: 'blg_date', caption: 'Geliş Tarihi', width: 200 },
                                    { dataField: 'park_address', caption: 'Park Adresi', width: 200 },
                                    { dataField: 'groupage_status', caption: 'Grupaj Durumu', width: 200 },
                                    { dataField: 'pdi_order', caption: 'PDI Emri', width: 200 },
                                    { dataField: 'pdi_status', caption: 'PDI', width: 200 }
                                ]}
                            >


                            </DataGrid>
                        </div>
                    </Col>


                    <Col md={12} className="pr-0 mt-3">
                        <div className="card p-2">
                            {/* Main Table Component */}
                            <h5>Sub Table</h5>
                            <br />
                            <DataGrid
                                className='user-select-none'
                                height={300}
                                showColumnLines={true}
                                showRowLines={true}
                                ref={subGridRef}
                                dataSource={selectedData}
                                keyExpr="chassis_no"
                                hoverStateEnabled={true}
                                showBorders={true}
                                selection={{ mode: 'multiple', showCheckBoxesMode: 'none' }}
                                onSelectionChanged={handleSubGridSelection}
                                columns={[
                                    { dataField: 'chassis_no', caption: 'Gün', width: 200 },
                                    { dataField: 'process_date', caption: 'FaturaT', width: 200 },
                                    { dataField: 'priority', caption: 'Öncelik', width: 200 },
                                    { dataField: 'chassis_no', caption: 'Şase', width: 150 },
                                    { dataField: 'model', caption: 'Model', width: 200 },
                                    { dataField: 'vehicle_type', caption: 'Tip', width: 200 },
                                    { dataField: 'warehouse_name', caption: 'Nereden', width: 200 },
                                    { dataField: 'zone_name', caption: 'Nereye', width: 200 },
                                    { dataField: 'shipping_info', caption: 'Bilgi', width: 200 },
                                    { dataField: 'blg_date', caption: 'Geliş Tarihi', width: 200 },
                                    { dataField: 'park_address', caption: 'Park Adresi', width: 200 },
                                    { dataField: 'groupage_status', caption: 'Grupaj Durumu', width: 200 },
                                    { dataField: 'pdi_order', caption: 'PDI Emri', width: 200 },
                                    { dataField: 'pdi_status', caption: 'PDI', width: 200 }
                                ]}
                            />
                        </div>
                    </Col>
                </Row>
                </Col>

            </Row>
            <style>
                {`
                    .user-select-none {
                        user-select: none;
                    }
                    
                    .dx-datagrid {
                        width: 100% !important;
                        table-layout: fixed !important;
                    }
                    
                    .dx-datagrid-table {
                        table-layout: fixed !important;
                    }
                    
                    .dx-datagrid-headers {
                        table-layout: fixed !important;
                    }
                    
                    .dx-datagrid-content .dx-datagrid-table {
                        table-layout: fixed !important;
                    }

                    .dx-state-hover td[role="gridcell"] {
                        background-color:rgb(255, 214, 164) !important;   
                    }
                `}
            </style>
        </div>
    )
}

export default GrupajHazirlamaV2



const initialMainData = [
    {
        "blg_date": "2025-04-30",
        "brand": null,
        "chassis_no": "VF3VJYHV7SU288229",
        "city_name": null,
        "client_code": "SY000002",
        "color": null,
        "customs_status": null,
        "dealer_name": null,
        "distrit_name": null,
        "groupage_status": "NO_GROUPAGE",
        "model": null,
        "order_type": "INVOICE",
        "park_address": "RESEPSİYON / RS-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "-/",
        "status": "AVAILABLE",
        "vehicle_origin": null,
        "vehicle_type": null,
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "RESEPSİYON"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ631140",
        "city_name": "Ankara",
        "client_code": "00195",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ633914",
        "city_name": "Ankara",
        "client_code": "00195",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-21",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4048779",
        "city_name": "Ankara",
        "client_code": "TR8910",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:10\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 2,
        "process_date": "2025-04-16",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNSXSW025683",
        "city_name": "Ankara",
        "client_code": "TR8910",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VF3VLEHZ7SU284239",
        "city_name": "Ankara",
        "client_code": "00195",
        "color": null,
        "customs_status": null,
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "NO_GROUPAGE",
        "model": "EXPERT",
        "order_type": "INVOICE",
        "park_address": "STOK / AB-9",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7VKEHZ7SZ018420",
        "city_name": "Ankara",
        "client_code": "01459",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "NO_GROUPAGE",
        "model": "JUMPY",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS6SY538865",
        "city_name": "Ankara",
        "client_code": "00195",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS6SY543287",
        "city_name": "Ankara",
        "client_code": "00195",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS7SY538860",
        "city_name": "Ankara",
        "client_code": "00195",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY6SS031761",
        "city_name": "Ankara",
        "client_code": "00195",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ1SS069057",
        "city_name": "Ankara",
        "client_code": "00195",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ7SS063795",
        "city_name": "Ankara",
        "client_code": "00195",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ8SS065278",
        "city_name": "Ankara",
        "client_code": "00195",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ633932",
        "city_name": "Ankara",
        "client_code": "00195",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ633750",
        "city_name": "Ankara",
        "client_code": "00195",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ633931",
        "city_name": "Ankara",
        "client_code": "00195",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS1SE034537",
        "city_name": "Ankara",
        "client_code": "01459",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:01\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS8SE034549",
        "city_name": "Ankara",
        "client_code": "01459",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE034270",
        "city_name": "Ankara",
        "client_code": "01459",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW0SE034472",
        "city_name": "Ankara",
        "client_code": "01459",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:08\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS4SW026201",
        "city_name": "Ankara",
        "client_code": "TR8910",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS7SW026239",
        "city_name": "Ankara",
        "client_code": "TR8910",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP2SJ638313",
        "city_name": "Ankara",
        "client_code": "TR8910",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP2SJ638327",
        "city_name": "Ankara",
        "client_code": "TR8910",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP2SJ638344",
        "city_name": "Ankara",
        "client_code": "TR8910",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP6SJ638363",
        "city_name": "Ankara",
        "client_code": "TR8910",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHPXSJ638320",
        "city_name": "Ankara",
        "client_code": "TR8910",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ1SN523146",
        "city_name": "Ankara",
        "client_code": "TR8910",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:13\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SJ619868",
        "city_name": "Ankara",
        "client_code": "TR8910",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ6SJ619846",
        "city_name": "Ankara",
        "client_code": "TR8910",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SN521773",
        "city_name": "Ankara",
        "client_code": "TR8910",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SN522424",
        "city_name": "Ankara",
        "client_code": "TR8910",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:15\"}",
        "dealer_name": "ABC",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ABC-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHZ2SU288645",
        "city_name": "Gaziantep",
        "client_code": "TR8045",
        "color": null,
        "customs_status": null,
        "dealer_name": "ADIM",
        "distrit_name": "Şehitkamil",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ADIM-Gaziantep/Şehitkamil",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ0SJ618160",
        "city_name": "Gaziantep",
        "client_code": "TR8045",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "ADIM",
        "distrit_name": "Şehitkamil",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ADIM-Gaziantep/Şehitkamil",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ6SN523157",
        "city_name": "Gaziantep",
        "client_code": "TR8045",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "ADIM",
        "distrit_name": "Şehitkamil",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ADIM-Gaziantep/Şehitkamil",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ618138",
        "city_name": "Gaziantep",
        "client_code": "TR8045",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "ADIM",
        "distrit_name": "Şehitkamil",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ADIM-Gaziantep/Şehitkamil",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SN523144",
        "city_name": "Gaziantep",
        "client_code": "TR8045",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "ADIM",
        "distrit_name": "Şehitkamil",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ADIM-Gaziantep/Şehitkamil",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ5SJ620266",
        "city_name": "Gaziantep",
        "client_code": "01400",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "ADIM GAZİANTEP",
        "distrit_name": "Şehitkamil",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ADIM GAZİANTEP-Gaziantep/Şehitkamil",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ636686",
        "city_name": "Aksaray",
        "client_code": "00291",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-25",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY538878",
        "city_name": "Aksaray",
        "client_code": "00291",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS066405",
        "city_name": "Aksaray",
        "client_code": "00291",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ6SS064467",
        "city_name": "Aksaray",
        "client_code": "00291",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ7SS065272",
        "city_name": "Aksaray",
        "client_code": "00291",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ8SS065426",
        "city_name": "Aksaray",
        "client_code": "00291",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7ACYHZ2SL018365",
        "city_name": "Aksaray",
        "client_code": "01485",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C5 AIRCROSS",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7ACYHZ6SL018188",
        "city_name": "Aksaray",
        "client_code": "01485",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C5 AIRCROSS",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BCZKW0SE026347",
        "city_name": "Aksaray",
        "client_code": "01485",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:56\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BCZKW4SE017845",
        "city_name": "Aksaray",
        "client_code": "01485",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:33\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BCZKW6SE026384",
        "city_name": "Aksaray",
        "client_code": "01485",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:56\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS2SE034207",
        "city_name": "Aksaray",
        "client_code": "01485",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:02\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS8SE034146",
        "city_name": "Aksaray",
        "client_code": "01485",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW7SE031519",
        "city_name": "Aksaray",
        "client_code": "01485",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:08\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW8SE031478",
        "city_name": "Aksaray",
        "client_code": "01485",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:08\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP6SJ577653",
        "city_name": "Aksaray",
        "client_code": "01485",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 10:32:10\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ9SJ614731",
        "city_name": "Aksaray",
        "client_code": "01485",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS8SW026170",
        "city_name": "Aksaray",
        "client_code": "TR0062",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "AĞAÇLI",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "AĞAÇLI-Aksaray/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS1SY538756",
        "city_name": "İstanbul",
        "client_code": "00002",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS8SY538818",
        "city_name": "İstanbul",
        "client_code": "00002",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNSXSY535080",
        "city_name": "İstanbul",
        "client_code": "00002",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS031765",
        "city_name": "İstanbul",
        "client_code": "00002",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY9SS037831",
        "city_name": "İstanbul",
        "client_code": "00002",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ631332",
        "city_name": "İstanbul",
        "client_code": "00002",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ635123",
        "city_name": "İstanbul",
        "client_code": "00002",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ631083",
        "city_name": "İstanbul",
        "client_code": "00002",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ631326",
        "city_name": "İstanbul",
        "client_code": "00002",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ634252",
        "city_name": "İstanbul",
        "client_code": "00002",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS7SJ631134",
        "city_name": "İstanbul",
        "client_code": "00002",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ633752",
        "city_name": "İstanbul",
        "client_code": "00002",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ1SJ652575",
        "city_name": "İstanbul",
        "client_code": "00000373",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ2SJ648017",
        "city_name": "İstanbul",
        "client_code": "00000373",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ2SJ649846",
        "city_name": "İstanbul",
        "client_code": "00000373",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ2SJ655193",
        "city_name": "İstanbul",
        "client_code": "00000373",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ4SJ642090",
        "city_name": "İstanbul",
        "client_code": "00000373",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SJ644270",
        "city_name": "İstanbul",
        "client_code": "00000373",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ6SJ649848",
        "city_name": "İstanbul",
        "client_code": "00000373",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ6SJ654659",
        "city_name": "İstanbul",
        "client_code": "00000373",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ6SJ654662",
        "city_name": "İstanbul",
        "client_code": "00000373",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ641886",
        "city_name": "İstanbul",
        "client_code": "00000373",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ648031",
        "city_name": "İstanbul",
        "client_code": "00000373",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ649826",
        "city_name": "İstanbul",
        "client_code": "00000373",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SJ644263",
        "city_name": "İstanbul",
        "client_code": "00000373",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SJ652556",
        "city_name": "İstanbul",
        "client_code": "00000373",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSJ644281",
        "city_name": "İstanbul",
        "client_code": "00000373",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSJ652610",
        "city_name": "İstanbul",
        "client_code": "00000373",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "AKTİF-İRİYIL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AKTİF-İRİYIL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ3SJ645943",
        "city_name": "İstanbul",
        "client_code": "00000498",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "ALA FİLO",
        "distrit_name": "Kartal",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ALA FİLO-İstanbul/Kartal",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ7SJ645993",
        "city_name": "İstanbul",
        "client_code": "00000498",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "ALA FİLO",
        "distrit_name": "Kartal",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ALA FİLO-İstanbul/Kartal",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ7SJ646447",
        "city_name": "İstanbul",
        "client_code": "00000498",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "ALA FİLO",
        "distrit_name": "Kartal",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ALA FİLO-İstanbul/Kartal",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ9SJ624059",
        "city_name": "Eskişehir",
        "client_code": "01451",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "ALPATA",
        "distrit_name": "Odunpazarı",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ALPATA-Eskişehir/Odunpazarı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS0SY538960",
        "city_name": "Antalya",
        "client_code": "ANB-PEU-641",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "ANTALYA BACAR",
        "distrit_name": "Aksu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ANTALYA BACAR-Antalya/Aksu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS7SY540009",
        "city_name": "Antalya",
        "client_code": "ANB-PEU-641",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ANTALYA BACAR",
        "distrit_name": "Aksu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ANTALYA BACAR-Antalya/Aksu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS8SY534249",
        "city_name": "Antalya",
        "client_code": "ANB-PEU-641",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ANTALYA BACAR",
        "distrit_name": "Aksu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ANTALYA BACAR-Antalya/Aksu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS8SY538768",
        "city_name": "Antalya",
        "client_code": "ANB-PEU-641",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ANTALYA BACAR",
        "distrit_name": "Aksu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ANTALYA BACAR-Antalya/Aksu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4070644",
        "city_name": "Antalya",
        "client_code": "TR8500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "ANTOTO",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ANTOTO-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS037724",
        "city_name": "Antalya",
        "client_code": "00276",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "ANTOTO",
        "distrit_name": "Konyaaltı",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ANTOTO-Antalya/Konyaaltı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS0SE028535",
        "city_name": "Antalya",
        "client_code": "01477",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:56\"}",
        "dealer_name": "ANTOTO",
        "distrit_name": "Konyaaltı",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ANTOTO-Antalya/Konyaaltı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP7SJ638573",
        "city_name": "Antalya",
        "client_code": "01477",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "ANTOTO",
        "distrit_name": "Konyaaltı",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ANTOTO-Antalya/Konyaaltı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4070553",
        "city_name": "Antalya",
        "client_code": "TR8500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "ANTOTO",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ANTOTO-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS0SW027443",
        "city_name": "Antalya",
        "client_code": "TR8500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "ANTOTO",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ANTOTO-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS031770",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY538900",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS5SY538775",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS069660",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS048518",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY6SS066395",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS064133",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ0SS069034",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ6SS066090",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:52\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ8SS063806",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ9SS064916",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZXSS065427",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ625515",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ628060",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ628058",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ625517",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ625520",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ628054",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ625521",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ633960",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ625522",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ628056",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ629935",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ625523",
        "city_name": "İzmir",
        "client_code": "00247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Çiğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ARKAS-İzmir/Çiğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4084349",
        "city_name": "İzmir",
        "client_code": "TR4704",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Karşıyaka",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ARKAS-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4073866",
        "city_name": "İzmir",
        "client_code": "TR4704",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Karşıyaka",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ARKAS-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS9SW028932",
        "city_name": "İzmir",
        "client_code": "TR4704",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Karşıyaka",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ARKAS-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP3SJ655735",
        "city_name": "İzmir",
        "client_code": "TR4704",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:59\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ1SJ649854",
        "city_name": "İzmir",
        "client_code": "TR4704",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ2SJ652584",
        "city_name": "İzmir",
        "client_code": "TR4704",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ4SJ641313",
        "city_name": "İzmir",
        "client_code": "TR4704",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SJ648044",
        "city_name": "İzmir",
        "client_code": "TR4704",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SJ652606",
        "city_name": "İzmir",
        "client_code": "TR4704",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SJ624281",
        "city_name": "İzmir",
        "client_code": "TR4704",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSJ652560",
        "city_name": "İzmir",
        "client_code": "TR4704",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSJ652655",
        "city_name": "İzmir",
        "client_code": "TR4704",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSJ652896",
        "city_name": "İzmir",
        "client_code": "TR4704",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "ARKAS",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP0SJ596604",
        "city_name": "İzmir",
        "client_code": "01449",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 14:56:34\"}",
        "dealer_name": "ARKAS GAZİEMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS GAZİEMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ0SJ619896",
        "city_name": "İzmir",
        "client_code": "01449",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "ARKAS GAZİEMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ARKAS GAZİEMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ0SJ619932",
        "city_name": "İzmir",
        "client_code": "01449",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "ARKAS GAZİEMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ARKAS GAZİEMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ2SJ620290",
        "city_name": "İzmir",
        "client_code": "01449",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "ARKAS GAZİEMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ARKAS GAZİEMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ7SJ620236",
        "city_name": "İzmir",
        "client_code": "01449",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "ARKAS GAZİEMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ARKAS GAZİEMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ9SJ618312",
        "city_name": "İzmir",
        "client_code": "01449",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "ARKAS GAZİEMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ARKAS GAZİEMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ9SJ620187",
        "city_name": "İzmir",
        "client_code": "01449",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "ARKAS GAZİEMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ARKAS GAZİEMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7VLEHZ8SU285270",
        "city_name": "İzmir",
        "client_code": "01444",
        "color": null,
        "customs_status": null,
        "dealer_name": "ARKAS KARŞIYAKA",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "JUMPY VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AB-33",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS KARŞIYAKA-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS1SE033719",
        "city_name": "İzmir",
        "client_code": "01444",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ARKAS KARŞIYAKA",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS KARŞIYAKA-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS7SE028329",
        "city_name": "İzmir",
        "client_code": "01444",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "ARKAS KARŞIYAKA",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS KARŞIYAKA-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BCZKW1SE026910",
        "city_name": "İzmir",
        "client_code": "01444",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "ARKAS KARŞIYAKA",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS KARŞIYAKA-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS3SE034586",
        "city_name": "İzmir",
        "client_code": "01444",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "ARKAS KARŞIYAKA",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS KARŞIYAKA-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE026752",
        "city_name": "İzmir",
        "client_code": "01444",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "ARKAS KARŞIYAKA",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS KARŞIYAKA-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW0SE034570",
        "city_name": "İzmir",
        "client_code": "01444",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:08\"}",
        "dealer_name": "ARKAS KARŞIYAKA",
        "distrit_name": "Karşıyaka",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS KARŞIYAKA-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ3SJ619939",
        "city_name": "İzmir",
        "client_code": "01444",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "ARKAS KARŞIYAKA",
        "distrit_name": "Karşıyaka",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS KARŞIYAKA-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ4SJ619898",
        "city_name": "İzmir",
        "client_code": "01444",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "ARKAS KARŞIYAKA",
        "distrit_name": "Karşıyaka",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS KARŞIYAKA-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ6SJ620292",
        "city_name": "İzmir",
        "client_code": "01444",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "ARKAS KARŞIYAKA",
        "distrit_name": "Karşıyaka",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARKAS KARŞIYAKA-İzmir/Karşıyaka",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS037841",
        "city_name": "Diyarbakır",
        "client_code": "00255",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ARM",
        "distrit_name": "Yenişehir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "ARM-Diyarbakır/Yenişehir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS037842",
        "city_name": "Diyarbakır",
        "client_code": "00255",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ARM",
        "distrit_name": "Yenişehir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "ARM-Diyarbakır/Yenişehir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS2SY538961",
        "city_name": "Diyarbakır",
        "client_code": "00255",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "ARM",
        "distrit_name": "Yenişehir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ARM-Diyarbakır/Yenişehir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS6SY538851",
        "city_name": "Diyarbakır",
        "client_code": "00255",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ARM",
        "distrit_name": "Yenişehir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ARM-Diyarbakır/Yenişehir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY6SS037561",
        "city_name": "Diyarbakır",
        "client_code": "00255",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "ARM",
        "distrit_name": "Yenişehir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ARM-Diyarbakır/Yenişehir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY9SS037747",
        "city_name": "Diyarbakır",
        "client_code": "00255",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "ARM",
        "distrit_name": "Yenişehir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ARM-Diyarbakır/Yenişehir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-28",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY0SS068465",
        "city_name": "Batman",
        "client_code": "00000496",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ARM BATMAN",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ARM BATMAN-Batman/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-28",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS068629",
        "city_name": "Batman",
        "client_code": "00000496",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "ARM BATMAN",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ARM BATMAN-Batman/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX0S4090719",
        "city_name": "İstanbul",
        "client_code": "TR9000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "ASAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ASAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX2S4091077",
        "city_name": "İstanbul",
        "client_code": "TR9000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "ASAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ASAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX6S4090644",
        "city_name": "İstanbul",
        "client_code": "TR9000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "ASAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ASAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4066918",
        "city_name": "İstanbul",
        "client_code": "TR9000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "ASAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ASAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4084099",
        "city_name": "İstanbul",
        "client_code": "TR9000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "ASAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ASAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP5SJ655722",
        "city_name": "İstanbul",
        "client_code": "TR9000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "ASAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ASAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP5SJ655753",
        "city_name": "İstanbul",
        "client_code": "TR9000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "ASAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ASAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP5SJ656708",
        "city_name": "İstanbul",
        "client_code": "TR9000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "ASAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ASAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP6SJ652862",
        "city_name": "İstanbul",
        "client_code": "TR9000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "ASAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ASAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ1SN527410",
        "city_name": "İstanbul",
        "client_code": "TR9000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "ASAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ASAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SN521238",
        "city_name": "İstanbul",
        "client_code": "TR9000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "ASAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ASAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SN521779",
        "city_name": "İstanbul",
        "client_code": "TR9000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "ASAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ASAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SN525914",
        "city_name": "İstanbul",
        "client_code": "TR9000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "ASAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ASAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SJ644255",
        "city_name": "İstanbul",
        "client_code": "TR9000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "ASAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ASAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSN527406",
        "city_name": "İstanbul",
        "client_code": "TR9000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "ASAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ASAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHZ6SU287871",
        "city_name": "Hatay",
        "client_code": "TR0051",
        "color": null,
        "customs_status": null,
        "dealer_name": "ASLANBEY",
        "distrit_name": "Antakya",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ASLANBEY-Hatay/Antakya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4038315",
        "city_name": "Hatay",
        "client_code": "TR0051",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "ASLANBEY",
        "distrit_name": "Antakya",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ASLANBEY-Hatay/Antakya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ631078",
        "city_name": "Hatay",
        "client_code": "00272",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ASLANBEY",
        "distrit_name": "Belen",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ASLANBEY-Hatay/Belen",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ633973",
        "city_name": "Hatay",
        "client_code": "00272",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ASLANBEY",
        "distrit_name": "Belen",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ASLANBEY-Hatay/Belen",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP8SJ626254",
        "city_name": "Hatay",
        "client_code": "01468",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "ASLANBEY",
        "distrit_name": "İskenderun",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ASLANBEY-Hatay/İskenderun",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VF7VKEHZXSZ024499",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPY",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VF7VLEHZ0S7804374",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-20 11:54:53\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPY VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VF7VLEHZ6S7804248",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-20 11:54:53\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPY VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VF7VLEHZ7SU285468",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": null,
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "NO_GROUPAGE",
        "model": "JUMPY VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-15",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS0SE034206",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:01\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS3SE034250",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS3SE034538",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS3SE034541",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS3SE034605",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS4SE034192",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS4SE034466",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS4SE034533",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE034267",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP2SJ626332",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:09\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ4SJ620257",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ5SJ620218",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ5SJ647967",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ6SJ619997",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ8SJ614722",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ8SJ620018",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ9SJ641718",
        "city_name": "Ankara",
        "client_code": "01432",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "ATA",
        "distrit_name": "Çankaya",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ATA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-22",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS029019",
        "city_name": "Ordu",
        "client_code": "00283",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-28 10:42:16\"}",
        "dealer_name": "ATEŞ",
        "distrit_name": "Gülyalı",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 2,
        "process_date": "2025-04-21",
        "shipping_info": "ATEŞ-Ordu/Gülyalı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY9SS037845",
        "city_name": "Ordu",
        "client_code": "00283",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "ATEŞ",
        "distrit_name": "Gülyalı",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ATEŞ-Ordu/Gülyalı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS037843",
        "city_name": "Ordu",
        "client_code": "00283",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "ATEŞ",
        "distrit_name": "Gülyalı",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ATEŞ-Ordu/Gülyalı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS8SE010770",
        "city_name": "İstanbul",
        "client_code": "AUF-CIT-380",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-24 10:02:01\"}",
        "dealer_name": "AUTOCRAT FİLO",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-02-28",
        "shipping_info": "AUTOCRAT FİLO-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS8SE010784",
        "city_name": "İstanbul",
        "client_code": "AUF-CIT-380",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-24 10:02:01\"}",
        "dealer_name": "AUTOCRAT FİLO",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-02-28",
        "shipping_info": "AUTOCRAT FİLO-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE009403",
        "city_name": "İstanbul",
        "client_code": "AUF-CIT-380",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-24 10:02:01\"}",
        "dealer_name": "AUTOCRAT FİLO",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-02-28",
        "shipping_info": "AUTOCRAT FİLO-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE009734",
        "city_name": "İstanbul",
        "client_code": "AUF-CIT-380",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-24 10:02:01\"}",
        "dealer_name": "AUTOCRAT FİLO",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-02-28",
        "shipping_info": "AUTOCRAT FİLO-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE010768",
        "city_name": "İstanbul",
        "client_code": "AUF-CIT-380",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-24 10:02:01\"}",
        "dealer_name": "AUTOCRAT FİLO",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-02-28",
        "shipping_info": "AUTOCRAT FİLO-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE010916",
        "city_name": "İstanbul",
        "client_code": "AUF-CIT-380",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-24 10:02:01\"}",
        "dealer_name": "AUTOCRAT FİLO",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-02-28",
        "shipping_info": "AUTOCRAT FİLO-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ630407",
        "city_name": "İstanbul",
        "client_code": "00001133",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "AUTOROLA",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AUTOROLA-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ630408",
        "city_name": "İstanbul",
        "client_code": "00001133",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "AUTOROLA",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AUTOROLA-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ630409",
        "city_name": "İstanbul",
        "client_code": "00001133",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "AUTOROLA",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AUTOROLA-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ627966",
        "city_name": "İstanbul",
        "client_code": "00001133",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "AUTOROLA",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AUTOROLA-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4044895",
        "city_name": "İstanbul",
        "client_code": "00000578",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "AUTOROLA",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AUTOROLA-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4071516",
        "city_name": "İstanbul",
        "client_code": "00000578",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "AUTOROLA",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "AUTOROLA-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4071517",
        "city_name": "İstanbul",
        "client_code": "00000578",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "AUTOROLA",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AUTOROLA-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4071477",
        "city_name": "İstanbul",
        "client_code": "00000578",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "AUTOROLA",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AUTOROLA-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ3SJ648043",
        "city_name": "İstanbul",
        "client_code": "TR0070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "AVEK",
        "distrit_name": "Esenler",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "AVEK-İstanbul/Esenler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ3SJ649855",
        "city_name": "İstanbul",
        "client_code": "TR0070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "AVEK",
        "distrit_name": "Esenler",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "AVEK-İstanbul/Esenler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ4SJ652585",
        "city_name": "İstanbul",
        "client_code": "TR0070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "AVEK",
        "distrit_name": "Esenler",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "AVEK-İstanbul/Esenler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ6SJ648053",
        "city_name": "İstanbul",
        "client_code": "TR0070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "AVEK",
        "distrit_name": "Esenler",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "AVEK-İstanbul/Esenler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ6SJ652653",
        "city_name": "İstanbul",
        "client_code": "TR0070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "AVEK",
        "distrit_name": "Esenler",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AVEK-İstanbul/Esenler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ654654",
        "city_name": "İstanbul",
        "client_code": "TR0070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "AVEK",
        "distrit_name": "Esenler",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "AVEK-İstanbul/Esenler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SJ643395",
        "city_name": "İstanbul",
        "client_code": "TR0070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "AVEK",
        "distrit_name": "Esenler",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AVEK-İstanbul/Esenler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS4SW026134",
        "city_name": "Zonguldak",
        "client_code": "TR9010",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "AYSA",
        "distrit_name": "Ereğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "AYSA-Zonguldak/Ereğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS4SW026022",
        "city_name": "Zonguldak",
        "client_code": "TR9010",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "AYSA",
        "distrit_name": "Ereğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "AYSA-Zonguldak/Ereğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS064953",
        "city_name": "Zonguldak",
        "client_code": "00278",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "AYSA",
        "distrit_name": "Ereğli",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AYSA-Zonguldak/Ereğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS037745",
        "city_name": "Zonguldak",
        "client_code": "00278",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "AYSA",
        "distrit_name": "Ereğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "AYSA-Zonguldak/Ereğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZXSS064469",
        "city_name": "Zonguldak",
        "client_code": "00278",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "AYSA",
        "distrit_name": "Ereğli",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AYSA-Zonguldak/Ereğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ650692",
        "city_name": "Zonguldak",
        "client_code": "00278",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:54\"}",
        "dealer_name": "AYSA",
        "distrit_name": "Ereğli",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AYSA-Zonguldak/Ereğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ631786",
        "city_name": "Zonguldak",
        "client_code": "00278",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "AYSA",
        "distrit_name": "Ereğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "AYSA-Zonguldak/Ereğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS7SJ633935",
        "city_name": "Zonguldak",
        "client_code": "00278",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "AYSA",
        "distrit_name": "Ereğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AYSA-Zonguldak/Ereğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7ACYHZ3SL018360",
        "city_name": "Zonguldak",
        "client_code": "01495",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "AYSA",
        "distrit_name": "Ereğli",
        "groupage_status": "NO_GROUPAGE",
        "model": "C5 AIRCROSS",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AYSA-Zonguldak/Ereğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7ACYHZ9SL017956",
        "city_name": "Zonguldak",
        "client_code": "01495",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "AYSA",
        "distrit_name": "Ereğli",
        "groupage_status": "NO_GROUPAGE",
        "model": "C5 AIRCROSS",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "AYSA-Zonguldak/Ereğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX3S4090648",
        "city_name": "Zonguldak",
        "client_code": "TR9010",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "AYSA",
        "distrit_name": "Ereğli",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "AYSA-Zonguldak/Ereğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS2SW027203",
        "city_name": "Zonguldak",
        "client_code": "TR9010",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "AYSA",
        "distrit_name": "Ereğli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "AYSA-Zonguldak/Ereğli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS8SY538981",
        "city_name": "Ankara",
        "client_code": "BAH-PEU-999",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "BACAR HANGAR",
        "distrit_name": "Yenimahalle",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BACAR HANGAR-Ankara/Yenimahalle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS3SY540055",
        "city_name": "İstanbul",
        "client_code": "00000602",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "BACAR KAĞITHANE",
        "distrit_name": "Kağıthane",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BACAR KAĞITHANE-İstanbul/Kağıthane",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNSXSY543356",
        "city_name": "İstanbul",
        "client_code": "00000602",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "BACAR KAĞITHANE",
        "distrit_name": "Kağıthane",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BACAR KAĞITHANE-İstanbul/Kağıthane",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE036759",
        "city_name": "İstanbul",
        "client_code": "00000656",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "BACAR KAĞITHANE",
        "distrit_name": "Kağıthane",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BACAR KAĞITHANE-İstanbul/Kağıthane",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE034110",
        "city_name": "İstanbul",
        "client_code": "00000656",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "BACAR KAĞITHANE",
        "distrit_name": "Kağıthane",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BACAR KAĞITHANE-İstanbul/Kağıthane",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS2SY538765",
        "city_name": "İstanbul",
        "client_code": "00000365",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "BACAR SAMANDIRA",
        "distrit_name": "Maltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BACAR SAMANDIRA-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS2SY539091",
        "city_name": "İstanbul",
        "client_code": "00000365",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "BACAR SAMANDIRA",
        "distrit_name": "Maltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BACAR SAMANDIRA-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS6SY538770",
        "city_name": "İstanbul",
        "client_code": "00000365",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "BACAR SAMANDIRA",
        "distrit_name": "Maltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BACAR SAMANDIRA-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS6SY539093",
        "city_name": "İstanbul",
        "client_code": "00000365",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "BACAR SAMANDIRA",
        "distrit_name": "Maltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BACAR SAMANDIRA-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS8SY539094",
        "city_name": "İstanbul",
        "client_code": "00000365",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "BACAR SAMANDIRA",
        "distrit_name": "Maltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BACAR SAMANDIRA-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ622100",
        "city_name": "İstanbul",
        "client_code": "00000365",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "BACAR SAMANDIRA",
        "distrit_name": "Maltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "BACAR SAMANDIRA-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ621857",
        "city_name": "İstanbul",
        "client_code": "00000365",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:42\"}",
        "dealer_name": "BACAR SAMANDIRA",
        "distrit_name": "Maltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "BACAR SAMANDIRA-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS1SE028074",
        "city_name": "İstanbul",
        "client_code": "00000422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:39\"}",
        "dealer_name": "BACAR SAMANDIRA",
        "distrit_name": "Maltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BACAR SAMANDIRA-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE028077",
        "city_name": "İstanbul",
        "client_code": "00000422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:39\"}",
        "dealer_name": "BACAR SAMANDIRA",
        "distrit_name": "Maltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BACAR SAMANDIRA-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE028078",
        "city_name": "İstanbul",
        "client_code": "00000422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:39\"}",
        "dealer_name": "BACAR SAMANDIRA",
        "distrit_name": "Maltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BACAR SAMANDIRA-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4066691",
        "city_name": "İstanbul",
        "client_code": "00000395",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "BACAR SAMANDIRA",
        "distrit_name": "Maltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "BACAR SAMANDIRA-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS037578",
        "city_name": "Muğla",
        "client_code": "00265",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "BAKIRCILAR",
        "distrit_name": "Fethiye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BAKIRCILAR-Muğla/Fethiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS037725",
        "city_name": "Muğla",
        "client_code": "00265",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "BAKIRCILAR",
        "distrit_name": "Fethiye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BAKIRCILAR-Muğla/Fethiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ2SS067138",
        "city_name": "Muğla",
        "client_code": "00265",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "BAKIRCILAR",
        "distrit_name": "Fethiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BAKIRCILAR-Muğla/Fethiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3UKZKW0SJ600126",
        "city_name": "Muğla",
        "client_code": "00265",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 14:56:30\"}",
        "dealer_name": "BAKIRCILAR",
        "distrit_name": "Fethiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BAKIRCILAR-Muğla/Fethiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX2S4090656",
        "city_name": "Muğla",
        "client_code": "TR8700",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "BAKIRCILAR",
        "distrit_name": "Fethiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BAKIRCILAR-Muğla/Fethiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ4SJ642106",
        "city_name": "Muğla",
        "client_code": "TR8700",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "BAKIRCILAR",
        "distrit_name": "Fethiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BAKIRCILAR-Muğla/Fethiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SJ652573",
        "city_name": "Muğla",
        "client_code": "TR8700",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "BAKIRCILAR",
        "distrit_name": "Fethiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BAKIRCILAR-Muğla/Fethiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP6SJ634532",
        "city_name": "Antalya",
        "client_code": "01457",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "BALABAN",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BALABAN-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP8SJ626318",
        "city_name": "Antalya",
        "client_code": "01457",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "BALABAN",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BALABAN-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHPXSJ596576",
        "city_name": "Antalya",
        "client_code": "01457",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 14:56:35\"}",
        "dealer_name": "BALABAN",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BALABAN-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHZ1SU287468",
        "city_name": "Çanakkale",
        "client_code": "TR8020",
        "color": null,
        "customs_status": null,
        "dealer_name": "BAŞARAN",
        "distrit_name": "Kepez",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "BAŞARAN-Çanakkale/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNSXSY538822",
        "city_name": "Çanakkale",
        "client_code": "00217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "BAŞARAN",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "BAŞARAN-Çanakkale/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS2SE027573",
        "city_name": "Diyarbakır",
        "client_code": "01453",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "BAŞDAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BAŞDAŞ-Diyarbakır/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP2RJ053281",
        "city_name": "Diyarbakır",
        "client_code": "01453",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "BAŞDAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BAŞDAŞ-Diyarbakır/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP6SJ626317",
        "city_name": "Diyarbakır",
        "client_code": "01453",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "BAŞDAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BAŞDAŞ-Diyarbakır/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS2SE032876",
        "city_name": "İzmir",
        "client_code": "BAE-CIT-430",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:02\"}",
        "dealer_name": "BATMAN EMİR",
        "distrit_name": "Buca",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BATMAN EMİR-İzmir/Buca",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS037565",
        "city_name": "Bursa",
        "client_code": "00224",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "BAYKAR",
        "distrit_name": "Panayır",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BAYKAR-Bursa/Panayır",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS037728",
        "city_name": "Bursa",
        "client_code": "00224",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "BAYKAR",
        "distrit_name": "Panayır",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BAYKAR-Bursa/Panayır",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ5SS063651",
        "city_name": "Bursa",
        "client_code": "00224",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "BAYKAR",
        "distrit_name": "Panayır",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BAYKAR-Bursa/Panayır",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ631155",
        "city_name": "Bursa",
        "client_code": "00224",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "BAYKAR",
        "distrit_name": "Panayır",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "BAYKAR-Bursa/Panayır",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS032417",
        "city_name": "İstanbul",
        "client_code": "00198",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "BAYKARALAR",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "BAYKARALAR-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY0SS038673",
        "city_name": "İstanbul",
        "client_code": "00198",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "BAYKARALAR",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "BAYKARALAR-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS032700",
        "city_name": "İstanbul",
        "client_code": "00198",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "BAYKARALAR",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "BAYKARALAR-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS2SY539026",
        "city_name": "İstanbul",
        "client_code": "00198",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "BAYKARALAR",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BAYKARALAR-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS9SY538777",
        "city_name": "İstanbul",
        "client_code": "00198",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "BAYKARALAR",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BAYKARALAR-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS031764",
        "city_name": "İstanbul",
        "client_code": "00198",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "BAYKARALAR",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "BAYKARALAR-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS037729",
        "city_name": "İstanbul",
        "client_code": "00198",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "BAYKARALAR",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BAYKARALAR-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS037830",
        "city_name": "İstanbul",
        "client_code": "00198",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "BAYKARALAR",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BAYKARALAR-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ5SS063407",
        "city_name": "İstanbul",
        "client_code": "00198",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "BAYKARALAR",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BAYKARALAR-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ6SS063805",
        "city_name": "İstanbul",
        "client_code": "00198",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "BAYKARALAR",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BAYKARALAR-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ8SS063675",
        "city_name": "İstanbul",
        "client_code": "00198",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "BAYKARALAR",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BAYKARALAR-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ8SS067144",
        "city_name": "İstanbul",
        "client_code": "00198",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "BAYKARALAR",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BAYKARALAR-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ9SS067279",
        "city_name": "İstanbul",
        "client_code": "00198",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "BAYKARALAR",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BAYKARALAR-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ633751",
        "city_name": "İstanbul",
        "client_code": "00198",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "BAYKARALAR",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "BAYKARALAR-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ631331",
        "city_name": "İstanbul",
        "client_code": "00198",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "BAYKARALAR",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "BAYKARALAR-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHZ0SJ641222",
        "city_name": "İstanbul",
        "client_code": "BEG-PEU-186",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:51\"}",
        "dealer_name": "BERA GROUP",
        "distrit_name": "Maltepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BERA GROUP-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS031777",
        "city_name": "Balıkesir",
        "client_code": "00226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Altıeylül",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "BEYAZ-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4043442",
        "city_name": "Balıkesir",
        "client_code": "TR8901",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNSXSW026798",
        "city_name": "Balıkesir",
        "client_code": "TR8901",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F7SG015998",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP0SN525641",
        "city_name": "Balıkesir",
        "client_code": "00226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:49\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BEYAZ-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP4SN525352",
        "city_name": "Balıkesir",
        "client_code": "00226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:50\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP4SN527098",
        "city_name": "Balıkesir",
        "client_code": "00226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:50\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP6SN527104",
        "city_name": "Balıkesir",
        "client_code": "00226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:50\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS1SY542516",
        "city_name": "Balıkesir",
        "client_code": "00226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BEYAZ-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS066315",
        "city_name": "Balıkesir",
        "client_code": "00226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BEYAZ-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY6SS066316",
        "city_name": "Balıkesir",
        "client_code": "00226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BEYAZ-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS064195",
        "city_name": "Balıkesir",
        "client_code": "00226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BEYAZ-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ2SS063803",
        "city_name": "Balıkesir",
        "client_code": "00226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BEYAZ-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ2SS067320",
        "city_name": "Balıkesir",
        "client_code": "00226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BEYAZ-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ3SS063650",
        "city_name": "Balıkesir",
        "client_code": "00226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BEYAZ-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ3SS069772",
        "city_name": "Balıkesir",
        "client_code": "00226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BEYAZ-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ7SS065546",
        "city_name": "Balıkesir",
        "client_code": "00226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:52\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "BEYAZ-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ652277",
        "city_name": "Balıkesir",
        "client_code": "00226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:53\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ657144",
        "city_name": "Balıkesir",
        "client_code": "00226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:57\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7ACYHZ7SL018362",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C5 AIRCROSS",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHPY6SE026783",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:00\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VR7BCZKW6SE013599",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:33\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE028529",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:04\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS8SE029481",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW2SE015759",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:37\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW4SE027329",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW8SE031402",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:08\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP3SN521906",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP6SN521902",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ3SJ620010",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ4SJ641741",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ6SJ620230",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ8SJ620228",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZXSJ619923",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZXSN527056",
        "city_name": "Balıkesir",
        "client_code": "01439",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX3S4090665",
        "city_name": "Balıkesir",
        "client_code": "TR8901",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX6S4090661",
        "city_name": "Balıkesir",
        "client_code": "TR8901",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX9S4091061",
        "city_name": "Balıkesir",
        "client_code": "TR8901",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4084002",
        "city_name": "Balıkesir",
        "client_code": "TR8901",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP0SJ655742",
        "city_name": "Balıkesir",
        "client_code": "TR8901",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:59\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHPXSJ652864",
        "city_name": "Balıkesir",
        "client_code": "TR8901",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ1SJ641334",
        "city_name": "Balıkesir",
        "client_code": "TR8901",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ641354",
        "city_name": "Balıkesir",
        "client_code": "TR8901",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "BEYAZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ-Balıkesir/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "CITROEN",
        "chassis_no": "VR7ACYHZSPL060185",
        "city_name": "Balıkesir",
        "client_code": "BEB-CIT-9999",
        "color": null,
        "customs_status": null,
        "dealer_name": "BEYAZ CITROEN",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "C5 AIRCROSS",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 2,
        "process_date": "2023-10-31",
        "shipping_info": "BEYAZ CITROEN-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "CITROEN",
        "chassis_no": "VR7ACYHZ4RL019138",
        "city_name": "Balıkesir",
        "client_code": "BEB-CIT-9999",
        "color": null,
        "customs_status": null,
        "dealer_name": "BEYAZ CITROEN",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "C5 AIRCROSS",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2024-05-24",
        "shipping_info": "BEYAZ CITROEN-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "CITROEN",
        "chassis_no": "VR7ACYHZXRL013084",
        "city_name": "Balıkesir",
        "client_code": "BEB-CIT-9999",
        "color": null,
        "customs_status": null,
        "dealer_name": "BEYAZ CITROEN",
        "distrit_name": "Altıeylül",
        "groupage_status": "NO_GROUPAGE",
        "model": "C5 AIRCROSS",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2024-03-26",
        "shipping_info": "BEYAZ CITROEN-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS2SY543299",
        "city_name": "Ankara",
        "client_code": "00000392",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "BEYAZ SİSTEM",
        "distrit_name": "Akyurt",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BEYAZ SİSTEM-Ankara/Akyurt",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS7SY540026",
        "city_name": "Ankara",
        "client_code": "00000392",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "BEYAZ SİSTEM",
        "distrit_name": "Akyurt",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ SİSTEM-Ankara/Akyurt",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNSXSY538965",
        "city_name": "Ankara",
        "client_code": "00000392",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "BEYAZ SİSTEM",
        "distrit_name": "Akyurt",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BEYAZ SİSTEM-Ankara/Akyurt",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ628227",
        "city_name": "Ankara",
        "client_code": "00000392",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "BEYAZ SİSTEM",
        "distrit_name": "Akyurt",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ SİSTEM-Ankara/Akyurt",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ636182",
        "city_name": "Ankara",
        "client_code": "00000392",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "BEYAZ SİSTEM",
        "distrit_name": "Akyurt",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BEYAZ SİSTEM-Ankara/Akyurt",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS1SE017950",
        "city_name": "Samsun",
        "client_code": "BİÇ-CIT-449",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 14:56:32\"}",
        "dealer_name": "BİEKSPER ÇARŞAMBA",
        "distrit_name": "Çarşamba",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "BİEKSPER ÇARŞAMBA-Samsun/Çarşamba",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE017952",
        "city_name": "Samsun",
        "client_code": "BİÇ-CIT-449",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 14:56:33\"}",
        "dealer_name": "BİEKSPER ÇARŞAMBA",
        "distrit_name": "Çarşamba",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "BİEKSPER ÇARŞAMBA-Samsun/Çarşamba",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4066050",
        "city_name": "Diyarbakır",
        "client_code": "BİD-OPE-396",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:37\"}",
        "dealer_name": "BİEKSPER DİYARBAKIR",
        "distrit_name": "Yenişehir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "BİEKSPER DİYARBAKIR-Diyarbakır/Yenişehir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS0SY538988",
        "city_name": "İstanbul",
        "client_code": "BİE-PEU-776",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "BİKA ESENYURT",
        "distrit_name": "Esenyurt",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BİKA ESENYURT-İstanbul/Esenyurt",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS1SY538983",
        "city_name": "İstanbul",
        "client_code": "BİE-PEU-776",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "BİKA ESENYURT",
        "distrit_name": "Esenyurt",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BİKA ESENYURT-İstanbul/Esenyurt",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS3SY540007",
        "city_name": "İstanbul",
        "client_code": "BİE-PEU-776",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "BİKA ESENYURT",
        "distrit_name": "Esenyurt",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BİKA ESENYURT-İstanbul/Esenyurt",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNSXSY538982",
        "city_name": "İstanbul",
        "client_code": "BİE-PEU-776",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "BİKA ESENYURT",
        "distrit_name": "Esenyurt",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BİKA ESENYURT-İstanbul/Esenyurt",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ624962",
        "city_name": "İstanbul",
        "client_code": "BİE-PEU-776",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:43\"}",
        "dealer_name": "BİKA ESENYURT",
        "distrit_name": "Esenyurt",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "BİKA ESENYURT-İstanbul/Esenyurt",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE032916",
        "city_name": "Sakarya",
        "client_code": "01405",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "BÜL",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BÜL-Sakarya/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKWXSE031353",
        "city_name": "Sakarya",
        "client_code": "01405",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "BÜL",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BÜL-Sakarya/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS8SY538995",
        "city_name": "Bursa",
        "client_code": "BUB-PEU-499",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "BURSA BİEKSPER",
        "distrit_name": "Osmangazi",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "BURSA BİEKSPER-Bursa/Osmangazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS8SY539001",
        "city_name": "Bursa",
        "client_code": "BUB-PEU-499",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "BURSA BİEKSPER",
        "distrit_name": "Osmangazi",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "BURSA BİEKSPER-Bursa/Osmangazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-22",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ630205",
        "city_name": "Uşak",
        "client_code": "00285",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:43\"}",
        "dealer_name": "ÇAĞDAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 2,
        "process_date": "2025-04-21",
        "shipping_info": "ÇAĞDAŞ-Uşak/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHT1SJ620813",
        "city_name": "Uşak",
        "client_code": "00285",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:47\"}",
        "dealer_name": "ÇAĞDAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "PARTNER VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ÇAĞDAŞ-Uşak/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS0SY538876",
        "city_name": "Uşak",
        "client_code": "00285",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "ÇAĞDAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇAĞDAŞ-Uşak/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ631137",
        "city_name": "Uşak",
        "client_code": "00285",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ÇAĞDAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇAĞDAŞ-Uşak/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS7SJ631084",
        "city_name": "Uşak",
        "client_code": "00285",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÇAĞDAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇAĞDAŞ-Uşak/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ631782",
        "city_name": "Uşak",
        "client_code": "00285",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ÇAĞDAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÇAĞDAŞ-Uşak/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7VLEHZ9SU284208",
        "city_name": "İstanbul",
        "client_code": "01446",
        "color": null,
        "customs_status": null,
        "dealer_name": "CAN",
        "distrit_name": "Ümraniye",
        "groupage_status": "NO_GROUPAGE",
        "model": "JUMPY VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-24",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "CAN-İstanbul/Ümraniye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS7SY538888",
        "city_name": "İstanbul",
        "client_code": "00140",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "CAN",
        "distrit_name": "Ümraniye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "CAN-İstanbul/Ümraniye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS037567",
        "city_name": "İstanbul",
        "client_code": "00140",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "CAN",
        "distrit_name": "Ümraniye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "CAN-İstanbul/Ümraniye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ627962",
        "city_name": "İstanbul",
        "client_code": "00140",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "CAN",
        "distrit_name": "Ümraniye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "CAN-İstanbul/Ümraniye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ630121",
        "city_name": "İstanbul",
        "client_code": "00140",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "CAN",
        "distrit_name": "Ümraniye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "CAN-İstanbul/Ümraniye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS8SE033448",
        "city_name": "İstanbul",
        "client_code": "01446",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "CAN",
        "distrit_name": "Ümraniye",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "CAN-İstanbul/Ümraniye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS8SE035863",
        "city_name": "İstanbul",
        "client_code": "01446",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "CAN",
        "distrit_name": "Ümraniye",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "CAN-İstanbul/Ümraniye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE034107",
        "city_name": "İstanbul",
        "client_code": "01446",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "CAN",
        "distrit_name": "Ümraniye",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "CAN-İstanbul/Ümraniye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW2SE034568",
        "city_name": "İstanbul",
        "client_code": "01446",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:08\"}",
        "dealer_name": "CAN",
        "distrit_name": "Ümraniye",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "CAN-İstanbul/Ümraniye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW4SE025922",
        "city_name": "İstanbul",
        "client_code": "01446",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "CAN",
        "distrit_name": "Ümraniye",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "CAN-İstanbul/Ümraniye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW4SE032871",
        "city_name": "İstanbul",
        "client_code": "01446",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:08\"}",
        "dealer_name": "CAN",
        "distrit_name": "Ümraniye",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "CAN-İstanbul/Ümraniye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP4RJ053282",
        "city_name": "İstanbul",
        "client_code": "01446",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "CAN",
        "distrit_name": "Ümraniye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "CAN-İstanbul/Ümraniye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ4SJ577863",
        "city_name": "İstanbul",
        "client_code": "01446",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 10:32:10\"}",
        "dealer_name": "CAN",
        "distrit_name": "Ümraniye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "CAN-İstanbul/Ümraniye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE027073",
        "city_name": "Mersin",
        "client_code": "01425",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:57\"}",
        "dealer_name": "ÇAYAN",
        "distrit_name": "Toroslar",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ÇAYAN-Mersin/Toroslar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXEVJYHV1SU288186",
        "city_name": "İstanbul",
        "client_code": "TR8653",
        "color": null,
        "customs_status": null,
        "dealer_name": "ÇETAŞ BAYRAMPAŞA",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ÇETAŞ BAYRAMPAŞA-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW2SE029015",
        "city_name": "İstanbul",
        "client_code": "01472",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "ÇETAŞ BAYRAMPAŞA",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BAYRAMPAŞA-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW4SE030909",
        "city_name": "İstanbul",
        "client_code": "01472",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "ÇETAŞ BAYRAMPAŞA",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BAYRAMPAŞA-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW6SE033410",
        "city_name": "İstanbul",
        "client_code": "01472",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:08\"}",
        "dealer_name": "ÇETAŞ BAYRAMPAŞA",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BAYRAMPAŞA-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW6SE034055",
        "city_name": "İstanbul",
        "client_code": "01472",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:08\"}",
        "dealer_name": "ÇETAŞ BAYRAMPAŞA",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BAYRAMPAŞA-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ2SJ645996",
        "city_name": "İstanbul",
        "client_code": "01472",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "ÇETAŞ BAYRAMPAŞA",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BAYRAMPAŞA-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ6SJ641773",
        "city_name": "İstanbul",
        "client_code": "01472",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "ÇETAŞ BAYRAMPAŞA",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BAYRAMPAŞA-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4044226",
        "city_name": "İstanbul",
        "client_code": "TR8653",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:37\"}",
        "dealer_name": "ÇETAŞ BAYRAMPAŞA",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÇETAŞ BAYRAMPAŞA-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY6SS037592",
        "city_name": "İstanbul",
        "client_code": "00262",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-25",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VF3VKEHZ5SZ013671",
        "city_name": "İstanbul",
        "client_code": "00262",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:36\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "TRAVELLER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VF3YDG8FXSG016974",
        "city_name": "İstanbul",
        "client_code": "00262",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BOXER ",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS1SY538997",
        "city_name": "İstanbul",
        "client_code": "00262",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS5SY538792",
        "city_name": "İstanbul",
        "client_code": "00262",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS065592",
        "city_name": "İstanbul",
        "client_code": "00262",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS064963",
        "city_name": "İstanbul",
        "client_code": "00262",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS038940",
        "city_name": "İstanbul",
        "client_code": "00262",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ9SS063796",
        "city_name": "İstanbul",
        "client_code": "00262",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZXSS069381",
        "city_name": "İstanbul",
        "client_code": "00262",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ633755",
        "city_name": "İstanbul",
        "client_code": "00262",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ621858",
        "city_name": "İstanbul",
        "client_code": "00262",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:43\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS0SE033467",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS2SE027461",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS2SE028335",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS6SE033635",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHPY8SE033184",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:00\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS0SE034271",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:01\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS0SE035257",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:01\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS0SE035291",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:01\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS1SE033338",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:01\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS1SE035431",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:02\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS2SE035258",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:02\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS2SE035289",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:02\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS2SE035292",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:02\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS3SE034121",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS4SE034239",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE035917",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:04\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE026756",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:04\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE035263",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE035277",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE027088",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE029410",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE033425",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE035272",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE035434",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS8SE028590",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS8SE034552",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE032938",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE033393",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE034172",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE035242",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE035256",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE025979",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE026713",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE034259",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE034617",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW1SE032262",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW6SE034461",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:08\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW7SE033383",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:08\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW9SE028010",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ0SJ620241",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ1SJ620202",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ4SJ620226",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ5SJ619893",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ6SJ619949",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ7SJ620320",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZXSJ618447",
        "city_name": "İstanbul",
        "client_code": "01460",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHT4S7813523",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHT6S7812888",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX3S4090651",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX6S4091065",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKXXS4090646",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4073609",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4073819",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4073586",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:37\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4082448",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4084385",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4084502",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4073587",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4066373",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4084310",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4084386",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:56\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4084311",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4084387",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4084388",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4092166",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS4SW028188",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ1SJ652589",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ2SJ648048",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SJ616341",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SJ620714",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ6SN525913",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SN524690",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SJ649830",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSJ642093",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEMZKU3S8501103",
        "city_name": "İstanbul",
        "client_code": "TR8652",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-13 11:22:03\"}",
        "dealer_name": "ÇETAŞ BÜYÜKÇEKMECE",
        "distrit_name": "Büyükçekmece",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ BÜYÜKÇEKMECE-İstanbul/Büyükçekmece",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY0SS037572",
        "city_name": "Tekirdağ",
        "client_code": "00263",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ÇETAŞ ÇORLU",
        "distrit_name": "Çorlu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-25",
        "shipping_info": "ÇETAŞ ÇORLU-Tekirdağ/Çorlu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS064143",
        "city_name": "Tekirdağ",
        "client_code": "00263",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ÇETAŞ ÇORLU",
        "distrit_name": "Çorlu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ÇETAŞ ÇORLU-Tekirdağ/Çorlu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHZ7SU287233",
        "city_name": "Tekirdağ",
        "client_code": "TR0066",
        "color": null,
        "customs_status": null,
        "dealer_name": "ÇETAŞ ÇORLU",
        "distrit_name": "Çorlu",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ÇETAŞ ÇORLU-Tekirdağ/Çorlu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS8SE033510",
        "city_name": "Tekirdağ",
        "client_code": "01461",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "ÇETAŞ ÇORLU",
        "distrit_name": "Çorlu",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ ÇORLU-Tekirdağ/Çorlu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS9SE026338",
        "city_name": "Tekirdağ",
        "client_code": "01461",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "ÇETAŞ ÇORLU",
        "distrit_name": "Çorlu",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ ÇORLU-Tekirdağ/Çorlu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNSXSE028292",
        "city_name": "Tekirdağ",
        "client_code": "01461",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "ÇETAŞ ÇORLU",
        "distrit_name": "Çorlu",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ ÇORLU-Tekirdağ/Çorlu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BCZKW4SE013598",
        "city_name": "Tekirdağ",
        "client_code": "01461",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:33\"}",
        "dealer_name": "ÇETAŞ ÇORLU",
        "distrit_name": "Çorlu",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ ÇORLU-Tekirdağ/Çorlu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS2SE028536",
        "city_name": "Tekirdağ",
        "client_code": "01461",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:57\"}",
        "dealer_name": "ÇETAŞ ÇORLU",
        "distrit_name": "Çorlu",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ ÇORLU-Tekirdağ/Çorlu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE034218",
        "city_name": "Tekirdağ",
        "client_code": "01461",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "ÇETAŞ ÇORLU",
        "distrit_name": "Çorlu",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ ÇORLU-Tekirdağ/Çorlu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ5SJ619960",
        "city_name": "Tekirdağ",
        "client_code": "01461",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "ÇETAŞ ÇORLU",
        "distrit_name": "Çorlu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ ÇORLU-Tekirdağ/Çorlu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ7SJ620270",
        "city_name": "Tekirdağ",
        "client_code": "01461",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "ÇETAŞ ÇORLU",
        "distrit_name": "Çorlu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ ÇORLU-Tekirdağ/Çorlu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ8SJ619936",
        "city_name": "Tekirdağ",
        "client_code": "01461",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "ÇETAŞ ÇORLU",
        "distrit_name": "Çorlu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ ÇORLU-Tekirdağ/Çorlu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ9SJ619928",
        "city_name": "Tekirdağ",
        "client_code": "01461",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "ÇETAŞ ÇORLU",
        "distrit_name": "Çorlu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ ÇORLU-Tekirdağ/Çorlu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS1SW027628",
        "city_name": "Tekirdağ",
        "client_code": "TR0066",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "ÇETAŞ ÇORLU",
        "distrit_name": "Çorlu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ ÇORLU-Tekirdağ/Çorlu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS8SW026203",
        "city_name": "Tekirdağ",
        "client_code": "TR0066",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "ÇETAŞ ÇORLU",
        "distrit_name": "Çorlu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÇETAŞ ÇORLU-Tekirdağ/Çorlu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS9SW028493",
        "city_name": "Tekirdağ",
        "client_code": "TR0066",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "ÇETAŞ ÇORLU",
        "distrit_name": "Çorlu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇETAŞ ÇORLU-Tekirdağ/Çorlu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ0SJ620286",
        "city_name": "Kocaeli",
        "client_code": "01470",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "ÇETAŞ İZMİT",
        "distrit_name": "İzmit",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ İZMİT-Kocaeli/İzmit",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ7SJ619958",
        "city_name": "Kocaeli",
        "client_code": "01470",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "ÇETAŞ İZMİT",
        "distrit_name": "İzmit",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇETAŞ İZMİT-Kocaeli/İzmit",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4073603",
        "city_name": "Ordu",
        "client_code": "CET-OPE-651",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "CEYHUN TURİZM GÜLYALI",
        "distrit_name": "Gülyalı",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "CEYHUN TURİZM GÜLYALI-Ordu/Gülyalı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4044773",
        "city_name": "Antalya",
        "client_code": "ÇİA-OPE-925",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "ÇİZGİ ANTALYA",
        "distrit_name": "Aksu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ ANTALYA-Antalya/Aksu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4043947",
        "city_name": "Antalya",
        "client_code": "ÇİA-OPE-925",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "ÇİZGİ ANTALYA",
        "distrit_name": "Aksu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ ANTALYA-Antalya/Aksu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4043424",
        "city_name": "Antalya",
        "client_code": "ÇİA-OPE-925",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "ÇİZGİ ANTALYA",
        "distrit_name": "Aksu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ ANTALYA-Antalya/Aksu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4043769",
        "city_name": "Antalya",
        "client_code": "ÇİA-OPE-925",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "ÇİZGİ ANTALYA",
        "distrit_name": "Aksu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ ANTALYA-Antalya/Aksu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4043948",
        "city_name": "Antalya",
        "client_code": "ÇİA-OPE-925",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "ÇİZGİ ANTALYA",
        "distrit_name": "Aksu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ ANTALYA-Antalya/Aksu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4043750",
        "city_name": "Antalya",
        "client_code": "ÇİA-OPE-925",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "ÇİZGİ ANTALYA",
        "distrit_name": "Aksu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ ANTALYA-Antalya/Aksu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4043434",
        "city_name": "Antalya",
        "client_code": "ÇİA-OPE-925",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "ÇİZGİ ANTALYA",
        "distrit_name": "Aksu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ ANTALYA-Antalya/Aksu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4044769",
        "city_name": "Antalya",
        "client_code": "ÇİA-OPE-925",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "ÇİZGİ ANTALYA",
        "distrit_name": "Aksu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ ANTALYA-Antalya/Aksu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4043436",
        "city_name": "Antalya",
        "client_code": "ÇİA-OPE-925",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "ÇİZGİ ANTALYA",
        "distrit_name": "Aksu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ ANTALYA-Antalya/Aksu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ629943",
        "city_name": "İstanbul",
        "client_code": "ÇİA-PEU-140",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÇİZGİ ARNAVUTKÖY",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇİZGİ ARNAVUTKÖY-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ630378",
        "city_name": "İstanbul",
        "client_code": "ÇİA-PEU-140",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÇİZGİ ARNAVUTKÖY",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇİZGİ ARNAVUTKÖY-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4044992",
        "city_name": "İstanbul",
        "client_code": "ÇİA-OPE-226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "ÇİZGİ ARNAVUTKÖY",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ ARNAVUTKÖY-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4043407",
        "city_name": "İstanbul",
        "client_code": "ÇİA-OPE-226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "ÇİZGİ ARNAVUTKÖY",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ ARNAVUTKÖY-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4044947",
        "city_name": "İstanbul",
        "client_code": "ÇİA-OPE-226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "ÇİZGİ ARNAVUTKÖY",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ ARNAVUTKÖY-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4044950",
        "city_name": "İstanbul",
        "client_code": "ÇİA-OPE-226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "ÇİZGİ ARNAVUTKÖY",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ ARNAVUTKÖY-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4043427",
        "city_name": "İstanbul",
        "client_code": "ÇİA-OPE-226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "ÇİZGİ ARNAVUTKÖY",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ ARNAVUTKÖY-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4044965",
        "city_name": "İstanbul",
        "client_code": "ÇİA-OPE-226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "ÇİZGİ ARNAVUTKÖY",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ ARNAVUTKÖY-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4043758",
        "city_name": "İstanbul",
        "client_code": "ÇİA-OPE-226",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "ÇİZGİ ARNAVUTKÖY",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ ARNAVUTKÖY-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS0SE027143",
        "city_name": "Muğla",
        "client_code": "ÇİD-CIT-492",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:39\"}",
        "dealer_name": "ÇİZGİ DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÇİZGİ DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE026730",
        "city_name": "Muğla",
        "client_code": "ÇİD-CIT-492",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "ÇİZGİ DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÇİZGİ DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4046278",
        "city_name": "İzmir",
        "client_code": "ÇİG-OPE-673",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "ÇİZGİ GAZİEMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ GAZİEMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4073605",
        "city_name": "İzmir",
        "client_code": "ÇİG-OPE-673",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "ÇİZGİ GAZİEMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ GAZİEMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4046292",
        "city_name": "İzmir",
        "client_code": "ÇİG-OPE-673",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "ÇİZGİ GAZİEMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ GAZİEMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4073606",
        "city_name": "İzmir",
        "client_code": "ÇİG-OPE-673",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "ÇİZGİ GAZİEMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ GAZİEMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4046284",
        "city_name": "İzmir",
        "client_code": "ÇİG-OPE-673",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "ÇİZGİ GAZİEMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ GAZİEMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4044978",
        "city_name": "İzmir",
        "client_code": "ÇİG-OPE-673",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "ÇİZGİ GAZİEMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ GAZİEMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4073610",
        "city_name": "İzmir",
        "client_code": "ÇİG-OPE-673",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "ÇİZGİ GAZİEMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ GAZİEMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4044991",
        "city_name": "İzmir",
        "client_code": "ÇİG-OPE-673",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "ÇİZGİ GAZİEMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÇİZGİ GAZİEMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ625658",
        "city_name": "Trabzon",
        "client_code": "ÇİK-PEU-708",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ÇİZGİ KONAKLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇİZGİ KONAKLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ625661",
        "city_name": "Trabzon",
        "client_code": "ÇİK-PEU-708",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ÇİZGİ KONAKLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇİZGİ KONAKLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ625516",
        "city_name": "Trabzon",
        "client_code": "ÇİK-PEU-708",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ÇİZGİ KONAKLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇİZGİ KONAKLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ625659",
        "city_name": "Trabzon",
        "client_code": "ÇİK-PEU-708",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ÇİZGİ KONAKLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇİZGİ KONAKLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS3SJ625511",
        "city_name": "Trabzon",
        "client_code": "ÇİK-PEU-708",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ÇİZGİ KONAKLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇİZGİ KONAKLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS3SJ625654",
        "city_name": "Trabzon",
        "client_code": "ÇİK-PEU-708",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ÇİZGİ KONAKLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇİZGİ KONAKLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ630376",
        "city_name": "Trabzon",
        "client_code": "ÇİK-PEU-708",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÇİZGİ KONAKLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇİZGİ KONAKLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ625509",
        "city_name": "Trabzon",
        "client_code": "ÇİK-PEU-708",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÇİZGİ KONAKLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇİZGİ KONAKLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ625655",
        "city_name": "Trabzon",
        "client_code": "ÇİK-PEU-708",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÇİZGİ KONAKLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇİZGİ KONAKLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ629942",
        "city_name": "Trabzon",
        "client_code": "ÇİK-PEU-708",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÇİZGİ KONAKLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇİZGİ KONAKLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS7SJ625656",
        "city_name": "Trabzon",
        "client_code": "ÇİK-PEU-708",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÇİZGİ KONAKLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇİZGİ KONAKLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ625657",
        "city_name": "Trabzon",
        "client_code": "ÇİK-PEU-708",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ÇİZGİ KONAKLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇİZGİ KONAKLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ628051",
        "city_name": "Trabzon",
        "client_code": "ÇİK-PEU-708",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ÇİZGİ KONAKLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÇİZGİ KONAKLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS7SE026337",
        "city_name": "Denizli",
        "client_code": "01407",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "COŞKUNLAR DENİZLİ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "COŞKUNLAR DENİZLİ-Denizli/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS8SE027481",
        "city_name": "Denizli",
        "client_code": "01407",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "COŞKUNLAR DENİZLİ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "COŞKUNLAR DENİZLİ-Denizli/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP5RJ053288",
        "city_name": "Denizli",
        "client_code": "01407",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "COŞKUNLAR DENİZLİ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "COŞKUNLAR DENİZLİ-Denizli/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ3SJ641598",
        "city_name": "Denizli",
        "client_code": "01407",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "COŞKUNLAR DENİZLİ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "COŞKUNLAR DENİZLİ-Denizli/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNSXSE033573",
        "city_name": "Muğla",
        "client_code": "01426",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "COŞKUNLAR FETHİYE",
        "distrit_name": "Fethiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "COŞKUNLAR FETHİYE-Muğla/Fethiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE026699",
        "city_name": "Samsun",
        "client_code": "01448",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "DEMİR",
        "distrit_name": "Tekkeköy",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "DEMİR-Samsun/Tekkeköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS037855",
        "city_name": "Samsun",
        "client_code": "00295",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "DEMİR",
        "distrit_name": "Tekkeköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "DEMİR-Samsun/Tekkeköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS037705",
        "city_name": "Samsun",
        "client_code": "00295",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "DEMİR",
        "distrit_name": "Tekkeköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "DEMİR-Samsun/Tekkeköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ631074",
        "city_name": "Samsun",
        "client_code": "00295",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "DEMİR",
        "distrit_name": "Tekkeköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "DEMİR-Samsun/Tekkeköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ633961",
        "city_name": "Samsun",
        "client_code": "00295",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "DEMİR",
        "distrit_name": "Tekkeköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "DEMİR-Samsun/Tekkeköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE027173",
        "city_name": "Samsun",
        "client_code": "01448",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "DEMİR",
        "distrit_name": "Tekkeköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "DEMİR-Samsun/Tekkeköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE028520",
        "city_name": "Samsun",
        "client_code": "01448",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "DEMİR",
        "distrit_name": "Tekkeköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "DEMİR-Samsun/Tekkeköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKWXSE031434",
        "city_name": "Samsun",
        "client_code": "01448",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "DEMİR",
        "distrit_name": "Tekkeköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "DEMİR-Samsun/Tekkeköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4070645",
        "city_name": "Samsun",
        "client_code": "TR8970",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "DEMİR",
        "distrit_name": "Tekkeköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "DEMİR-Samsun/Tekkeköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4070539",
        "city_name": "Samsun",
        "client_code": "TR8970",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "DEMİR",
        "distrit_name": "Tekkeköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "DEMİR-Samsun/Tekkeköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS2SW027301",
        "city_name": "Samsun",
        "client_code": "TR8970",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "DEMİR",
        "distrit_name": "Tekkeköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "DEMİR-Samsun/Tekkeköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHZ4SJ618722",
        "city_name": "İstanbul",
        "client_code": "00297",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "DENİZ",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-29",
        "shipping_info": "DENİZ-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHZ5SJ590235",
        "city_name": "İstanbul",
        "client_code": "00297",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 14:56:29\"}",
        "dealer_name": "DENİZ",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-29",
        "shipping_info": "DENİZ-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY528853",
        "city_name": "İstanbul",
        "client_code": "00297",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:14\"}",
        "dealer_name": "DENİZ",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-29",
        "shipping_info": "DENİZ-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS3SJ622009",
        "city_name": "İstanbul",
        "client_code": "00297",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:08\"}",
        "dealer_name": "DENİZ",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-29",
        "shipping_info": "DENİZ-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ576263",
        "city_name": "İstanbul",
        "client_code": "00297",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:03\"}",
        "dealer_name": "DENİZ",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-29",
        "shipping_info": "DENİZ-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ580100",
        "city_name": "İstanbul",
        "client_code": "00297",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:03\"}",
        "dealer_name": "DENİZ",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-29",
        "shipping_info": "DENİZ-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ594094",
        "city_name": "İstanbul",
        "client_code": "00297",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 14:56:32\"}",
        "dealer_name": "DENİZ",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-29",
        "shipping_info": "DENİZ-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4074287",
        "city_name": "İstanbul",
        "client_code": "TR0067",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "DENİZ",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "DENİZ-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP2SN518318",
        "city_name": "İstanbul",
        "client_code": "00297",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "DENİZ",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "DENİZ-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHZ9SJ590660",
        "city_name": "İstanbul",
        "client_code": "00297",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 14:56:29\"}",
        "dealer_name": "DENİZ",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "DENİZ-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE027108",
        "city_name": "İstanbul",
        "client_code": "01494",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:39\"}",
        "dealer_name": "DENİZ",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "DENİZ-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ0SJ617744",
        "city_name": "İstanbul",
        "client_code": "01494",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "DENİZ",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "DENİZ-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ4SJ619934",
        "city_name": "İstanbul",
        "client_code": "01494",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "DENİZ",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "DENİZ-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ5SJ617738",
        "city_name": "İstanbul",
        "client_code": "01494",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "DENİZ",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "DENİZ-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS2SE026754",
        "city_name": "İstanbul",
        "client_code": "DEC-CIT-877",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:57\"}",
        "dealer_name": "DERMA COS",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "DERMA COS-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE027090",
        "city_name": "İstanbul",
        "client_code": "DEC-CIT-877",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:57\"}",
        "dealer_name": "DERMA COS",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "DERMA COS-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS8SE027181",
        "city_name": "İstanbul",
        "client_code": "DEC-CIT-877",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "DERMA COS",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "DERMA COS-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ6SJ624018",
        "city_name": "Van",
        "client_code": "01481",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "DOĞU",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "DOĞU-Van/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS6SW019833",
        "city_name": "Van",
        "client_code": "TR3400",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-08 16:16:57\"}",
        "dealer_name": "DOĞU",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "DOĞU-Van/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS3SW028814",
        "city_name": "İzmir",
        "client_code": "TR8960",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ616342",
        "city_name": "İzmir",
        "client_code": "TR8960",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS7SW028623",
        "city_name": "İzmir",
        "client_code": "TR8960",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VF7VLEHZ5S7804256",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-20 11:54:53\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPY VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY538752",
        "city_name": "İzmir",
        "client_code": "00280",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS6SY536257",
        "city_name": "İzmir",
        "client_code": "00280",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS031752",
        "city_name": "İzmir",
        "client_code": "00280",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS031381",
        "city_name": "İzmir",
        "client_code": "00280",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS037837",
        "city_name": "İzmir",
        "client_code": "00280",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ4SS066119",
        "city_name": "İzmir",
        "client_code": "00280",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ5SS067151",
        "city_name": "İzmir",
        "client_code": "00280",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ611517",
        "city_name": "İzmir",
        "client_code": "00280",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:14\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ615558",
        "city_name": "İzmir",
        "client_code": "00280",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:07\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ631154",
        "city_name": "İzmir",
        "client_code": "00280",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ631763",
        "city_name": "İzmir",
        "client_code": "00280",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ634260",
        "city_name": "İzmir",
        "client_code": "00280",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS0SE028334",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS1SE033509",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS1SE033512",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS2SE033499",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS5SE028278",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS7SE033465",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BCZKW7SE013675",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:33\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS0SE034285",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:01\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS2SE026706",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:02\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS3SE032949",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE028538",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE029472",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE027179",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:39\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE034214",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW3SE029119",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW6SE031432",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:08\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKWXSE034088",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP2SJ638268",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP7SJ653106",
        "city_name": "İzmir",
        "client_code": "01476",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHZ6SU286056",
        "city_name": "İzmir",
        "client_code": "TR8960",
        "color": null,
        "customs_status": null,
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-32",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX2S4091046",
        "city_name": "İzmir",
        "client_code": "TR8960",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4071478",
        "city_name": "İzmir",
        "client_code": "TR8960",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4044221",
        "city_name": "İzmir",
        "client_code": "TR8960",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4046276",
        "city_name": "İzmir",
        "client_code": "TR8960",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4069671",
        "city_name": "İzmir",
        "client_code": "TR8960",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS0SW026017",
        "city_name": "İzmir",
        "client_code": "TR8960",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS1SW025796",
        "city_name": "İzmir",
        "client_code": "TR8960",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS9SW025139",
        "city_name": "İzmir",
        "client_code": "TR8960",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNSXSW028681",
        "city_name": "İzmir",
        "client_code": "TR8960",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP4SJ630830",
        "city_name": "İzmir",
        "client_code": "TR8960",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP9SJ630760",
        "city_name": "İzmir",
        "client_code": "TR8960",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:13\"}",
        "dealer_name": "EGEM",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EGEM-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS7SJ621834",
        "city_name": "İstanbul",
        "client_code": "00000462",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:42\"}",
        "dealer_name": "EKİM TURİZM",
        "distrit_name": "Ataşehir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EKİM TURİZM-İstanbul/Ataşehir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ631662",
        "city_name": "Sakarya",
        "client_code": "00250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Arifiye",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "EKİN-Sakarya/Arifiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXEVJYHV9SU288209",
        "city_name": "Sakarya",
        "client_code": "TR2200",
        "color": null,
        "customs_status": null,
        "dealer_name": "EKİN",
        "distrit_name": "Adapazarı",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "EKİN-Sakarya/Adapazarı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHT4S7813991",
        "city_name": "Sakarya",
        "client_code": "TR2200",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Adapazarı",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "EKİN-Sakarya/Adapazarı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP2SN526452",
        "city_name": "Sakarya",
        "client_code": "00250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:50\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Arifiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EKİN-Sakarya/Arifiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHZ9SJ641915",
        "city_name": "Sakarya",
        "client_code": "00250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:51\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Arifiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "PARTNER VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EKİN-Sakarya/Arifiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS1SY543391",
        "city_name": "Sakarya",
        "client_code": "00250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Arifiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EKİN-Sakarya/Arifiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY536323",
        "city_name": "Sakarya",
        "client_code": "00250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Arifiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EKİN-Sakarya/Arifiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY538783",
        "city_name": "Sakarya",
        "client_code": "00250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Arifiye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "EKİN-Sakarya/Arifiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS037743",
        "city_name": "Sakarya",
        "client_code": "00250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Arifiye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "EKİN-Sakarya/Arifiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS037413",
        "city_name": "Sakarya",
        "client_code": "00250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Arifiye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EKİN-Sakarya/Arifiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS065096",
        "city_name": "Sakarya",
        "client_code": "00250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:49\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Arifiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EKİN-Sakarya/Arifiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS064924",
        "city_name": "Sakarya",
        "client_code": "00250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Arifiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EKİN-Sakarya/Arifiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS066396",
        "city_name": "Sakarya",
        "client_code": "00250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Arifiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EKİN-Sakarya/Arifiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY9SS037859",
        "city_name": "Sakarya",
        "client_code": "00250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Arifiye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "EKİN-Sakarya/Arifiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ1SS064098",
        "city_name": "Sakarya",
        "client_code": "00250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Arifiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EKİN-Sakarya/Arifiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ7SS069032",
        "city_name": "Sakarya",
        "client_code": "00250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Arifiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EKİN-Sakarya/Arifiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZXSS063807",
        "city_name": "Sakarya",
        "client_code": "00250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Arifiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EKİN-Sakarya/Arifiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3UKZKW5SJ610635",
        "city_name": "Sakarya",
        "client_code": "00250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:52\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Arifiye",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EKİN-Sakarya/Arifiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX3S4090679",
        "city_name": "Sakarya",
        "client_code": "TR2200",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Adapazarı",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EKİN-Sakarya/Adapazarı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS4SW026800",
        "city_name": "Sakarya",
        "client_code": "TR2200",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Adapazarı",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "EKİN-Sakarya/Adapazarı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SJ642101",
        "city_name": "Sakarya",
        "client_code": "TR2200",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Adapazarı",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EKİN-Sakarya/Adapazarı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SJ648027",
        "city_name": "Sakarya",
        "client_code": "TR2200",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Adapazarı",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EKİN-Sakarya/Adapazarı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ655156",
        "city_name": "Sakarya",
        "client_code": "TR2200",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "EKİN",
        "distrit_name": "Adapazarı",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "EKİN-Sakarya/Adapazarı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS025599",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:01\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS028034",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:01\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS028924",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-28 10:42:16\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS029622",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-28 10:42:16\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS032780",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-18 09:50:38\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS025577",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:01\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS029015",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-28 10:42:16\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS029631",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:01\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS031895",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-18 09:50:38\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS032772",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-18 09:50:38\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ627776",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ628216",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:42\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ636154",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ636168",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:42\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ636171",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:42\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ636185",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:42\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ637000",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ628225",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ630010",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ636177",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ636180",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:42\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ636681",
        "city_name": "İzmir",
        "client_code": "ENA-PEU-217",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ENTERPRISE ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS029016",
        "city_name": "Antalya",
        "client_code": "ENA-PEU-792",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-28 10:42:16\"}",
        "dealer_name": "ENTERPRISE ANTALYA HVL",
        "distrit_name": "Muratpaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ANTALYA HVL-Antalya/Muratpaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS031204",
        "city_name": "Antalya",
        "client_code": "ENA-PEU-792",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-18 09:50:38\"}",
        "dealer_name": "ENTERPRISE ANTALYA HVL",
        "distrit_name": "Muratpaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ANTALYA HVL-Antalya/Muratpaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ630333",
        "city_name": "Antalya",
        "client_code": "ENA-PEU-792",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ENTERPRISE ANTALYA HVL",
        "distrit_name": "Muratpaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ANTALYA HVL-Antalya/Muratpaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ636173",
        "city_name": "Antalya",
        "client_code": "ENA-PEU-792",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:43\"}",
        "dealer_name": "ENTERPRISE ANTALYA HVL",
        "distrit_name": "Muratpaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ANTALYA HVL-Antalya/Muratpaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ636187",
        "city_name": "Antalya",
        "client_code": "ENA-PEU-792",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ENTERPRISE ANTALYA HVL",
        "distrit_name": "Muratpaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ANTALYA HVL-Antalya/Muratpaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ636190",
        "city_name": "Antalya",
        "client_code": "ENA-PEU-792",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ENTERPRISE ANTALYA HVL",
        "distrit_name": "Muratpaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ANTALYA HVL-Antalya/Muratpaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ636688",
        "city_name": "Antalya",
        "client_code": "ENA-PEU-792",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ENTERPRISE ANTALYA HVL",
        "distrit_name": "Muratpaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ANTALYA HVL-Antalya/Muratpaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ637002",
        "city_name": "Antalya",
        "client_code": "ENA-PEU-792",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ENTERPRISE ANTALYA HVL",
        "distrit_name": "Muratpaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE ANTALYA HVL-Antalya/Muratpaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ652069",
        "city_name": "Muğla",
        "client_code": "END-PEU-415",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:55\"}",
        "dealer_name": "ENTERPRISE DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ653383",
        "city_name": "Muğla",
        "client_code": "END-PEU-415",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:55\"}",
        "dealer_name": "ENTERPRISE DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-04",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ593892",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 14:56:31\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ636174",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ636689",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ650723",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:52\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ628228",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ636166",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ636183",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ636197",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ636202",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ636684",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ650715",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:53\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ653338",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:53\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ653386",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:53\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ653498",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:53\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ628223",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ636175",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ636189",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ636192",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ637004",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-502",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ENTERPRİSE İGA",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE İGA-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ637006",
        "city_name": "Muğla",
        "client_code": "ENM-PEU-123",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ENTERPRISE MİLAS HVL",
        "distrit_name": "Milas",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE MİLAS HVL-Muğla/Milas",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS029613",
        "city_name": "İstanbul",
        "client_code": "ENS-PEU-441",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:01\"}",
        "dealer_name": "ENTERPRİSE SABİHA HVL",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE SABİHA HVL-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS030115",
        "city_name": "İstanbul",
        "client_code": "ENS-PEU-441",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:01\"}",
        "dealer_name": "ENTERPRİSE SABİHA HVL",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE SABİHA HVL-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS030132",
        "city_name": "İstanbul",
        "client_code": "ENS-PEU-441",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-18 09:50:38\"}",
        "dealer_name": "ENTERPRİSE SABİHA HVL",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE SABİHA HVL-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS032527",
        "city_name": "İstanbul",
        "client_code": "ENS-PEU-441",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-28 10:42:16\"}",
        "dealer_name": "ENTERPRİSE SABİHA HVL",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE SABİHA HVL-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS3SJ636153",
        "city_name": "İstanbul",
        "client_code": "ENS-PEU-441",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ENTERPRİSE SABİHA HVL",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE SABİHA HVL-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS3SJ636198",
        "city_name": "İstanbul",
        "client_code": "ENS-PEU-441",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ENTERPRİSE SABİHA HVL",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE SABİHA HVL-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ627767",
        "city_name": "İstanbul",
        "client_code": "ENS-PEU-441",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ENTERPRİSE SABİHA HVL",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE SABİHA HVL-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ636680",
        "city_name": "İstanbul",
        "client_code": "ENS-PEU-441",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ENTERPRİSE SABİHA HVL",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRİSE SABİHA HVL-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS029626",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-803",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-18 09:50:38\"}",
        "dealer_name": "ENTERPRISE TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS030128",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-803",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:00\"}",
        "dealer_name": "ENTERPRISE TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS031909",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-803",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:30\"}",
        "dealer_name": "ENTERPRISE TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS032770",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-803",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-18 09:50:38\"}",
        "dealer_name": "ENTERPRISE TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS028906",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-803",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-18 09:50:38\"}",
        "dealer_name": "ENTERPRISE TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS029005",
        "city_name": "İstanbul",
        "client_code": "ENT-PEU-803",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-28 10:42:16\"}",
        "dealer_name": "ENTERPRISE TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS7SJ636687",
        "city_name": "Trabzon",
        "client_code": "ENT-PEU-642",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ENTERPRISE TRABZON HVL",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE TRABZON HVL-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS7SJ637001",
        "city_name": "Trabzon",
        "client_code": "ENT-PEU-642",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ENTERPRISE TRABZON HVL",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ENTERPRISE TRABZON HVL-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS5SY538789",
        "city_name": "Elazığ",
        "client_code": "00232",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "ERCAN",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ERCAN-Elazığ/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS8SY538852",
        "city_name": "Elazığ",
        "client_code": "00232",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ERCAN",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ERCAN-Elazığ/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS037718",
        "city_name": "Elazığ",
        "client_code": "00232",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ERCAN",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERCAN-Elazığ/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ1SJ620300",
        "city_name": "Elazığ",
        "client_code": "01473",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "ERCAN",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERCAN-Elazığ/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX5S4090697",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4043768",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP7SJ655723",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SJ642108",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SJ641338",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY6SS065098",
        "city_name": "İstanbul",
        "client_code": "00281",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ5SS069563",
        "city_name": "İstanbul",
        "client_code": "00281",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ630389",
        "city_name": "İstanbul",
        "client_code": "00281",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS3SJ621779",
        "city_name": "İstanbul",
        "client_code": "00281",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ633911",
        "city_name": "İstanbul",
        "client_code": "00281",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ627951",
        "city_name": "İstanbul",
        "client_code": "00281",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ621780",
        "city_name": "İstanbul",
        "client_code": "00281",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ621830",
        "city_name": "İstanbul",
        "client_code": "00281",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:43\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ627952",
        "city_name": "İstanbul",
        "client_code": "00281",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS2SE034515",
        "city_name": "İstanbul",
        "client_code": "01463",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:02\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE034257",
        "city_name": "İstanbul",
        "client_code": "01463",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS8SE034616",
        "city_name": "İstanbul",
        "client_code": "01463",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE033376",
        "city_name": "İstanbul",
        "client_code": "01463",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE028591",
        "city_name": "İstanbul",
        "client_code": "01463",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP1SJ596613",
        "city_name": "İstanbul",
        "client_code": "01463",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 14:56:34\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX2S4094996",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX3S4090181",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX6S4090689",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX8S4090192",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX9S4091058",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4069697",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4082496",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4065996",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4082989",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4077589",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:56\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS2SW028187",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP1SN525977",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:59\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP2SN527009",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:59\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP3SN525978",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:59\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP3SN526693",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:59\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP7SN525966",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP8SN525975",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHPXSN525976",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ0SJ648050",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ1SJ642094",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ4SJ619859",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SN523165",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ6SN523496",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ644271",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ644304",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SJ642125",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SJ648037",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SN522124",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SJ649861",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SJ652582",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSJ630946",
        "city_name": "İstanbul",
        "client_code": "TR4500",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "ERDEMİR",
        "distrit_name": "Beylikdüzü",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ERDEMİR-İstanbul/Beylikdüzü",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4077586",
        "city_name": "Erzurum",
        "client_code": "TR1100",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "ERDEMİR ERZURUM",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ERDEMİR ERZURUM-Erzurum/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS1SW027600",
        "city_name": "Erzurum",
        "client_code": "TR1100",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "ERDEMİR ERZURUM",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ERDEMİR ERZURUM-Erzurum/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS9SW027599",
        "city_name": "Erzurum",
        "client_code": "TR1100",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "ERDEMİR ERZURUM",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ERDEMİR ERZURUM-Erzurum/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4073703",
        "city_name": "İstanbul",
        "client_code": "00000450",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:37\"}",
        "dealer_name": "EVA OTO",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EVA OTO-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4067837",
        "city_name": "İstanbul",
        "client_code": "00000450",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "EVA OTO",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EVA OTO-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4066530",
        "city_name": "İstanbul",
        "client_code": "00000450",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "EVA OTO",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EVA OTO-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4067824",
        "city_name": "İstanbul",
        "client_code": "00000450",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "EVA OTO",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EVA OTO-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4067808",
        "city_name": "İstanbul",
        "client_code": "00000450",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "EVA OTO",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EVA OTO-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4067825",
        "city_name": "İstanbul",
        "client_code": "00000450",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "EVA OTO",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EVA OTO-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4067820",
        "city_name": "İstanbul",
        "client_code": "00000450",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "EVA OTO",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EVA OTO-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4073696",
        "city_name": "İstanbul",
        "client_code": "00000450",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "EVA OTO",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "EVA OTO-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP0SN526997",
        "city_name": "Diyarbakır",
        "client_code": "FEF-PEU-814",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:49\"}",
        "dealer_name": "FEMA FILO",
        "distrit_name": "Dicle",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FEMA FILO-Diyarbakır/Dicle",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS023888",
        "city_name": "İzmir",
        "client_code": "FİGA-PEU-1253",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:00\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS031876",
        "city_name": "İzmir",
        "client_code": "FİGA-PEU-1253",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-18 09:50:38\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS025627",
        "city_name": "İzmir",
        "client_code": "FİGA-PEU-1253",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:01\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS024763",
        "city_name": "İzmir",
        "client_code": "FİGA-PEU-1253",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:01\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS025637",
        "city_name": "İzmir",
        "client_code": "FİGA-PEU-1253",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:01\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ4SJ646471",
        "city_name": "İzmir",
        "client_code": "FİGA-CIT-1264",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4081127",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4081273",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4084268",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4084271",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4084948",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4081119",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4081265",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4084246",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4084269",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4084272",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4084935",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4084913",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4081115",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4084273",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4081267",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4081270",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4084279",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4084914",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4081116",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4081276",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4084274",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4081268",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:56\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4081271",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:56\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4081117",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4081263",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4084275",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4081269",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4084270",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4081118",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4081121",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4081264",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4081328",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4084911",
        "city_name": "İzmir",
        "client_code": "FİGA-OPEL-1247",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "FİLOKUR GARENTA",
        "distrit_name": "Menderes",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FİLOKUR GARENTA-İzmir/Menderes",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP6SJ614507",
        "city_name": "İstanbul",
        "client_code": "FİT-CIT-975",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-01 15:52:28\"}",
        "dealer_name": "FİLO TEKNİK",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "FİLO TEKNİK-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP7SJ614497",
        "city_name": "İstanbul",
        "client_code": "FİT-CIT-975",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-01 15:52:28\"}",
        "dealer_name": "FİLO TEKNİK",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "FİLO TEKNİK-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP8SJ614489",
        "city_name": "İstanbul",
        "client_code": "FİT-CIT-975",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-01 15:52:29\"}",
        "dealer_name": "FİLO TEKNİK",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "FİLO TEKNİK-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP8SJ614508",
        "city_name": "İstanbul",
        "client_code": "FİT-CIT-975",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-01 15:52:29\"}",
        "dealer_name": "FİLO TEKNİK",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "FİLO TEKNİK-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP9SJ614498",
        "city_name": "İstanbul",
        "client_code": "FİT-CIT-975",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-01 15:52:29\"}",
        "dealer_name": "FİLO TEKNİK",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "FİLO TEKNİK-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP9SJ614517",
        "city_name": "İstanbul",
        "client_code": "FİT-CIT-975",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-01 15:52:29\"}",
        "dealer_name": "FİLO TEKNİK",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "FİLO TEKNİK-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHPXSJ608838",
        "city_name": "İstanbul",
        "client_code": "FİT-CIT-975",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-01 15:52:29\"}",
        "dealer_name": "FİLO TEKNİK",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "FİLO TEKNİK-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHPXSJ614493",
        "city_name": "İstanbul",
        "client_code": "FİT-CIT-975",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-01 15:52:29\"}",
        "dealer_name": "FİLO TEKNİK",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "FİLO TEKNİK-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHPXSJ614509",
        "city_name": "İstanbul",
        "client_code": "FİT-CIT-975",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-01 15:52:29\"}",
        "dealer_name": "FİLO TEKNİK",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "FİLO TEKNİK-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHPXSJ614512",
        "city_name": "İstanbul",
        "client_code": "FİT-CIT-975",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-01 15:52:29\"}",
        "dealer_name": "FİLO TEKNİK",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "FİLO TEKNİK-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ4SJ645605",
        "city_name": "Elazığ",
        "client_code": "TR8880",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "FIRAT",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-04-29",
        "shipping_info": "FIRAT-Elazığ/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS8SW027836",
        "city_name": "Elazığ",
        "client_code": "TR8880",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "FIRAT",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "FIRAT-Elazığ/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ622574",
        "city_name": "İzmir",
        "client_code": "FOİ-PEU-487",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS3SJ622477",
        "city_name": "İzmir",
        "client_code": "FOİ-PEU-487",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS3SJ622575",
        "city_name": "İzmir",
        "client_code": "FOİ-PEU-487",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ622478",
        "city_name": "İzmir",
        "client_code": "FOİ-PEU-487",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:42\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ622554",
        "city_name": "İzmir",
        "client_code": "FOİ-PEU-487",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:42\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS7SJ622479",
        "city_name": "İzmir",
        "client_code": "FOİ-PEU-487",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:42\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ622555",
        "city_name": "İzmir",
        "client_code": "FOİ-PEU-487",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:42\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ622475",
        "city_name": "İzmir",
        "client_code": "FOİ-PEU-487",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:43\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ622556",
        "city_name": "İzmir",
        "client_code": "FOİ-PEU-487",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:43\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS1SE029404",
        "city_name": "İzmir",
        "client_code": "FOİ-CIT-150",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:01\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS1SE034117",
        "city_name": "İzmir",
        "client_code": "FOİ-CIT-150",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:01\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE029406",
        "city_name": "İzmir",
        "client_code": "FOİ-CIT-150",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:04\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE029407",
        "city_name": "İzmir",
        "client_code": "FOİ-CIT-150",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE032887",
        "city_name": "İzmir",
        "client_code": "FOİ-CIT-150",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE033330",
        "city_name": "İzmir",
        "client_code": "FOİ-CIT-150",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE029408",
        "city_name": "İzmir",
        "client_code": "FOİ-CIT-150",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE032888",
        "city_name": "İzmir",
        "client_code": "FOİ-CIT-150",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE033328",
        "city_name": "İzmir",
        "client_code": "FOİ-CIT-150",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE029448",
        "city_name": "İzmir",
        "client_code": "FOİ-CIT-150",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE034116",
        "city_name": "İzmir",
        "client_code": "FOİ-CIT-150",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "FORDSTORE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "FORDSTORE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS037834",
        "city_name": "Şanlıurfa",
        "client_code": "00254",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "GAPEL",
        "distrit_name": "Eyyübiye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "GAPEL-Şanlıurfa/Eyyübiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS037719",
        "city_name": "Şanlıurfa",
        "client_code": "00254",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "GAPEL",
        "distrit_name": "Eyyübiye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GAPEL-Şanlıurfa/Eyyübiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ631072",
        "city_name": "Şanlıurfa",
        "client_code": "00254",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "GAPEL",
        "distrit_name": "Eyyübiye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GAPEL-Şanlıurfa/Eyyübiye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4044218",
        "city_name": "Şanlıurfa",
        "client_code": "TR3600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "GAPEL",
        "distrit_name": "Harran",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GAPEL-Şanlıurfa/Harran",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNSXSW027837",
        "city_name": "Şanlıurfa",
        "client_code": "TR3600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "GAPEL",
        "distrit_name": "Harran",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GAPEL-Şanlıurfa/Harran",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY9SS037750",
        "city_name": "İstanbul",
        "client_code": "GAK-PEU-496",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-18 09:50:38\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4084237",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4084934",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4081279",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4081282",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4084232",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4081274",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4082652",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4084238",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4081123",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4081266",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4081283",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4081316",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4084233",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4084247",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4081275",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4081325",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4082653",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4081124",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4081317",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4082659",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4084234",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4084248",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4082962",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4081125",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:56\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4084235",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:56\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4084915",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:56\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4081277",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4081280",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4081272",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4081319",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4084236",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4084916",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4084933",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4081278",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4081281",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4081331",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4082446",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4084231",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4084245",
        "city_name": "İstanbul",
        "client_code": "GAK-OPE-818",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "GARENTA KURTKÖY",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA KURTKÖY-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4081323",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4084917",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4081122",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4084909",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4084912",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4081128",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4081324",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4084930",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4081129",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4084936",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4084928",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4084931",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4081318",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:56\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4084929",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:56\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4081120",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4084910",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4084950",
        "city_name": "İstanbul",
        "client_code": "GAT-OPE-867",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "GARENTA TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GARENTA TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP2SN526984",
        "city_name": "İstanbul",
        "client_code": "00245",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:50\"}",
        "dealer_name": "GENERAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GENERAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP6SN522081",
        "city_name": "İstanbul",
        "client_code": "00245",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:50\"}",
        "dealer_name": "GENERAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GENERAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS064191",
        "city_name": "İstanbul",
        "client_code": "00245",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:49\"}",
        "dealer_name": "GENERAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GENERAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ8SS064096",
        "city_name": "İstanbul",
        "client_code": "00245",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "GENERAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GENERAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ631789",
        "city_name": "İstanbul",
        "client_code": "00245",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "GENERAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GENERAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS0SE033680",
        "city_name": "İstanbul",
        "client_code": "01436",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "GENERAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GENERAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHPY8SE033136",
        "city_name": "İstanbul",
        "client_code": "01436",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:00\"}",
        "dealer_name": "GENERAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GENERAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS1SE027071",
        "city_name": "İstanbul",
        "client_code": "01436",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:01\"}",
        "dealer_name": "GENERAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GENERAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW1SE028485",
        "city_name": "İstanbul",
        "client_code": "01436",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "GENERAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GENERAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW4SE032269",
        "city_name": "İstanbul",
        "client_code": "01436",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "GENERAL",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GENERAL-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-22",
        "brand": "OPEL",
        "chassis_no": "VXKFPHNS2S1011722",
        "city_name": "İstanbul",
        "client_code": "TR0116",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "GERÇEK",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "ASTRA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-04-21",
        "shipping_info": "GERÇEK-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4043870",
        "city_name": "İstanbul",
        "client_code": "TR0116",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "GERÇEK",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "GERÇEK-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX0S4091076",
        "city_name": "İstanbul",
        "client_code": "TR0116",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "GERÇEK",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GERÇEK-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4044951",
        "city_name": "İstanbul",
        "client_code": "TR0116",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "GERÇEK",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GERÇEK-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS2SW028674",
        "city_name": "İstanbul",
        "client_code": "TR0116",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "GERÇEK",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GERÇEK-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ1SJ648008",
        "city_name": "İstanbul",
        "client_code": "TR0116",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "GERÇEK",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GERÇEK-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ4SJ648035",
        "city_name": "İstanbul",
        "client_code": "TR0116",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "GERÇEK",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GERÇEK-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SJ652577",
        "city_name": "İstanbul",
        "client_code": "TR0116",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "GERÇEK",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GERÇEK-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SJ655172",
        "city_name": "İstanbul",
        "client_code": "TR0116",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "GERÇEK",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GERÇEK-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SN525921",
        "city_name": "İstanbul",
        "client_code": "TR0116",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "GERÇEK",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GERÇEK-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ6SJ648022",
        "city_name": "İstanbul",
        "client_code": "TR0116",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "GERÇEK",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GERÇEK-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SJ652565",
        "city_name": "İstanbul",
        "client_code": "TR0116",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "GERÇEK",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GERÇEK-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHZ7SU289161",
        "city_name": "İstanbul",
        "client_code": "TR0053",
        "color": null,
        "customs_status": null,
        "dealer_name": "GLOBAL",
        "distrit_name": "Üsküdar",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GLOBAL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKFPHNS0S1011654",
        "city_name": "İstanbul",
        "client_code": "TR0053",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "GLOBAL",
        "distrit_name": "Üsküdar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "ASTRA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GLOBAL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS9RW084329",
        "city_name": "İstanbul",
        "client_code": "TR0053",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-08 16:16:57\"}",
        "dealer_name": "GLOBAL",
        "distrit_name": "Üsküdar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GLOBAL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SN522110",
        "city_name": "İstanbul",
        "client_code": "TR0053",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "GLOBAL",
        "distrit_name": "Üsküdar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GLOBAL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSN522125",
        "city_name": "İstanbul",
        "client_code": "TR0053",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:15\"}",
        "dealer_name": "GLOBAL",
        "distrit_name": "Üsküdar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GLOBAL-İstanbul/Üsküdar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VF3VLEHZ3SU287400",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": null,
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "EXPERT",
        "order_type": "INVOICE",
        "park_address": "RESEPSİYON / RS-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "RESEPSİYON"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ631654",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ628011",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VF3VLEHT3S7805001",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:00\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "EXPERT",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHZ8SJ585062",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 14:56:29\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "PARTNER VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS2SY536398",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS2SY538751",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS2SY538782",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY543434",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS5SY538811",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS6SY538820",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS7SY536493",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS9SY538763",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNSXSY538738",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNSXSY538884",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY0SS063900",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY0SS066408",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS037709",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS037838",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS066143",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS037847",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS065969",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS066474",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS063888",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS066144",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS037557",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS063964",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:49\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS064869",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:49\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS032531",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS037423",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS063892",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:49\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS037861",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS063893",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS038937",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY9SS063961",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY9SS065094",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY9SS065595",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY9SS068626",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS037417",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS064407",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS064875",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS066142",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ0SS066120",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ1SS064229",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ1SS069298",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ2SS065275",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ3SS063406",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ3SS064894",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ3SS067164",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ4SS063561",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ4SS063656",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ5SS068820",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ7SS064381",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ9SS064382",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ657154",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:52\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ631138",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ631139",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ633748",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ633913",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ633749",
        "city_name": "Ankara",
        "client_code": "00081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS2SE029508",
        "city_name": "Ankara",
        "client_code": "00000845",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:02\"}",
        "dealer_name": "GÖRAL BALGAT",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL BALGAT-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHZ2SJ641139",
        "city_name": "Ankara",
        "client_code": "00219",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:51\"}",
        "dealer_name": "GÖRAL ÜMİTKÖY",
        "distrit_name": "Ümitköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL ÜMİTKÖY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS1SY535078",
        "city_name": "Ankara",
        "client_code": "00219",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "GÖRAL ÜMİTKÖY",
        "distrit_name": "Ümitköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL ÜMİTKÖY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS8SY538821",
        "city_name": "Ankara",
        "client_code": "00219",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "GÖRAL ÜMİTKÖY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL ÜMİTKÖY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNSXSY538755",
        "city_name": "Ankara",
        "client_code": "00219",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "GÖRAL ÜMİTKÖY",
        "distrit_name": "Ümitköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL ÜMİTKÖY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS063890",
        "city_name": "Ankara",
        "client_code": "00219",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:49\"}",
        "dealer_name": "GÖRAL ÜMİTKÖY",
        "distrit_name": "Ümitköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÖRAL ÜMİTKÖY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ1SS064473",
        "city_name": "Ankara",
        "client_code": "00219",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "GÖRAL ÜMİTKÖY",
        "distrit_name": "Ümitköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL ÜMİTKÖY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ6SS063559",
        "city_name": "Ankara",
        "client_code": "00219",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "GÖRAL ÜMİTKÖY",
        "distrit_name": "Ümitköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL ÜMİTKÖY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZXSS065248",
        "city_name": "Ankara",
        "client_code": "00219",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "GÖRAL ÜMİTKÖY",
        "distrit_name": "Ümitköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÖRAL ÜMİTKÖY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ634255",
        "city_name": "Ankara",
        "client_code": "00219",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "GÖRAL ÜMİTKÖY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL ÜMİTKÖY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ634250",
        "city_name": "Ankara",
        "client_code": "00219",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "GÖRAL ÜMİTKÖY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL ÜMİTKÖY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS7SJ634261",
        "city_name": "Ankara",
        "client_code": "00219",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "GÖRAL ÜMİTKÖY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÖRAL ÜMİTKÖY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHZ9SJ641168",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:51\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-04-29",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZXSS063662",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS037836",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS037420",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS8SW024791",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F0SG015826",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F0SG016314",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F1SG015818",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F1SG015995",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F1SG016001",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F2SG016329",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F3SG015836",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F3SG016338",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F3SG016470",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F4SG015991",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F6SG015815",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F7SG015399",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F8SG015816",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F8SG016481",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F9SG015405",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F9SG015839",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / XX-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6F9SG015999",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7YEF6FXSG015817",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHZ2SJ658538",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:51\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHZ2SJ658541",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:51\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHZ4SJ658539",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:51\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHZ9SJ641199",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:51\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS0SY532849",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS1SY538871",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS1SY538899",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS8SY538883",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS032415",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ2SS067155",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ633753",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ622471",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ631756",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ652396",
        "city_name": "İstanbul",
        "client_code": "00275",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS0SE033503",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS2SE035012",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS2SE035057",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS3SE028280",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHPY1SE034726",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS8SE033353",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP5SN521907",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ0SN527048",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ1SJ646461",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ1SN527060",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ3SN526766",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ4SN526047",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ6SN526759",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ6SN527068",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ8SN526049",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ8SN527069",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ8SN527072",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ9SN527047",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZXSN526764",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZXSN527073",
        "city_name": "İstanbul",
        "client_code": "01475",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX4S4090643",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4082651",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4092144",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4073585",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:37\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4081332",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4084344",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4084358",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4084456",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4070548",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4084949",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4084281",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4084340",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4081320",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4084282",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4084489",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4084492",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4043420",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4084503",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:56\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4081285",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:56\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4081321",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:56\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4092660",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:56\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4081286",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4081322",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4084348",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4092689",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS3SW026237",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS4SW027977",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS6SW020593",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-08 16:16:57\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS9SW025044",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNSXSW026655",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP3SJ626526",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP4SJ630844",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ2SJ648034",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ6SJ623279",
        "city_name": "İstanbul",
        "client_code": "TR0056",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "GÜLAN",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜLAN-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS3SJ631065",
        "city_name": "İstanbul",
        "client_code": "00000617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "GÜRSES ARAÇ KİRALAMA",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜRSES ARAÇ KİRALAMA-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ630414",
        "city_name": "İstanbul",
        "client_code": "00000617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "GÜRSES ARAÇ KİRALAMA",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜRSES ARAÇ KİRALAMA-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ631071",
        "city_name": "İstanbul",
        "client_code": "00000617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "GÜRSES ARAÇ KİRALAMA",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜRSES ARAÇ KİRALAMA-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ631080",
        "city_name": "İstanbul",
        "client_code": "00000617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "GÜRSES ARAÇ KİRALAMA",
        "distrit_name": "Bayrampaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "GÜRSES ARAÇ KİRALAMA-İstanbul/Bayrampaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY0SS037720",
        "city_name": "Antalya",
        "client_code": "00048",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "HAŞİM BALABAN",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-04-29",
        "shipping_info": "HAŞİM BALABAN-Antalya/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS031753",
        "city_name": "Antalya",
        "client_code": "00048",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "HAŞİM BALABAN",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "HAŞİM BALABAN-Antalya/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS037854",
        "city_name": "Antalya",
        "client_code": "00048",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "HAŞİM BALABAN",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-25",
        "shipping_info": "HAŞİM BALABAN-Antalya/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VF3VLEHT6S7805915",
        "city_name": "Antalya",
        "client_code": "00048",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-17 10:40:19\"}",
        "dealer_name": "HAŞİM BALABAN",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "EXPERT",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "HAŞİM BALABAN-Antalya/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VF3VLEHZXSU284316",
        "city_name": "Antalya",
        "client_code": "00048",
        "color": null,
        "customs_status": null,
        "dealer_name": "HAŞİM BALABAN",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "EXPERT",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-5",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "HAŞİM BALABAN-Antalya/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP2SJ637073",
        "city_name": "Antalya",
        "client_code": "00048",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:36\"}",
        "dealer_name": "HAŞİM BALABAN",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "HAŞİM BALABAN-Antalya/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY9SS037876",
        "city_name": "Antalya",
        "client_code": "00048",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "HAŞİM BALABAN",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "HAŞİM BALABAN-Antalya/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ631063",
        "city_name": "Antalya",
        "client_code": "00048",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "HAŞİM BALABAN",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "HAŞİM BALABAN-Antalya/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4074361",
        "city_name": "Antalya",
        "client_code": "TR0058",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "HAŞİM BALABAN",
        "distrit_name": "Konyaaltı",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "HAŞİM BALABAN-Antalya/Konyaaltı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS0SE027269",
        "city_name": "İzmir",
        "client_code": "00001646",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:39\"}",
        "dealer_name": "HONDA TERAKKİ PLAZA",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "HONDA TERAKKİ PLAZA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS0SE035470",
        "city_name": "İzmir",
        "client_code": "00001646",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:01\"}",
        "dealer_name": "HONDA TERAKKİ PLAZA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "HONDA TERAKKİ PLAZA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS2SE034577",
        "city_name": "İzmir",
        "client_code": "00001646",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:02\"}",
        "dealer_name": "HONDA TERAKKİ PLAZA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "HONDA TERAKKİ PLAZA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS4SE027209",
        "city_name": "İzmir",
        "client_code": "00001646",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:57\"}",
        "dealer_name": "HONDA TERAKKİ PLAZA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "HONDA TERAKKİ PLAZA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE028630",
        "city_name": "İzmir",
        "client_code": "00001646",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:39\"}",
        "dealer_name": "HONDA TERAKKİ PLAZA",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "HONDA TERAKKİ PLAZA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE033357",
        "city_name": "İzmir",
        "client_code": "00001646",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:57\"}",
        "dealer_name": "HONDA TERAKKİ PLAZA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "HONDA TERAKKİ PLAZA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE027308",
        "city_name": "İzmir",
        "client_code": "00001646",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:57\"}",
        "dealer_name": "HONDA TERAKKİ PLAZA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "HONDA TERAKKİ PLAZA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE027253",
        "city_name": "İzmir",
        "client_code": "00001646",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "HONDA TERAKKİ PLAZA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "HONDA TERAKKİ PLAZA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE034106",
        "city_name": "İzmir",
        "client_code": "00001646",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "HONDA TERAKKİ PLAZA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "HONDA TERAKKİ PLAZA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE027268",
        "city_name": "İzmir",
        "client_code": "00001646",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "HONDA TERAKKİ PLAZA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "HONDA TERAKKİ PLAZA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE028632",
        "city_name": "İzmir",
        "client_code": "00001646",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "HONDA TERAKKİ PLAZA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "HONDA TERAKKİ PLAZA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE035466",
        "city_name": "İzmir",
        "client_code": "00001646",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "HONDA TERAKKİ PLAZA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "HONDA TERAKKİ PLAZA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE035864",
        "city_name": "İzmir",
        "client_code": "00001646",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "HONDA TERAKKİ PLAZA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "HONDA TERAKKİ PLAZA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ2SS069035",
        "city_name": "Malatya",
        "client_code": "00012",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ILICAK",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ILICAK-Malatya/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4084886",
        "city_name": "Malatya",
        "client_code": "TR0063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "ILICAK",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ILICAK-Malatya/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP1SJ643924",
        "city_name": "Malatya",
        "client_code": "TR0063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:59\"}",
        "dealer_name": "ILICAK",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ILICAK-Malatya/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP1SJ648010",
        "city_name": "Malatya",
        "client_code": "TR0063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:59\"}",
        "dealer_name": "ILICAK",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ILICAK-Malatya/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHPXSJ655893",
        "city_name": "Malatya",
        "client_code": "TR0063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "ILICAK",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ILICAK-Malatya/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS6SE026605",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS9SE026601",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS9SE033189",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHPY8SE033895",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:00\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS0SE029510",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:00\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS0SE034240",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:01\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS1SE035316",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:01\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS2SE033395",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:02\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS3SE034149",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS3SE034216",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS4SE029543",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS4SE034158",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE034184",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:04\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE033397",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS8SE034163",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE026637",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE033337",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ5SJ642302",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ6SJ647976",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ9SJ645994",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZXSJ641775",
        "city_name": "Bursa",
        "client_code": "01410",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "İNALLAR OVAAKÇA",
        "distrit_name": "Ovaakça",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İNALLAR OVAAKÇA-Bursa/Ovaakça",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHZ8SU286740",
        "city_name": "Kayseri",
        "client_code": "TR0800",
        "color": null,
        "customs_status": null,
        "dealer_name": "İNCİROĞLU",
        "distrit_name": "Melikgazi",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "İNCİROĞLU-Kayseri/Melikgazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW9SE031456",
        "city_name": "Kayseri",
        "client_code": "01454",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "İNCİROĞLU",
        "distrit_name": "Melikgazi",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İNCİROĞLU-Kayseri/Melikgazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ1SJ619891",
        "city_name": "Kayseri",
        "client_code": "01454",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "İNCİROĞLU",
        "distrit_name": "Melikgazi",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İNCİROĞLU-Kayseri/Melikgazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ2SJ620225",
        "city_name": "Kayseri",
        "client_code": "01454",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "İNCİROĞLU",
        "distrit_name": "Melikgazi",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İNCİROĞLU-Kayseri/Melikgazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ8SJ618446",
        "city_name": "Kayseri",
        "client_code": "01454",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "İNCİROĞLU",
        "distrit_name": "Melikgazi",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İNCİROĞLU-Kayseri/Melikgazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ9SJ620240",
        "city_name": "Kayseri",
        "client_code": "01454",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "İNCİROĞLU",
        "distrit_name": "Melikgazi",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İNCİROĞLU-Kayseri/Melikgazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZXSJ619985",
        "city_name": "Kayseri",
        "client_code": "01454",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "İNCİROĞLU",
        "distrit_name": "Melikgazi",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İNCİROĞLU-Kayseri/Melikgazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZXSJ620201",
        "city_name": "Kayseri",
        "client_code": "01454",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "İNCİROĞLU",
        "distrit_name": "Melikgazi",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İNCİROĞLU-Kayseri/Melikgazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4069730",
        "city_name": "Kayseri",
        "client_code": "TR0800",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "İNCİROĞLU",
        "distrit_name": "Melikgazi",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "İNCİROĞLU-Kayseri/Melikgazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4073699",
        "city_name": "İzmir",
        "client_code": "00001039",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "İZMİR BACAR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 2,
        "process_date": "2025-04-21",
        "shipping_info": "İZMİR BACAR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS2SY538880",
        "city_name": "İzmir",
        "client_code": "00000972",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "İZMİR BACAR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İZMİR BACAR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY541201",
        "city_name": "İzmir",
        "client_code": "00000972",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "İZMİR BACAR",
        "distrit_name": "Gaziemir",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İZMİR BACAR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS6SY538767",
        "city_name": "İzmir",
        "client_code": "00000972",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "İZMİR BACAR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İZMİR BACAR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS7SY542178",
        "city_name": "İzmir",
        "client_code": "00000972",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "İZMİR BACAR",
        "distrit_name": "Gaziemir",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İZMİR BACAR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS8SY538771",
        "city_name": "İzmir",
        "client_code": "00000972",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "İZMİR BACAR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İZMİR BACAR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-05",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS9SY542487",
        "city_name": "İzmir",
        "client_code": "00000972",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "İZMİR BACAR",
        "distrit_name": "Gaziemir",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İZMİR BACAR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE028532",
        "city_name": "İzmir",
        "client_code": "00000952",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:04\"}",
        "dealer_name": "İZMİR BACAR",
        "distrit_name": "Gaziemir",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İZMİR BACAR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE035876",
        "city_name": "İzmir",
        "client_code": "00000952",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "İZMİR BACAR",
        "distrit_name": "Gaziemir",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İZMİR BACAR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS6SY536355",
        "city_name": "İzmir",
        "client_code": "İZB-PEU-904",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "İZMİR BİEKSPER",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "İZMİR BİEKSPER-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS021352",
        "city_name": "İzmir",
        "client_code": "İZB-PEU-904",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:31\"}",
        "dealer_name": "İZMİR BİEKSPER",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İZMİR BİEKSPER-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS015384",
        "city_name": "İzmir",
        "client_code": "İZB-PEU-904",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-01 03:26:16\"}",
        "dealer_name": "İZMİR BİEKSPER",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "İZMİR BİEKSPER-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4073837",
        "city_name": "İzmir",
        "client_code": "İZB-OPE-101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "İZMİR BİEKSPER",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "İZMİR BİEKSPER-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ4SN522802",
        "city_name": "İzmir",
        "client_code": "TR0057",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHZ4SJ658542",
        "city_name": "İzmir",
        "client_code": "00220",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:51\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS0SY538764",
        "city_name": "İzmir",
        "client_code": "00220",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY539089",
        "city_name": "İzmir",
        "client_code": "00220",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS8SY542352",
        "city_name": "İzmir",
        "client_code": "00220",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS063970",
        "city_name": "İzmir",
        "client_code": "00220",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ1SS063677",
        "city_name": "İzmir",
        "client_code": "00220",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ1SS067275",
        "city_name": "İzmir",
        "client_code": "00220",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ5SS066906",
        "city_name": "İzmir",
        "client_code": "00220",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ5SS067313",
        "city_name": "İzmir",
        "client_code": "00220",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ6SS067143",
        "city_name": "İzmir",
        "client_code": "00220",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ7SS067149",
        "city_name": "İzmir",
        "client_code": "00220",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3UHZKX1S4029851",
        "city_name": "İzmir",
        "client_code": "00220",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-28 10:42:16\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "208",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ634257",
        "city_name": "İzmir",
        "client_code": "00220",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS7SJ624961",
        "city_name": "İzmir",
        "client_code": "00220",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ633760",
        "city_name": "İzmir",
        "client_code": "00220",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ631130",
        "city_name": "İzmir",
        "client_code": "00220",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4046279",
        "city_name": "İzmir",
        "client_code": "TR0057",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ1SJ618149",
        "city_name": "İzmir",
        "client_code": "TR0057",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ2SJ623280",
        "city_name": "İzmir",
        "client_code": "TR0057",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:13\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ652662",
        "city_name": "İzmir",
        "client_code": "TR0057",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "KAHYAOĞULLARI İZMİR",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "KAHYAOĞULLARI İZMİR-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY9SS037697",
        "city_name": "Çorum",
        "client_code": "00058",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "KARATAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "KARATAŞ-Çorum/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXEVJYHV1SU287586",
        "city_name": "Çorum",
        "client_code": "TR8920",
        "color": null,
        "customs_status": null,
        "dealer_name": "KARATAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "KARATAŞ-Çorum/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY538850",
        "city_name": "Çorum",
        "client_code": "00058",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "KARATAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KARATAŞ-Çorum/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ631773",
        "city_name": "Çorum",
        "client_code": "00058",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "KARATAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KARATAŞ-Çorum/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ615168",
        "city_name": "Çorum",
        "client_code": "00058",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:09\"}",
        "dealer_name": "KARATAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "KARATAŞ-Çorum/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4067683",
        "city_name": "Çorum",
        "client_code": "TR8920",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "KARATAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KARATAŞ-Çorum/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ619841",
        "city_name": "Çorum",
        "client_code": "TR8920",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "KARATAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KARATAŞ-Çorum/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SN521247",
        "city_name": "Çorum",
        "client_code": "TR8920",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "KARATAŞ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KARATAŞ-Çorum/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ631097",
        "city_name": "Düzce",
        "client_code": "00266",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "KERVAN",
        "distrit_name": "Kaynaşlı",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "KERVAN-Düzce/Kaynaşlı",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS8SY538849",
        "city_name": "Mardin",
        "client_code": "00235",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "KIZILTEPE",
        "distrit_name": "Kızıltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KIZILTEPE-Mardin/Kızıltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNSXSY538819",
        "city_name": "Mardin",
        "client_code": "00235",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "KIZILTEPE",
        "distrit_name": "Kızıltepe",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "KIZILTEPE-Mardin/Kızıltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS068541",
        "city_name": "Mardin",
        "client_code": "00235",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:49\"}",
        "dealer_name": "KIZILTEPE",
        "distrit_name": "Kızıltepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "KIZILTEPE-Mardin/Kızıltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ0SS064237",
        "city_name": "Mardin",
        "client_code": "00235",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "KIZILTEPE",
        "distrit_name": "Kızıltepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "KIZILTEPE-Mardin/Kızıltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ9SJ620254",
        "city_name": "Mardin",
        "client_code": "01442",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "KIZILTEPE",
        "distrit_name": "Kızıltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "KIZILTEPE-Mardin/Kızıltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS6SY540020",
        "city_name": "Ankara",
        "client_code": "KOÇ-PEU-636",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "KOLUMAN ÇANKAYA",
        "distrit_name": "Çankaya",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "KOLUMAN ÇANKAYA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNSXSY540019",
        "city_name": "Ankara",
        "client_code": "KOÇ-PEU-636",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "KOLUMAN ÇANKAYA",
        "distrit_name": "Çankaya",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "KOLUMAN ÇANKAYA-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY9SS066391",
        "city_name": "Gaziantep",
        "client_code": "00239",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "KOLUMAN MONDE",
        "distrit_name": "Şehitkamil",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "KOLUMAN MONDE-Gaziantep/Şehitkamil",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS8SY538902",
        "city_name": "Gaziantep",
        "client_code": "00239",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "KOLUMAN MONDE",
        "distrit_name": "Şehitkamil",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KOLUMAN MONDE-Gaziantep/Şehitkamil",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS037721",
        "city_name": "Gaziantep",
        "client_code": "00239",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "KOLUMAN MONDE",
        "distrit_name": "Şehitkamil",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "KOLUMAN MONDE-Gaziantep/Şehitkamil",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY6SS037723",
        "city_name": "Gaziantep",
        "client_code": "00239",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "KOLUMAN MONDE",
        "distrit_name": "Şehitkamil",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KOLUMAN MONDE-Gaziantep/Şehitkamil",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS037570",
        "city_name": "Gaziantep",
        "client_code": "00239",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "KOLUMAN MONDE",
        "distrit_name": "Şehitkamil",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "KOLUMAN MONDE-Gaziantep/Şehitkamil",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS037562",
        "city_name": "Gaziantep",
        "client_code": "00239",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "KOLUMAN MONDE",
        "distrit_name": "Şehitkamil",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KOLUMAN MONDE-Gaziantep/Şehitkamil",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS031908",
        "city_name": "Gaziantep",
        "client_code": "00239",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "KOLUMAN MONDE",
        "distrit_name": "Şehitkamil",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "KOLUMAN MONDE-Gaziantep/Şehitkamil",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ1SS063808",
        "city_name": "Gaziantep",
        "client_code": "00239",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "KOLUMAN MONDE",
        "distrit_name": "Şehitkamil",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "KOLUMAN MONDE-Gaziantep/Şehitkamil",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS037860",
        "city_name": "İstanbul",
        "client_code": "00000671",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "KOLUMAN SANCAKTEPE",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KOLUMAN SANCAKTEPE-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE021279",
        "city_name": "Konya",
        "client_code": "KOB-CIT-661",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 14:56:33\"}",
        "dealer_name": "KONYA BACAR",
        "distrit_name": "Karatay",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "KONYA BACAR-Konya/Karatay",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ633929",
        "city_name": "Afyonkarahisar",
        "client_code": "00054",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "KUTLU",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "KUTLU-Afyonkarahisar/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ633922",
        "city_name": "Afyonkarahisar",
        "client_code": "00054",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "KUTLU",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "KUTLU-Afyonkarahisar/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS4SE033634",
        "city_name": "Afyonkarahisar",
        "client_code": "01484",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "KUTLU KARDEŞLER",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "KUTLU KARDEŞLER-Afyonkarahisar/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP0RJ053280",
        "city_name": "Afyonkarahisar",
        "client_code": "01484",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "KUTLU KARDEŞLER",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "KUTLU KARDEŞLER-Afyonkarahisar/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP2RJ053278",
        "city_name": "Afyonkarahisar",
        "client_code": "01484",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "KUTLU KARDEŞLER",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "KUTLU KARDEŞLER-Afyonkarahisar/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS6SW026202",
        "city_name": "Afyonkarahisar",
        "client_code": "TR0061",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "KUTLU KARDEŞLER",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "KUTLU KARDEŞLER-Afyonkarahisar/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY0SS032419",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-25",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-03-22",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ1SS032204",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-18 09:50:39\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-03-21",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY0SS064139",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VF3VJYHV5SU290738",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": null,
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "EXPERT",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VF3VLEHT9S7805312",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-17 10:40:19\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "EXPERT",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VF3VLEHZ8SU284346",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": null,
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "EXPERT",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-54",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7VLEHZ0S7807081",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-20 11:54:53\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPY VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7VLEHZ5S7804242",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-20 11:54:53\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPY VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP8SN526133",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:50\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP9SN526125",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:51\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHPXSN526148",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:51\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHPXSN526151",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:51\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHZ3SN527448",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:51\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY543370",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS037722",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS066298",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ0SS063802",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ1SS063405",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ1SS063792",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ2SS069388",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ4SS063558",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ650772",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:53\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ652380",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:55\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ631062",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ633930",
        "city_name": "İstanbul",
        "client_code": "00292",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS0SE035008",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS1SE035051",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS2SE028285",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS4SE029700",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS6SE027429",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS6SE029584",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:56\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS7SE035541",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS9SE035055",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS9SE035105",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BCZKW7SE032615",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:00\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS2SE029539",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:02\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS2SE034157",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:02\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS2SE034210",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:02\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS3SE027069",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:02\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS3SE028593",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:02\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS4SE034550",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE033360",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:04\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE034542",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:04\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE035232",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE034249",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE035238",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE034480",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE034530",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE028607",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE034147",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE034164",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW3SE031355",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:08\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW4SE034572",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:08\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW8SE034476",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ0SJ620000",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ0SJ620336",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ0SJ641784",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ2SJ620001",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ4SJ647989",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ6SJ620261",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ6SJ626237",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ7SJ620222",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ7SJ647999",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ8SJ619967",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ8SJ647994",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZXSJ619999",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZXSJ620022",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZXSJ647995",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZXSJ648001",
        "city_name": "İstanbul",
        "client_code": "01440",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "MAR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MAR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNSXSW027174",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 8,
        "process_date": "2025-04-28",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4044217",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHT3S7812363",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:36\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHT5S7813529",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4067611",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4070643",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS1SW027175",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS8SW027464",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNSXSW019611",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-08 16:16:57\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP1SJ630784",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP3SJ630754",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP3SJ630771",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP5SJ620663",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP7SJ620650",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:13\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP8SJ630748",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:13\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP8SJ630765",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:13\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SJ630918",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ6SJ648036",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ6SJ649879",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ624277",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SJ642089",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SJ648023",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SJ620702",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SN523492",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSJ649836",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSJ654650",
        "city_name": "İstanbul",
        "client_code": "TR4600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "MARTUR",
        "distrit_name": "Eyüpsultan",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MARTUR-İstanbul/Eyüpsultan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS031892",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ630211",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VF3VLEHT1S7804204",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:00\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "EXPERT",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS0SY541308",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS1SY538868",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS3SY541223",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS062528",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS031762",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS063885",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY9SS065970",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS031780",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ2SS063798",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ4SS067321",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ8SS064230",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ9SS065533",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZXSS069039",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3UKZKX2SJ576209",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:02\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3UKZKX4SJ572212",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:02\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3UKZKX9SJ576157",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:02\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3UKZKX9SJ576210",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:02\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS7SJ631148",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ613606",
        "city_name": "İstanbul",
        "client_code": "00063",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-01 15:52:26\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS0SE035467",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:01\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS1SE027300",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:57\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS3SE035270",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS4SE028036",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:39\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE034105",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:57\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE035271",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:04\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE035464",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:04\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE035862",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE028161",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE028533",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE034588",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE035465",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS8SE034194",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE026718",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE035239",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE034536",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW2SE034473",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:08\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKWXSE034575",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP2SJ653109",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP3SJ653118",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP5SJ653122",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP6SN525903",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP9SJ653110",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ4SJ647975",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ8SJ641774",
        "city_name": "İstanbul",
        "client_code": "01435",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX0S4074682",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX3S4090178",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX3S4090696",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX4S4090190",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKXXS4091070",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4074378",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4084022",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:52\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4077123",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4076989",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:56\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4092795",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4077111",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS3SW028683",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS5SW028815",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS7SW026998",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ2SJ641312",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SJ648013",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SN525273",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SJ652579",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSJ644278",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSJ648024",
        "city_name": "İstanbul",
        "client_code": "TR8070",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "MEPA",
        "distrit_name": "Bahçelievler",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MEPA-İstanbul/Bahçelievler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7ACYHZ0SL018378",
        "city_name": "İstanbul",
        "client_code": "01422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "MERSA",
        "distrit_name": "Güngören",
        "groupage_status": "NO_GROUPAGE",
        "model": "C5 AIRCROSS",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MERSA-İstanbul/Güngören",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS3SE035567",
        "city_name": "İstanbul",
        "client_code": "01422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "MERSA",
        "distrit_name": "Güngören",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MERSA-İstanbul/Güngören",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHPY3SE026787",
        "city_name": "İstanbul",
        "client_code": "01422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:56\"}",
        "dealer_name": "MERSA",
        "distrit_name": "Güngören",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MERSA-İstanbul/Güngören",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHPY7SE034875",
        "city_name": "İstanbul",
        "client_code": "01422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:00\"}",
        "dealer_name": "MERSA",
        "distrit_name": "Güngören",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MERSA-İstanbul/Güngören",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHPYXSE026771",
        "city_name": "İstanbul",
        "client_code": "01422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:56\"}",
        "dealer_name": "MERSA",
        "distrit_name": "Güngören",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MERSA-İstanbul/Güngören",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS1SE029418",
        "city_name": "İstanbul",
        "client_code": "01422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:01\"}",
        "dealer_name": "MERSA",
        "distrit_name": "Güngören",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MERSA-İstanbul/Güngören",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS1SE034182",
        "city_name": "İstanbul",
        "client_code": "01422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:01\"}",
        "dealer_name": "MERSA",
        "distrit_name": "Güngören",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MERSA-İstanbul/Güngören",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS4SE028537",
        "city_name": "İstanbul",
        "client_code": "01422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "MERSA",
        "distrit_name": "Güngören",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MERSA-İstanbul/Güngören",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE034511",
        "city_name": "İstanbul",
        "client_code": "01422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:04\"}",
        "dealer_name": "MERSA",
        "distrit_name": "Güngören",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MERSA-İstanbul/Güngören",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS7SE028595",
        "city_name": "İstanbul",
        "client_code": "01422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "MERSA",
        "distrit_name": "Güngören",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MERSA-İstanbul/Güngören",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP7SN521911",
        "city_name": "İstanbul",
        "client_code": "01422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "MERSA",
        "distrit_name": "Güngören",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MERSA-İstanbul/Güngören",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP8SJ596611",
        "city_name": "İstanbul",
        "client_code": "01422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 14:56:35\"}",
        "dealer_name": "MERSA",
        "distrit_name": "Güngören",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MERSA-İstanbul/Güngören",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHPXSN521904",
        "city_name": "İstanbul",
        "client_code": "01422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "MERSA",
        "distrit_name": "Güngören",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MERSA-İstanbul/Güngören",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHPXSN526780",
        "city_name": "İstanbul",
        "client_code": "01422",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "MERSA",
        "distrit_name": "Güngören",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MERSA-İstanbul/Güngören",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ2SJ643299",
        "city_name": "Bursa",
        "client_code": "MİL-OPE-419",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "MİLOTO",
        "distrit_name": "Osmangazi",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MİLOTO-Bursa/Osmangazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ2SJ644257",
        "city_name": "Bursa",
        "client_code": "MİL-OPE-419",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "MİLOTO",
        "distrit_name": "Osmangazi",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MİLOTO-Bursa/Osmangazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ6SJ623301",
        "city_name": "Bursa",
        "client_code": "MİL-OPE-419",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "MİLOTO",
        "distrit_name": "Osmangazi",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "MİLOTO-Bursa/Osmangazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKKAHPY2S6005925",
        "city_name": "İstanbul",
        "client_code": "MKO-OPE-1853",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 03:04:32\"}",
        "dealer_name": "MKC OTO",
        "distrit_name": "Maltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New Grandland",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-02-28",
        "shipping_info": "MKC OTO-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKKAHPY5S6006664",
        "city_name": "İstanbul",
        "client_code": "MKO-OPE-1853",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 03:04:33\"}",
        "dealer_name": "MKC OTO",
        "distrit_name": "Maltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New Grandland",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-02-28",
        "shipping_info": "MKC OTO-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKKAHPY6S6005930",
        "city_name": "İstanbul",
        "client_code": "MKO-OPE-1853",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 03:04:33\"}",
        "dealer_name": "MKC OTO",
        "distrit_name": "Maltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New Grandland",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-02-28",
        "shipping_info": "MKC OTO-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKKAHPYXS6006420",
        "city_name": "İstanbul",
        "client_code": "MKO-OPE-1853",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 03:04:33\"}",
        "dealer_name": "MKC OTO",
        "distrit_name": "Maltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New Grandland",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-02-28",
        "shipping_info": "MKC OTO-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKKAHPYXS6006661",
        "city_name": "İstanbul",
        "client_code": "MKO-OPE-1853",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 03:04:33\"}",
        "dealer_name": "MKC OTO",
        "distrit_name": "Maltepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New Grandland",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-02-28",
        "shipping_info": "MKC OTO-İstanbul/Maltepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS3SY538984",
        "city_name": "Antalya",
        "client_code": "MOA-PEU-756",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "MONDE ANTALYA",
        "distrit_name": "Muratpaşa",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "MONDE ANTALYA-Antalya/Muratpaşa",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3UKZKX1SJ576203",
        "city_name": "İzmir",
        "client_code": "MOİ-PEU-852",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:02\"}",
        "dealer_name": "MONDE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MONDE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3UKZKX2SJ579059",
        "city_name": "İzmir",
        "client_code": "MOİ-PEU-852",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:02\"}",
        "dealer_name": "MONDE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MONDE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3UKZKX3SJ576204",
        "city_name": "İzmir",
        "client_code": "MOİ-PEU-852",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:02\"}",
        "dealer_name": "MONDE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MONDE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3UKZKX7SJ579218",
        "city_name": "İzmir",
        "client_code": "MOİ-PEU-852",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:02\"}",
        "dealer_name": "MONDE İZMİR",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MONDE İZMİR-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP0SN526451",
        "city_name": "Şırnak",
        "client_code": "MSY-PEU-907",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:49\"}",
        "dealer_name": "MSB YAZILIM",
        "distrit_name": "Cizre",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MSB YAZILIM-Şırnak/Cizre",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP6SN526969",
        "city_name": "Şırnak",
        "client_code": "MSY-PEU-907",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:50\"}",
        "dealer_name": "MSB YAZILIM",
        "distrit_name": "Cizre",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "MSB YAZILIM-Şırnak/Cizre",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4067668",
        "city_name": "Isparta",
        "client_code": "TR4900",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "MUTSAN",
        "distrit_name": "Eğirdir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "MUTSAN-Isparta/Eğirdir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SJ625835",
        "city_name": "Isparta",
        "client_code": "TR4900",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "MUTSAN",
        "distrit_name": "Eğirdir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "MUTSAN-Isparta/Eğirdir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS2SY528852",
        "city_name": "Ankara",
        "client_code": "NAA-PEU-991",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:14\"}",
        "dealer_name": "NASSAN ANKARA",
        "distrit_name": "Etimesgut",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "NASSAN ANKARA-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ619645",
        "city_name": "Ankara",
        "client_code": "NAA-PEU-991",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:42\"}",
        "dealer_name": "NASSAN ANKARA",
        "distrit_name": "Etimesgut",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "NASSAN ANKARA-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE026742",
        "city_name": "Ankara",
        "client_code": "00000352",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:39\"}",
        "dealer_name": "NASSAN ANKARA",
        "distrit_name": "Etimesgut",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "NASSAN ANKARA-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE021323",
        "city_name": "İstanbul",
        "client_code": "00001541",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 14:56:33\"}",
        "dealer_name": "NAUTILUS BIEKSPER",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-03-25",
        "shipping_info": "NAUTILUS BIEKSPER-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS8SE021302",
        "city_name": "İstanbul",
        "client_code": "00001541",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 14:56:34\"}",
        "dealer_name": "NAUTILUS BIEKSPER",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-03-25",
        "shipping_info": "NAUTILUS BIEKSPER-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY542428",
        "city_name": "İstanbul",
        "client_code": "00001543",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "NAUTILUS BIEKSPER",
        "distrit_name": "Kadıköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NAUTILUS BIEKSPER-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY9SS026084",
        "city_name": "İstanbul",
        "client_code": "00001543",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:31\"}",
        "dealer_name": "NAUTILUS BIEKSPER",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "NAUTILUS BIEKSPER-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS0SE028163",
        "city_name": "İstanbul",
        "client_code": "00001541",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:56\"}",
        "dealer_name": "NAUTILUS BIEKSPER",
        "distrit_name": "Kadıköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "NAUTILUS BIEKSPER-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS2SE028164",
        "city_name": "İstanbul",
        "client_code": "00001541",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:57\"}",
        "dealer_name": "NAUTILUS BIEKSPER",
        "distrit_name": "Kadıköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "NAUTILUS BIEKSPER-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS3SE021501",
        "city_name": "İstanbul",
        "client_code": "00001541",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 14:56:33\"}",
        "dealer_name": "NAUTILUS BIEKSPER",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "NAUTILUS BIEKSPER-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS4SE027307",
        "city_name": "İstanbul",
        "client_code": "00001541",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:57\"}",
        "dealer_name": "NAUTILUS BIEKSPER",
        "distrit_name": "Kadıköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NAUTILUS BIEKSPER-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS4SE028165",
        "city_name": "İstanbul",
        "client_code": "00001541",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:57\"}",
        "dealer_name": "NAUTILUS BIEKSPER",
        "distrit_name": "Kadıköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "NAUTILUS BIEKSPER-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE028166",
        "city_name": "İstanbul",
        "client_code": "00001541",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:57\"}",
        "dealer_name": "NAUTILUS BIEKSPER",
        "distrit_name": "Kadıköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "NAUTILUS BIEKSPER-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS8SE028167",
        "city_name": "İstanbul",
        "client_code": "00001541",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "NAUTILUS BIEKSPER",
        "distrit_name": "Kadıköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "NAUTILUS BIEKSPER-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ0SJ623312",
        "city_name": "İstanbul",
        "client_code": "00001542",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:13\"}",
        "dealer_name": "NAUTILUS BIEKSPER",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NAUTILUS BIEKSPER-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SJ623311",
        "city_name": "İstanbul",
        "client_code": "00001542",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:15\"}",
        "dealer_name": "NAUTILUS BIEKSPER",
        "distrit_name": "Kadıköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NAUTILUS BIEKSPER-İstanbul/Kadıköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FMZKW3SY518479",
        "city_name": "Kocaeli",
        "client_code": "00244",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-28 10:42:16\"}",
        "dealer_name": "NAZER",
        "distrit_name": "Gebze",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "308",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "NAZER-Kocaeli/Gebze",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS066317",
        "city_name": "Kocaeli",
        "client_code": "00244",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "NAZER",
        "distrit_name": "Gebze",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "NAZER-Kocaeli/Gebze",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS037710",
        "city_name": "Kocaeli",
        "client_code": "00244",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "NAZER",
        "distrit_name": "Gebze",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NAZER-Kocaeli/Gebze",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS2SE037021",
        "city_name": "Bursa",
        "client_code": "01490",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "NESKAR",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NESKAR-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS2SE037083",
        "city_name": "Bursa",
        "client_code": "01490",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "NESKAR",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NESKAR-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS3SE035004",
        "city_name": "Bursa",
        "client_code": "01490",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "NESKAR",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NESKAR-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS4SE027428",
        "city_name": "Bursa",
        "client_code": "01490",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "NESKAR",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NESKAR-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS4SE027641",
        "city_name": "Bursa",
        "client_code": "01490",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "NESKAR",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NESKAR-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS4SE027669",
        "city_name": "Bursa",
        "client_code": "01490",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "NESKAR",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NESKAR-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS5SE035098",
        "city_name": "Bursa",
        "client_code": "01490",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "NESKAR",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NESKAR-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS5SE037076",
        "city_name": "Bursa",
        "client_code": "01490",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "NESKAR",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NESKAR-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS7SE027634",
        "city_name": "Bursa",
        "client_code": "01490",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "NESKAR",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NESKAR-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHPY5SE034714",
        "city_name": "Bursa",
        "client_code": "01490",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:00\"}",
        "dealer_name": "NESKAR",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NESKAR-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BCZKW9SE026380",
        "city_name": "Bursa",
        "client_code": "01490",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:56\"}",
        "dealer_name": "NESKAR",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NESKAR-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW6SE029535",
        "city_name": "Bursa",
        "client_code": "01490",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:58\"}",
        "dealer_name": "NESKAR",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NESKAR-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4043953",
        "city_name": "Bursa",
        "client_code": "TR4801",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "NESKAR NİLÜFER",
        "distrit_name": "Nilüfer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "NESKAR NİLÜFER-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4070118",
        "city_name": "Bursa",
        "client_code": "TR4801",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "NESKAR NİLÜFER",
        "distrit_name": "Nilüfer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "NESKAR NİLÜFER-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS2SW026245",
        "city_name": "Bursa",
        "client_code": "TR4800",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "NESKAR OSMANGAZİ",
        "distrit_name": "Osmangazi",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "NESKAR OSMANGAZİ-Bursa/Osmangazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX6S4075030",
        "city_name": "Bursa",
        "client_code": "TR4800",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "NESKAR OSMANGAZİ",
        "distrit_name": "Osmangazi",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NESKAR OSMANGAZİ-Bursa/Osmangazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX7S4090667",
        "city_name": "Bursa",
        "client_code": "TR4800",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "NESKAR OSMANGAZİ",
        "distrit_name": "Osmangazi",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NESKAR OSMANGAZİ-Bursa/Osmangazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX8S4074686",
        "city_name": "Bursa",
        "client_code": "TR4800",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "NESKAR OSMANGAZİ",
        "distrit_name": "Osmangazi",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NESKAR OSMANGAZİ-Bursa/Osmangazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKXXS4075029",
        "city_name": "Bursa",
        "client_code": "TR4800",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "NESKAR OSMANGAZİ",
        "distrit_name": "Osmangazi",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NESKAR OSMANGAZİ-Bursa/Osmangazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4046218",
        "city_name": "Bursa",
        "client_code": "TR4800",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "NESKAR OSMANGAZİ",
        "distrit_name": "Osmangazi",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "NESKAR OSMANGAZİ-Bursa/Osmangazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4077003",
        "city_name": "Bursa",
        "client_code": "TR4800",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "NESKAR OSMANGAZİ",
        "distrit_name": "Osmangazi",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NESKAR OSMANGAZİ-Bursa/Osmangazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4092840",
        "city_name": "Bursa",
        "client_code": "TR4800",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "NESKAR OSMANGAZİ",
        "distrit_name": "Osmangazi",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NESKAR OSMANGAZİ-Bursa/Osmangazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ1SJ623271",
        "city_name": "Bursa",
        "client_code": "TR4800",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "NESKAR OSMANGAZİ",
        "distrit_name": "Osmangazi",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NESKAR OSMANGAZİ-Bursa/Osmangazi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ630165",
        "city_name": "İstanbul",
        "client_code": "00221",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "NEV",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "NEV-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS062529",
        "city_name": "İstanbul",
        "client_code": "00221",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "NEV",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "NEV-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS2SY538989",
        "city_name": "İstanbul",
        "client_code": "00221",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "NEV",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NEV-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY6SS066333",
        "city_name": "İstanbul",
        "client_code": "00221",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "NEV",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NEV-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ1SS065283",
        "city_name": "İstanbul",
        "client_code": "00221",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "NEV",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NEV-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ9SS067167",
        "city_name": "İstanbul",
        "client_code": "00221",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "NEV",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NEV-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ627961",
        "city_name": "İstanbul",
        "client_code": "00221",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "NEV",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NEV-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ631752",
        "city_name": "İstanbul",
        "client_code": "00221",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "NEV",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "NEV-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ633747",
        "city_name": "İstanbul",
        "client_code": "00221",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "NEV",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "NEV-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7ACYHZ4SL018495",
        "city_name": "İstanbul",
        "client_code": "01466",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "NEV",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "C5 AIRCROSS",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NEV-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP7SJ626326",
        "city_name": "İstanbul",
        "client_code": "01466",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "NEV",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NEV-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX8S4090645",
        "city_name": "İstanbul",
        "client_code": "TR0052",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "NEV",
        "distrit_name": "Sarıyer",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NEV-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS2SW020526",
        "city_name": "İstanbul",
        "client_code": "TR0052",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-08 16:16:56\"}",
        "dealer_name": "NEV",
        "distrit_name": "Sarıyer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "NEV-İstanbul/Sarıyer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP1SJ620627",
        "city_name": "Balıkesir",
        "client_code": "NOAL-OPE-4163",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "NOVACAR ALTIEYLÜL",
        "distrit_name": "Altıeylül",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NOVACAR ALTIEYLÜL-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP3SJ620628",
        "city_name": "Balıkesir",
        "client_code": "NOAL-OPE-4163",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "NOVACAR ALTIEYLÜL",
        "distrit_name": "Altıeylül",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NOVACAR ALTIEYLÜL-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP4SJ620637",
        "city_name": "Balıkesir",
        "client_code": "NOAL-OPE-4163",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "NOVACAR ALTIEYLÜL",
        "distrit_name": "Altıeylül",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NOVACAR ALTIEYLÜL-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP4SJ620640",
        "city_name": "Balıkesir",
        "client_code": "NOAL-OPE-4163",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "NOVACAR ALTIEYLÜL",
        "distrit_name": "Altıeylül",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NOVACAR ALTIEYLÜL-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP5SJ628858",
        "city_name": "Balıkesir",
        "client_code": "NOAL-OPE-4163",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "NOVACAR ALTIEYLÜL",
        "distrit_name": "Altıeylül",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NOVACAR ALTIEYLÜL-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP6SJ620638",
        "city_name": "Balıkesir",
        "client_code": "NOAL-OPE-4163",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "NOVACAR ALTIEYLÜL",
        "distrit_name": "Altıeylül",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NOVACAR ALTIEYLÜL-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP6SJ620641",
        "city_name": "Balıkesir",
        "client_code": "NOAL-OPE-4163",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "NOVACAR ALTIEYLÜL",
        "distrit_name": "Altıeylül",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NOVACAR ALTIEYLÜL-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP8SJ620639",
        "city_name": "Balıkesir",
        "client_code": "NOAL-OPE-4163",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:13\"}",
        "dealer_name": "NOVACAR ALTIEYLÜL",
        "distrit_name": "Altıeylül",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NOVACAR ALTIEYLÜL-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP8SJ620642",
        "city_name": "Balıkesir",
        "client_code": "NOAL-OPE-4163",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:13\"}",
        "dealer_name": "NOVACAR ALTIEYLÜL",
        "distrit_name": "Altıeylül",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NOVACAR ALTIEYLÜL-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHPXSJ620626",
        "city_name": "Balıkesir",
        "client_code": "NOAL-OPE-4163",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:13\"}",
        "dealer_name": "NOVACAR ALTIEYLÜL",
        "distrit_name": "Altıeylül",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "NOVACAR ALTIEYLÜL-Balıkesir/Altıeylül",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS5SW026997",
        "city_name": "Diyarbakır",
        "client_code": "TR9030",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "ODABAŞI",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODABAŞI-Diyarbakır/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ4SJ619876",
        "city_name": "Diyarbakır",
        "client_code": "TR9030",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "ODABAŞI",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODABAŞI-Diyarbakır/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ653753",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:53\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SN522799",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY0SS037846",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS031893",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHZ7SU288642",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": null,
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS0SY538862",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS1SY524064",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:13\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS1SY538806",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS2SY538863",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS3SY538869",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS3SY538886",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY538766",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY538816",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY538881",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY541361",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS5SY538856",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS6SY538882",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS9SY543347",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNSXSY538853",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNSXSY538867",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY0SS037409",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS064135",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS037848",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY6SS062699",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS064132",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ0SS066912",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ4SS065424",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ7SS063330",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ7SS067152",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ631329",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ625524",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ633908",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ631149",
        "city_name": "İstanbul",
        "client_code": "00269",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHZ3SU289917",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": null,
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHZ5SU289904",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": null,
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHZXSU289168",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": null,
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4067351",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4066967",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4067609",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:37\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4070543",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4043944",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4066111",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS0SW028205",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS4SW027462",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS6SW028676",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNSXSW028079",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP8SJ620656",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:13\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ0SJ644290",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ0SJ656603",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ1SJ618118",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:13\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ1SJ644282",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ1SJ648039",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ1SJ649868",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ1SJ652656",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ2SN527402",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ3SJ619867",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ3SJ620713",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ3SJ630934",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ3SJ654666",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ4SN522122",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ4SN523156",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SJ618140",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SJ618154",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SJ642115",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ618141",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ648014",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ649843",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ652578",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SJ642098",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SJ648032",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSN520729",
        "city_name": "İstanbul",
        "client_code": "TR0101",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:15\"}",
        "dealer_name": "ODAK",
        "distrit_name": "Zeytinburnu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ODAK-İstanbul/Zeytinburnu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXEVJYHV3SU288206",
        "city_name": "Sivas",
        "client_code": "TR0065",
        "color": null,
        "customs_status": null,
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-16",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "DS",
        "chassis_no": "VR1JCYHZ9SY540620",
        "city_name": "Sivas",
        "client_code": "00301",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "DS 7",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS066409",
        "city_name": "Sivas",
        "client_code": "00192",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ8SS067290",
        "city_name": "Sivas",
        "client_code": "00192",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ651623",
        "city_name": "Sivas",
        "client_code": "00192",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:53\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ633974",
        "city_name": "Sivas",
        "client_code": "00192",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ650919",
        "city_name": "Sivas",
        "client_code": "00192",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:55\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS3SE035553",
        "city_name": "Sivas",
        "client_code": "01437",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:58\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS7SE027519",
        "city_name": "Sivas",
        "client_code": "01437",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:59\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BAHNS8SE027660",
        "city_name": "Sivas",
        "client_code": "01437",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:56\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW5SE031423",
        "city_name": "Sivas",
        "client_code": "01437",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW9SE028556",
        "city_name": "Sivas",
        "client_code": "01437",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP2SN521881",
        "city_name": "Sivas",
        "client_code": "01437",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP4SN526774",
        "city_name": "Sivas",
        "client_code": "01437",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP8SN525899",
        "city_name": "Sivas",
        "client_code": "01437",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX9S4090704",
        "city_name": "Sivas",
        "client_code": "TR0065",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4084050",
        "city_name": "Sivas",
        "client_code": "TR0065",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS8SW028081",
        "city_name": "Sivas",
        "client_code": "TR0065",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS8SW028677",
        "city_name": "Sivas",
        "client_code": "TR0065",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ2SJ652570",
        "city_name": "Sivas",
        "client_code": "TR0065",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:01\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSJ642109",
        "city_name": "Sivas",
        "client_code": "TR0065",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "OFZ",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OFZ-Sivas/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-01",
        "brand": "OPEL",
        "chassis_no": "VXKKCZKZ6S6010318",
        "city_name": "Mersin",
        "client_code": "TR8085",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-01 15:52:34\"}",
        "dealer_name": "ÖĞÜTLER",
        "distrit_name": "Mezitli",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "New Grandland",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-03-29",
        "shipping_info": "ÖĞÜTLER-Mersin/Mezitli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4066962",
        "city_name": "Mersin",
        "client_code": "TR8085",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "ÖĞÜTLER",
        "distrit_name": "Mezitli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ÖĞÜTLER-Mersin/Mezitli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4070071",
        "city_name": "Mersin",
        "client_code": "TR8085",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "ÖĞÜTLER",
        "distrit_name": "Mezitli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ÖĞÜTLER-Mersin/Mezitli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS6SY538901",
        "city_name": "Mersin",
        "client_code": "00238",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ÖĞÜTLER",
        "distrit_name": "Mezitli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖĞÜTLER-Mersin/Mezitli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS038881",
        "city_name": "Mersin",
        "client_code": "00238",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "ÖĞÜTLER",
        "distrit_name": "Mezitli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖĞÜTLER-Mersin/Mezitli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS037711",
        "city_name": "Mersin",
        "client_code": "00238",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "ÖĞÜTLER",
        "distrit_name": "Mezitli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖĞÜTLER-Mersin/Mezitli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ631095",
        "city_name": "Mersin",
        "client_code": "00238",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ÖĞÜTLER",
        "distrit_name": "Mezitli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÖĞÜTLER-Mersin/Mezitli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ630387",
        "city_name": "Mersin",
        "client_code": "00238",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ÖĞÜTLER",
        "distrit_name": "Mezitli",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖĞÜTLER-Mersin/Mezitli",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP0SN525638",
        "city_name": "İstanbul",
        "client_code": "ÖMK-PEU-803",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:49\"}",
        "dealer_name": "ÖMER KARAKAYA",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖMER KARAKAYA-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP1SN525647",
        "city_name": "İstanbul",
        "client_code": "ÖMK-PEU-803",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:49\"}",
        "dealer_name": "ÖMER KARAKAYA",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖMER KARAKAYA-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP2SN526970",
        "city_name": "İstanbul",
        "client_code": "ÖMK-PEU-803",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:50\"}",
        "dealer_name": "ÖMER KARAKAYA",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖMER KARAKAYA-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP3SN526637",
        "city_name": "İstanbul",
        "client_code": "ÖMK-PEU-803",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:50\"}",
        "dealer_name": "ÖMER KARAKAYA",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖMER KARAKAYA-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP4SN526632",
        "city_name": "İstanbul",
        "client_code": "ÖMK-PEU-803",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:50\"}",
        "dealer_name": "ÖMER KARAKAYA",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖMER KARAKAYA-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP7SN526642",
        "city_name": "İstanbul",
        "client_code": "ÖMK-PEU-803",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:50\"}",
        "dealer_name": "ÖMER KARAKAYA",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖMER KARAKAYA-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP9SN526643",
        "city_name": "İstanbul",
        "client_code": "ÖMK-PEU-803",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:51\"}",
        "dealer_name": "ÖMER KARAKAYA",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖMER KARAKAYA-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP4SN525366",
        "city_name": "Adana",
        "client_code": "00279",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:50\"}",
        "dealer_name": "ONATÇA",
        "distrit_name": "Seyhan",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ONATÇA-Adana/Seyhan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP7SN525653",
        "city_name": "Adana",
        "client_code": "00279",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:50\"}",
        "dealer_name": "ONATÇA",
        "distrit_name": "Seyhan",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ONATÇA-Adana/Seyhan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS2SY536322",
        "city_name": "Adana",
        "client_code": "00279",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "ONATÇA",
        "distrit_name": "Seyhan",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ONATÇA-Adana/Seyhan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ3SS064233",
        "city_name": "Adana",
        "client_code": "00279",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ONATÇA",
        "distrit_name": "Seyhan",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ONATÇA-Adana/Seyhan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ6SS063786",
        "city_name": "Adana",
        "client_code": "00279",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ONATÇA",
        "distrit_name": "Seyhan",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ONATÇA-Adana/Seyhan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3UKZKW5SJ611395",
        "city_name": "Adana",
        "client_code": "00279",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:52\"}",
        "dealer_name": "ONATÇA",
        "distrit_name": "Seyhan",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ONATÇA-Adana/Seyhan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ650902",
        "city_name": "Adana",
        "client_code": "00279",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:52\"}",
        "dealer_name": "ONATÇA",
        "distrit_name": "Seyhan",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ONATÇA-Adana/Seyhan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ652399",
        "city_name": "Adana",
        "client_code": "00279",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:55\"}",
        "dealer_name": "ONATÇA",
        "distrit_name": "Seyhan",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ONATÇA-Adana/Seyhan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4043952",
        "city_name": "Adana",
        "client_code": "TR8210",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "ONATÇA VİZYON",
        "distrit_name": "Seyhan",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ONATÇA VİZYON-Adana/Seyhan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS5SW028619",
        "city_name": "Adana",
        "client_code": "TR8210",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "ONATÇA VİZYON",
        "distrit_name": "Seyhan",
        "groupage_status": "NO_GROUPAGE",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ONATÇA VİZYON-Adana/Seyhan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ4SJ654644",
        "city_name": "Adana",
        "client_code": "TR8210",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "ONATÇA VİZYON",
        "distrit_name": "Seyhan",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ONATÇA VİZYON-Adana/Seyhan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ5SN527412",
        "city_name": "Adana",
        "client_code": "TR8210",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "ONATÇA VİZYON",
        "distrit_name": "Seyhan",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ONATÇA VİZYON-Adana/Seyhan",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-01",
        "brand": "OPEL",
        "chassis_no": "VXKFPHNS8S1011837",
        "city_name": "Ankara",
        "client_code": "TR4000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-01 15:52:33\"}",
        "dealer_name": "OPAL",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "ASTRA",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-03-29",
        "shipping_info": "OPAL-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ2SJ626518",
        "city_name": "Ankara",
        "client_code": "TR4000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:13\"}",
        "dealer_name": "OPAL",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "OPAL-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKFPHNS2S1011820",
        "city_name": "Ankara",
        "client_code": "TR4000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "OPAL",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "ASTRA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OPAL-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKFPHNS3S1011664",
        "city_name": "Ankara",
        "client_code": "TR4000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "OPAL",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "ASTRA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OPAL-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4039844",
        "city_name": "Ankara",
        "client_code": "TR4000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "OPAL",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OPAL-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP0SJ630856",
        "city_name": "Ankara",
        "client_code": "TR4000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "OPAL",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OPAL-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP3SJ630835",
        "city_name": "Ankara",
        "client_code": "TR4000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:12\"}",
        "dealer_name": "OPAL",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OPAL-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP7SJ626531",
        "city_name": "Ankara",
        "client_code": "TR4000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:13\"}",
        "dealer_name": "OPAL",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OPAL-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ0SJ619843",
        "city_name": "Ankara",
        "client_code": "TR4000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:13\"}",
        "dealer_name": "OPAL",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OPAL-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ4SN527403",
        "city_name": "Ankara",
        "client_code": "TR4000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:02\"}",
        "dealer_name": "OPAL",
        "distrit_name": "Balgat",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OPAL-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SJ623302",
        "city_name": "Ankara",
        "client_code": "TR4000",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "OPAL",
        "distrit_name": "Balgat",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OPAL-Ankara/Balgat",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP1SJ638318",
        "city_name": "İzmir",
        "client_code": "OSB-OPE-593",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:38\"}",
        "dealer_name": "OSMANLI BORNOVA",
        "distrit_name": "Bornova",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OSMANLI BORNOVA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP4SJ655890",
        "city_name": "İzmir",
        "client_code": "OSB-OPE-593",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "OSMANLI BORNOVA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OSMANLI BORNOVA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP5SN527005",
        "city_name": "İzmir",
        "client_code": "OSB-OPE-593",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "OSMANLI BORNOVA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OSMANLI BORNOVA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP7SN527006",
        "city_name": "İzmir",
        "client_code": "OSB-OPE-593",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "OSMANLI BORNOVA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OSMANLI BORNOVA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP8SN526687",
        "city_name": "İzmir",
        "client_code": "OSB-OPE-593",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "OSMANLI BORNOVA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OSMANLI BORNOVA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP8SN527015",
        "city_name": "İzmir",
        "client_code": "OSB-OPE-593",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "OSMANLI BORNOVA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OSMANLI BORNOVA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP9SN526679",
        "city_name": "İzmir",
        "client_code": "OSB-OPE-593",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "OSMANLI BORNOVA",
        "distrit_name": "Bornova",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OSMANLI BORNOVA-İzmir/Bornova",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ8SJ648000",
        "city_name": "Ankara",
        "client_code": "OTB-CIT-341",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "OTO BIANCO",
        "distrit_name": "Çankaya",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTO BIANCO-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ9SJ647986",
        "city_name": "Ankara",
        "client_code": "OTB-CIT-341",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "OTO BIANCO",
        "distrit_name": "Çankaya",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTO BIANCO-Ankara/Çankaya",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS022801",
        "city_name": "Antalya",
        "client_code": "OTA-PEU-9179",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:30\"}",
        "dealer_name": "OTOKOÇ ANTALYA",
        "distrit_name": "Aksu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ ANTALYA-Antalya/Aksu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS015436",
        "city_name": "Antalya",
        "client_code": "OTA-PEU-9179",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-01 03:26:17\"}",
        "dealer_name": "OTOKOÇ ANTALYA",
        "distrit_name": "Aksu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ ANTALYA-Antalya/Aksu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY9SS021354",
        "city_name": "Muğla",
        "client_code": "OBH-PEU-9491",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:31\"}",
        "dealer_name": "OTOKOÇ BODRUM HVL",
        "distrit_name": "Milas",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ BODRUM HVL-Muğla/Milas",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS021317",
        "city_name": "İstanbul",
        "client_code": "OİH-PEU-5912",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:31\"}",
        "dealer_name": "OTOKOÇ İSTANBUL HVL",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ İSTANBUL HVL-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS022791",
        "city_name": "İstanbul",
        "client_code": "OİH-PEU-5912",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:31\"}",
        "dealer_name": "OTOKOÇ İSTANBUL HVL",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ İSTANBUL HVL-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS021349",
        "city_name": "İstanbul",
        "client_code": "OİH-PEU-5912",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:31\"}",
        "dealer_name": "OTOKOÇ İSTANBUL HVL",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ İSTANBUL HVL-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS022839",
        "city_name": "İstanbul",
        "client_code": "OİH-PEU-5912",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:31\"}",
        "dealer_name": "OTOKOÇ İSTANBUL HVL",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ İSTANBUL HVL-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY6SS066381",
        "city_name": "İstanbul",
        "client_code": "OİH-PEU-5912",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "OTOKOÇ İSTANBUL HVL",
        "distrit_name": "Arnavutköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ İSTANBUL HVL-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS021353",
        "city_name": "İstanbul",
        "client_code": "OİH-PEU-5912",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:31\"}",
        "dealer_name": "OTOKOÇ İSTANBUL HVL",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ İSTANBUL HVL-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS015383",
        "city_name": "İstanbul",
        "client_code": "OİH-PEU-5912",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-01 03:26:17\"}",
        "dealer_name": "OTOKOÇ İSTANBUL HVL",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ İSTANBUL HVL-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS029252",
        "city_name": "İstanbul",
        "client_code": "OİH-PEU-5912",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-16 10:32:53\"}",
        "dealer_name": "OTOKOÇ İSTANBUL HVL",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ İSTANBUL HVL-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY0SS021355",
        "city_name": "İstanbul",
        "client_code": "OSG-PEU-3034",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:30\"}",
        "dealer_name": "OTOKOÇ SABİHA GÖKÇEN",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ SABİHA GÖKÇEN-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY0SS066540",
        "city_name": "Trabzon",
        "client_code": "OTH-PEU-9564",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:49\"}",
        "dealer_name": "OTOKOÇ TRABZON HVL",
        "distrit_name": "Ortahisar",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ TRABZON HVL-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS021316",
        "city_name": "Trabzon",
        "client_code": "OTH-PEU-9564",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:30\"}",
        "dealer_name": "OTOKOÇ TRABZON HVL",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ TRABZON HVL-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS015437",
        "city_name": "Trabzon",
        "client_code": "OTH-PEU-9564",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-01 03:26:16\"}",
        "dealer_name": "OTOKOÇ TRABZON HVL",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ TRABZON HVL-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS022799",
        "city_name": "Trabzon",
        "client_code": "OTH-PEU-9564",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:31\"}",
        "dealer_name": "OTOKOÇ TRABZON HVL",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ TRABZON HVL-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS029253",
        "city_name": "Trabzon",
        "client_code": "OTH-PEU-9564",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:31\"}",
        "dealer_name": "OTOKOÇ TRABZON HVL",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOKOÇ TRABZON HVL-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX4S4090710",
        "city_name": "Denizli",
        "client_code": "TR5300",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "OTOMAT",
        "distrit_name": "Gümüşler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOMAT-Denizli/Gümüşler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4084868",
        "city_name": "Denizli",
        "client_code": "TR5300",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "OTOMAT",
        "distrit_name": "Gümüşler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOMAT-Denizli/Gümüşler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4084885",
        "city_name": "Denizli",
        "client_code": "TR5300",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:53\"}",
        "dealer_name": "OTOMAT",
        "distrit_name": "Gümüşler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOMAT-Denizli/Gümüşler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4092793",
        "city_name": "Denizli",
        "client_code": "TR5300",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "OTOMAT",
        "distrit_name": "Gümüşler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOMAT-Denizli/Gümüşler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4082985",
        "city_name": "Denizli",
        "client_code": "TR5300",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:56\"}",
        "dealer_name": "OTOMAT",
        "distrit_name": "Gümüşler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOMAT-Denizli/Gümüşler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4084866",
        "city_name": "Denizli",
        "client_code": "TR5300",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:57\"}",
        "dealer_name": "OTOMAT",
        "distrit_name": "Gümüşler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOMAT-Denizli/Gümüşler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4092787",
        "city_name": "Denizli",
        "client_code": "TR5300",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:58\"}",
        "dealer_name": "OTOMAT",
        "distrit_name": "Gümüşler",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOMAT-Denizli/Gümüşler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ7SJ641371",
        "city_name": "Denizli",
        "client_code": "TR5300",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:03\"}",
        "dealer_name": "OTOMAT",
        "distrit_name": "Gümüşler",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOMAT-Denizli/Gümüşler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VF7VKEHZ3SZ023078",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:12\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPY",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VF7VLEHT3S7804266",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-20 11:54:53\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPY VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VF7VLEHT5S7804267",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-20 11:54:53\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPY VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VF7VLEHT6S7804262",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-20 11:54:53\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPY VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VF7VLEHZ4SU282849",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": null,
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "NO_GROUPAGE",
        "model": "JUMPY VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AB-46",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7ACYHZ8SL018502",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "NO_GROUPAGE",
        "model": "C5 AIRCROSS",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BCZKW7SE034350",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:00\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS4SE029512",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:03\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE028160",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:57\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS5SE033374",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:04\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE029513",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:04\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE033352",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE034534",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:05\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE033409",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:06\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE034463",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE029515",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE034200",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP8SJ653129",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ1SJ624072",
        "city_name": "Ankara",
        "client_code": "01423",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Etimesgut",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOSAY-Ankara/Etimesgut",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXEVKEHZ9SZ034436",
        "city_name": "Ankara",
        "client_code": "TR8095",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Ümitköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "ZAFIRA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOSAY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXEYEF6F7SG014443",
        "city_name": "Ankara",
        "client_code": "TR8095",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOVANO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OTOSAY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "HEAVY_COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKFPHNS1S1011713",
        "city_name": "Ankara",
        "client_code": "TR8095",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "ASTRA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OTOSAY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKFPHNS6S1011531",
        "city_name": "Ankara",
        "client_code": "TR8095",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:17\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "ASTRA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OTOSAY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX7S4091141",
        "city_name": "Ankara",
        "client_code": "TR8095",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Ümitköy",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "OTOSAY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4070550",
        "city_name": "Ankara",
        "client_code": "TR8095",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OTOSAY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4066968",
        "city_name": "Ankara",
        "client_code": "TR8095",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OTOSAY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4067359",
        "city_name": "Ankara",
        "client_code": "TR8095",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OTOSAY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS1SW027841",
        "city_name": "Ankara",
        "client_code": "TR8095",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OTOSAY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS6SW027463",
        "city_name": "Ankara",
        "client_code": "TR8095",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:03\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OTOSAY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHP8SJ630751",
        "city_name": "Ankara",
        "client_code": "TR8095",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:13\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOSAY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ3SJ619853",
        "city_name": "Ankara",
        "client_code": "TR8095",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OTOSAY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ8SN522429",
        "city_name": "Ankara",
        "client_code": "TR8095",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:14\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OTOSAY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZ9SJ619839",
        "city_name": "Ankara",
        "client_code": "TR8095",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:15\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OTOSAY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSJ623298",
        "city_name": "Ankara",
        "client_code": "TR8095",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:15\"}",
        "dealer_name": "OTOSAY",
        "distrit_name": "Ümitköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "OTOSAY-Ankara/Ümitköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ621835",
        "city_name": "Diyarbakır",
        "client_code": "OTO-PEU-574",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:43\"}",
        "dealer_name": "OTOSEÇ",
        "distrit_name": "Yenişehir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "OTOSEÇ-Diyarbakır/Yenişehir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY5SS037857",
        "city_name": "Konya",
        "client_code": "00251",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "ÖZKAYMAK",
        "distrit_name": "Selçuklu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "ÖZKAYMAK-Konya/Selçuklu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS9SY538813",
        "city_name": "Konya",
        "client_code": "00251",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ÖZKAYMAK",
        "distrit_name": "Selçuklu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÖZKAYMAK-Konya/Selçuklu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY1SS037712",
        "city_name": "Konya",
        "client_code": "00251",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ÖZKAYMAK",
        "distrit_name": "Selçuklu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZKAYMAK-Konya/Selçuklu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS031773",
        "city_name": "Konya",
        "client_code": "00251",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ÖZKAYMAK",
        "distrit_name": "Selçuklu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÖZKAYMAK-Konya/Selçuklu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ6SS064498",
        "city_name": "Konya",
        "client_code": "00251",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ÖZKAYMAK",
        "distrit_name": "Selçuklu",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZKAYMAK-Konya/Selçuklu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ6SS065425",
        "city_name": "Konya",
        "client_code": "00251",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ÖZKAYMAK",
        "distrit_name": "Selçuklu",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZKAYMAK-Konya/Selçuklu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZXSS067324",
        "city_name": "Konya",
        "client_code": "00251",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "ÖZKAYMAK",
        "distrit_name": "Selçuklu",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZKAYMAK-Konya/Selçuklu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ631076",
        "city_name": "Konya",
        "client_code": "00251",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÖZKAYMAK",
        "distrit_name": "Selçuklu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÖZKAYMAK-Konya/Selçuklu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS3SE027167",
        "city_name": "Konya",
        "client_code": "01443",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:57\"}",
        "dealer_name": "ÖZKAYMAK",
        "distrit_name": "Selçuklu",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZKAYMAK-Konya/Selçuklu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP4RJ053279",
        "city_name": "Konya",
        "client_code": "01443",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "ÖZKAYMAK",
        "distrit_name": "Selçuklu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZKAYMAK-Konya/Selçuklu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP5SJ626311",
        "city_name": "Konya",
        "client_code": "01443",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "ÖZKAYMAK",
        "distrit_name": "Selçuklu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZKAYMAK-Konya/Selçuklu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ2SJ577666",
        "city_name": "Konya",
        "client_code": "01443",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-13 11:23:11\"}",
        "dealer_name": "ÖZKAYMAK",
        "distrit_name": "Selçuklu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZKAYMAK-Konya/Selçuklu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX2S4090706",
        "city_name": "Konya",
        "client_code": "TR0600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "ÖZKAYMAK",
        "distrit_name": "Selçuklu",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZKAYMAK-Konya/Selçuklu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4071475",
        "city_name": "Konya",
        "client_code": "TR0600",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "ÖZKAYMAK",
        "distrit_name": "Selçuklu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÖZKAYMAK-Konya/Selçuklu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS2SW022356",
        "city_name": "İstanbul",
        "client_code": "TR8010",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "ÖZTEK",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 9,
        "process_date": "2025-04-28",
        "shipping_info": "ÖZTEK-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-15",
        "brand": "OPEL",
        "chassis_no": "VXKKAHPY1S6007438",
        "city_name": "İstanbul",
        "client_code": "TR8010",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-28 11:41:30\"}",
        "dealer_name": "ÖZTEK",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New Grandland",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 2,
        "process_date": "2025-04-14",
        "shipping_info": "ÖZTEK-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-25",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHZXSU288585",
        "city_name": "İstanbul",
        "client_code": "TR8010",
        "color": null,
        "customs_status": null,
        "dealer_name": "ÖZTEK",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-24",
        "shipping_info": "ÖZTEK-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4070066",
        "city_name": "İstanbul",
        "client_code": "TR8010",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:01\"}",
        "dealer_name": "ÖZTEK",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ÖZTEK-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4074290",
        "city_name": "İstanbul",
        "client_code": "TR8010",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "ÖZTEK",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE028524",
        "city_name": "Adana",
        "client_code": "01480",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:57\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS1SY541169",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS4SY541165",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS5SY538968",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:31\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS5SY540011",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS5SY542342",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS6SY538994",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS6SY541202",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS6SY542124",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS7SY540012",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS7SY541161",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS7SY543265",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS8SY540066",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "NO_GROUPAGE",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNSXSY541168",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNSXSY541204",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS064961",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS069662",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ631119",
        "city_name": "Adana",
        "client_code": "00246",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ÖZTEK ADANA",
        "distrit_name": "Yüreğir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ADANA-Adana/Yüreğir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS037590",
        "city_name": "İstanbul",
        "client_code": "00222",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP5SN526123",
        "city_name": "İstanbul",
        "client_code": "00222",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:50\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ0SS066022",
        "city_name": "İstanbul",
        "client_code": "00222",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ1SS067311",
        "city_name": "İstanbul",
        "client_code": "00222",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ3SS069769",
        "city_name": "İstanbul",
        "client_code": "00222",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ628057",
        "city_name": "İstanbul",
        "client_code": "00222",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ629936",
        "city_name": "İstanbul",
        "client_code": "00222",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS3SJ633964",
        "city_name": "İstanbul",
        "client_code": "00222",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ629938",
        "city_name": "İstanbul",
        "client_code": "00222",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ625518",
        "city_name": "İstanbul",
        "client_code": "00222",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS7SJ628055",
        "city_name": "İstanbul",
        "client_code": "00222",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS7SJ629934",
        "city_name": "İstanbul",
        "client_code": "00222",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ625519",
        "city_name": "İstanbul",
        "client_code": "00222",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS9SE034544",
        "city_name": "İstanbul",
        "client_code": "01465",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE033435",
        "city_name": "İstanbul",
        "client_code": "01465",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE034195",
        "city_name": "İstanbul",
        "client_code": "01465",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:07\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP1SJ626256",
        "city_name": "İstanbul",
        "client_code": "01465",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:09\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP1SJ653117",
        "city_name": "İstanbul",
        "client_code": "01465",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP1SJ653120",
        "city_name": "İstanbul",
        "client_code": "01465",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP4SJ626252",
        "city_name": "İstanbul",
        "client_code": "01465",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP4SJ634481",
        "city_name": "İstanbul",
        "client_code": "01465",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP6SJ634482",
        "city_name": "İstanbul",
        "client_code": "01465",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP7SJ626259",
        "city_name": "İstanbul",
        "client_code": "01465",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP8SJ634483",
        "city_name": "İstanbul",
        "client_code": "01465",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ3SJ647997",
        "city_name": "İstanbul",
        "client_code": "01465",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ4SJ647992",
        "city_name": "İstanbul",
        "client_code": "01465",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ9SJ646448",
        "city_name": "İstanbul",
        "client_code": "01465",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:11\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZXSJ620313",
        "city_name": "İstanbul",
        "client_code": "01465",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "ÖZTEK ÇEKMEKÖY",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ÖZTEK ÇEKMEKÖY-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS5SY538825",
        "city_name": "İstanbul",
        "client_code": "00234",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 9,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ621697",
        "city_name": "İstanbul",
        "client_code": "00234",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ621866",
        "city_name": "İstanbul",
        "client_code": "00234",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS9SY538889",
        "city_name": "İstanbul",
        "client_code": "00234",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS037851",
        "city_name": "İstanbul",
        "client_code": "00234",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ621867",
        "city_name": "İstanbul",
        "client_code": "00234",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ631655",
        "city_name": "İstanbul",
        "client_code": "00234",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ631656",
        "city_name": "İstanbul",
        "client_code": "00234",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ625442",
        "city_name": "İstanbul",
        "client_code": "00234",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ631094",
        "city_name": "İstanbul",
        "client_code": "00234",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7ACYHZ6SL018336",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "C5 AIRCROSS",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2024-12-31",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS1RE076815",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-01-02 10:56\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 0,
        "process_date": "2024-12-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP2SJ653112",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP9SJ653107",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:09\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHPXSJ653133",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ0SJ608798",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ2SJ647988",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ3SJ614465",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ4SJ623983",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:11\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ5SJ608814",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ5SJ647984",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ5SJ647998",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ6SJ608790",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ6SJ614475",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ7SJ608796",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ7SJ647985",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:07:10\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "NO_GROUPAGE",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ8SJ608791",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ8SJ608807",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ8SJ614459",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ9SJ608783",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ9SJ614468",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZXSJ608811",
        "city_name": "İstanbul",
        "client_code": "01434",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "ÖZTEK KARTAL",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK KARTAL-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP4SJ634478",
        "city_name": "İstanbul",
        "client_code": "00000809",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "ÖZTEK MADENLER",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK MADENLER-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP6SJ634479",
        "city_name": "İstanbul",
        "client_code": "00000809",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "ÖZTEK MADENLER",
        "distrit_name": "Sancaktepe",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ÖZTEK MADENLER-İstanbul/Sancaktepe",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP4SJ637155",
        "city_name": "Batman",
        "client_code": "ŞAG-PEU-688",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:36\"}",
        "dealer_name": "ŞAKAR GÜMRÜKLEME KOZLUK",
        "distrit_name": "Kozluk",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "RIFTER",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ŞAKAR GÜMRÜKLEME KOZLUK-Batman/Kozluk",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY4SS038398",
        "city_name": "Bursa",
        "client_code": "00080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ŞANÇELİK",
        "distrit_name": "Nilüfer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ŞANÇELİK-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ3SS067150",
        "city_name": "Bursa",
        "client_code": "00080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ŞANÇELİK",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ŞANÇELİK-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ3SS067276",
        "city_name": "Bursa",
        "client_code": "00080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ŞANÇELİK",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ŞANÇELİK-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ4SS064371",
        "city_name": "Bursa",
        "client_code": "00080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ŞANÇELİK",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ŞANÇELİK-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ6SS066087",
        "city_name": "Bursa",
        "client_code": "00080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ŞANÇELİK",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ŞANÇELİK-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ6SS067157",
        "city_name": "Bursa",
        "client_code": "00080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ŞANÇELİK",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ŞANÇELİK-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ7SS063327",
        "city_name": "Bursa",
        "client_code": "00080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ŞANÇELİK",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ŞANÇELİK-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ7SS067135",
        "city_name": "Bursa",
        "client_code": "00080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ŞANÇELİK",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ŞANÇELİK-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ7SS067314",
        "city_name": "Bursa",
        "client_code": "00080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ŞANÇELİK",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ŞANÇELİK-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ8SS063790",
        "city_name": "Bursa",
        "client_code": "00080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ŞANÇELİK",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ŞANÇELİK-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ9SS067282",
        "city_name": "Bursa",
        "client_code": "00080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "ŞANÇELİK",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ŞANÇELİK-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ628061",
        "city_name": "Bursa",
        "client_code": "00080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "ŞANÇELİK",
        "distrit_name": "Nilüfer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ŞANÇELİK-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ652328",
        "city_name": "Bursa",
        "client_code": "00080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:54\"}",
        "dealer_name": "ŞANÇELİK",
        "distrit_name": "Nilüfer",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "ŞANÇELİK-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ630208",
        "city_name": "Bursa",
        "client_code": "00080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ŞANÇELİK",
        "distrit_name": "Nilüfer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ŞANÇELİK-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ629939",
        "city_name": "Bursa",
        "client_code": "00080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "ŞANÇELİK",
        "distrit_name": "Nilüfer",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "ŞANÇELİK-Bursa/Nilüfer",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ631783",
        "city_name": "İstanbul",
        "client_code": "SAP-PEU-477",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "SANTA PHARMA",
        "distrit_name": "Tuzla",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "SANTA PHARMA-İstanbul/Tuzla",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ621831",
        "city_name": "İstanbul",
        "client_code": "SAP-PEU-477",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "SANTA PHARMA",
        "distrit_name": "Tuzla",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "SANTA PHARMA-İstanbul/Tuzla",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ621840",
        "city_name": "İstanbul",
        "client_code": "SAP-PEU-477",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "SANTA PHARMA",
        "distrit_name": "Tuzla",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "SANTA PHARMA-İstanbul/Tuzla",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ631767",
        "city_name": "İstanbul",
        "client_code": "SAP-PEU-477",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "SANTA PHARMA",
        "distrit_name": "Tuzla",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "SANTA PHARMA-İstanbul/Tuzla",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS4SJ631768",
        "city_name": "İstanbul",
        "client_code": "SAP-PEU-477",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:42\"}",
        "dealer_name": "SANTA PHARMA",
        "distrit_name": "Tuzla",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "SANTA PHARMA-İstanbul/Tuzla",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-02",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ621847",
        "city_name": "İstanbul",
        "client_code": "SAP-PEU-477",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:42\"}",
        "dealer_name": "SANTA PHARMA",
        "distrit_name": "Tuzla",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "SANTA PHARMA-İstanbul/Tuzla",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS3SJ629932",
        "city_name": "Antalya",
        "client_code": "00000394",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "SEAL PLAZA",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "SEAL PLAZA-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ629933",
        "city_name": "Antalya",
        "client_code": "00000394",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "SEAL PLAZA",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "SEAL PLAZA-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS7SJ625513",
        "city_name": "Antalya",
        "client_code": "00000394",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "SEAL PLAZA",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "SEAL PLAZA-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ625514",
        "city_name": "Antalya",
        "client_code": "00000394",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "SEAL PLAZA",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "SEAL PLAZA-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ604638",
        "city_name": "Antalya",
        "client_code": "00000394",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "SEAL PLAZA",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "SEAL PLAZA-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7VLEHZ5S7805987",
        "city_name": "Çanakkale",
        "client_code": "01492",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-20 11:54:53\"}",
        "dealer_name": "SE-BA BAŞARAN",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPY VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "SE-BA BAŞARAN-Çanakkale/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHPXSJ626255",
        "city_name": "Çanakkale",
        "client_code": "01492",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-14 18:17:10\"}",
        "dealer_name": "SE-BA BAŞARAN",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "SE-BA BAŞARAN-Çanakkale/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHP2SN526144",
        "city_name": "Van",
        "client_code": "00155",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:49\"}",
        "dealer_name": "SEVİMLİ",
        "distrit_name": "İpekyolu",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "SEVİMLİ-Van/İpekyolu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3EDYHPXSN526652",
        "city_name": "Van",
        "client_code": "00155",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 12:06:51\"}",
        "dealer_name": "SEVİMLİ",
        "distrit_name": "İpekyolu",
        "groupage_status": "NO_GROUPAGE",
        "model": "RIFTER",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "SEVİMLİ-Van/İpekyolu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS9SY538780",
        "city_name": "Van",
        "client_code": "00155",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "SEVİMLİ",
        "distrit_name": "İpekyolu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "SEVİMLİ-Van/İpekyolu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY0SS037832",
        "city_name": "Van",
        "client_code": "00155",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "SEVİMLİ",
        "distrit_name": "İpekyolu",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "SEVİMLİ-Van/İpekyolu",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4034082",
        "city_name": "Muğla",
        "client_code": "SIDA-OPEL-4951",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:39\"}",
        "dealer_name": "SIXT DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4048712",
        "city_name": "Muğla",
        "client_code": "SIDA-OPEL-4951",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:09\"}",
        "dealer_name": "SIXT DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4034074",
        "city_name": "Muğla",
        "client_code": "SIDA-OPEL-4951",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:39\"}",
        "dealer_name": "SIXT DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4043809",
        "city_name": "Muğla",
        "client_code": "SIDA-OPEL-4951",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:09\"}",
        "dealer_name": "SIXT DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4034083",
        "city_name": "Muğla",
        "client_code": "SIDA-OPEL-4951",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:40\"}",
        "dealer_name": "SIXT DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4046606",
        "city_name": "Muğla",
        "client_code": "SIDA-OPEL-4951",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:05\"}",
        "dealer_name": "SIXT DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4037266",
        "city_name": "Muğla",
        "client_code": "SIDA-OPEL-4951",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:05\"}",
        "dealer_name": "SIXT DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4034084",
        "city_name": "Muğla",
        "client_code": "SIDA-OPEL-4951",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:40\"}",
        "dealer_name": "SIXT DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4046607",
        "city_name": "Muğla",
        "client_code": "SIDA-OPEL-4951",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:05\"}",
        "dealer_name": "SIXT DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4037267",
        "city_name": "Muğla",
        "client_code": "SIDA-OPEL-4951",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:05\"}",
        "dealer_name": "SIXT DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4043344",
        "city_name": "Muğla",
        "client_code": "SIDA-OPEL-4951",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:05\"}",
        "dealer_name": "SIXT DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4037268",
        "city_name": "Muğla",
        "client_code": "SIDA-OPEL-4951",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:05\"}",
        "dealer_name": "SIXT DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4043801",
        "city_name": "Muğla",
        "client_code": "SIDA-OPEL-4951",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:10\"}",
        "dealer_name": "SIXT DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4043810",
        "city_name": "Muğla",
        "client_code": "SIDA-OPEL-4951",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:10\"}",
        "dealer_name": "SIXT DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4048711",
        "city_name": "Muğla",
        "client_code": "SIDA-OPEL-4951",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:10\"}",
        "dealer_name": "SIXT DALAMAN",
        "distrit_name": "Dalaman",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT DALAMAN-Muğla/Dalaman",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4018720",
        "city_name": "Mersin",
        "client_code": "SIK-OPE-973",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-21 11:15:29\"}",
        "dealer_name": "SIXT KARSAVRAN",
        "distrit_name": "Tarsus",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT KARSAVRAN-Mersin/Tarsus",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4017125",
        "city_name": "Mersin",
        "client_code": "SIK-OPE-973",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-21 11:15:29\"}",
        "dealer_name": "SIXT KARSAVRAN",
        "distrit_name": "Tarsus",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT KARSAVRAN-Mersin/Tarsus",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4017126",
        "city_name": "Mersin",
        "client_code": "SIK-OPE-973",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-21 11:15:29\"}",
        "dealer_name": "SIXT KARSAVRAN",
        "distrit_name": "Tarsus",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT KARSAVRAN-Mersin/Tarsus",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4018723",
        "city_name": "Mersin",
        "client_code": "SIK-OPE-973",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-21 11:15:29\"}",
        "dealer_name": "SIXT KARSAVRAN",
        "distrit_name": "Tarsus",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT KARSAVRAN-Mersin/Tarsus",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4017130",
        "city_name": "Mersin",
        "client_code": "SIK-OPE-973",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-21 11:15:29\"}",
        "dealer_name": "SIXT KARSAVRAN",
        "distrit_name": "Tarsus",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT KARSAVRAN-Mersin/Tarsus",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4017128",
        "city_name": "Antalya",
        "client_code": "SIK-OPE-314",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-21 11:15:29\"}",
        "dealer_name": "SIXT KEPEZ",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT KEPEZ-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4018717",
        "city_name": "Antalya",
        "client_code": "SIK-OPE-314",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-21 11:15:29\"}",
        "dealer_name": "SIXT KEPEZ",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT KEPEZ-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4017133",
        "city_name": "Antalya",
        "client_code": "SIK-OPE-314",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-21 11:15:29\"}",
        "dealer_name": "SIXT KEPEZ",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT KEPEZ-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4018730",
        "city_name": "Antalya",
        "client_code": "SIK-OPE-314",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-21 11:15:29\"}",
        "dealer_name": "SIXT KEPEZ",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT KEPEZ-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4015738",
        "city_name": "Antalya",
        "client_code": "SIK-OPE-314",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-21 11:15:29\"}",
        "dealer_name": "SIXT KEPEZ",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT KEPEZ-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4017134",
        "city_name": "Antalya",
        "client_code": "SIK-OPE-314",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-21 11:15:29\"}",
        "dealer_name": "SIXT KEPEZ",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT KEPEZ-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4018719",
        "city_name": "Antalya",
        "client_code": "SIK-OPE-314",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-21 11:15:29\"}",
        "dealer_name": "SIXT KEPEZ",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT KEPEZ-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4018722",
        "city_name": "Antalya",
        "client_code": "SIK-OPE-314",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-21 11:15:29\"}",
        "dealer_name": "SIXT KEPEZ",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT KEPEZ-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4015756",
        "city_name": "Antalya",
        "client_code": "SIK-OPE-314",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-21 11:15:29\"}",
        "dealer_name": "SIXT KEPEZ",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT KEPEZ-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4017135",
        "city_name": "Antalya",
        "client_code": "SIK-OPE-314",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-21 11:15:29\"}",
        "dealer_name": "SIXT KEPEZ",
        "distrit_name": "Kepez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT KEPEZ-Antalya/Kepez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4083217",
        "city_name": "İstanbul",
        "client_code": "BOS-OPE-516",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "SIXT SABİHA HVL",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "SIXT SABİHA HVL-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4083218",
        "city_name": "İstanbul",
        "client_code": "BOS-OPE-516",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "SIXT SABİHA HVL",
        "distrit_name": "Pendik",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "SIXT SABİHA HVL-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4084458",
        "city_name": "İstanbul",
        "client_code": "BOS-OPE-516",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "SIXT SABİHA HVL",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "SIXT SABİHA HVL-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4081052",
        "city_name": "İstanbul",
        "client_code": "BOS-OPE-516",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:55\"}",
        "dealer_name": "SIXT SABİHA HVL",
        "distrit_name": "Pendik",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "SIXT SABİHA HVL-İstanbul/Pendik",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4032879",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:39\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4043347",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:09\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4043803",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:09\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4048709",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:09\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4032874",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:39\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4048721",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:09\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4052848",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:09\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4043804",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:09\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4056410",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:09\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4015736",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:40\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4032875",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:40\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4049109",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:09\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4015737",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:40\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4032912",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:40\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4043800",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:09\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK5S4048723",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:09\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4034085",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:40\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4052845",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:10\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4052957",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:10\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4043345",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:10\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK7S4048724",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:10\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4034086",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:40\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK8S4052846",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:10\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4032878",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:41\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4034081",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 09:28:41\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4043346",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:10\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4043802",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:10\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK9S4048725",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:10\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4048720",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:10\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4052847",
        "city_name": "İstanbul",
        "client_code": "BOT-OPE-617",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:10\"}",
        "dealer_name": "SIXT TAYAKADIN",
        "distrit_name": "Arnavutköy",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-03-29",
        "shipping_info": "SIXT TAYAKADIN-İstanbul/Arnavutköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ6SS064369",
        "city_name": "Yalova",
        "client_code": "00236",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "SOYSAL",
        "distrit_name": "Çiftlikköy",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "SOYSAL-Yalova/Çiftlikköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7BFZKW3SE031386",
        "city_name": "Yalova",
        "client_code": "01456",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:50\"}",
        "dealer_name": "SOYSAL",
        "distrit_name": "Çiftlikköy",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "C4 X",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "SOYSAL-Yalova/Çiftlikköy",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-02-14",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS3RJ831048",
        "city_name": "İstanbul",
        "client_code": "98765",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2024-10-04 15:00\"}",
        "dealer_name": "STELLANTIS AP",
        "distrit_name": "Ümraniye",
        "groupage_status": "GROUPAGE_CANCELED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 2,
        "process_date": "2025-02-13",
        "shipping_info": "STELLANTIS AP-İstanbul/Ümraniye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ628366",
        "city_name": "İstanbul",
        "client_code": "98765",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:41\"}",
        "dealer_name": "STELLANTIS AP",
        "distrit_name": "Ümraniye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "STELLANTIS AP-İstanbul/Ümraniye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ628213",
        "city_name": "İstanbul",
        "client_code": "98765",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:43\"}",
        "dealer_name": "STELLANTIS AP",
        "distrit_name": "Ümraniye",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "STELLANTIS AP-İstanbul/Ümraniye",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VF7VLEHT5S7804270",
        "city_name": "Aydın",
        "client_code": "01474",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-20 11:54:53\"}",
        "dealer_name": "SURTAŞ",
        "distrit_name": "Efeler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "JUMPY VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "SURTAŞ-Aydın/Efeler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP7RJ053292",
        "city_name": "Aydın",
        "client_code": "01474",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "SURTAŞ",
        "distrit_name": "Efeler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "SURTAŞ-Aydın/Efeler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHZ3SJ614725",
        "city_name": "Aydın",
        "client_code": "01474",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-02 10:37:16\"}",
        "dealer_name": "SURTAŞ",
        "distrit_name": "Efeler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "SURTAŞ-Aydın/Efeler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS068628",
        "city_name": "Aydın",
        "client_code": "00274",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "SURTAŞ AYDIN",
        "distrit_name": "Efeler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "SURTAŞ AYDIN-Aydın/Efeler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS0SY538814",
        "city_name": "Aydın",
        "client_code": "00274",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "SURTAŞ AYDIN",
        "distrit_name": "Efeler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "SURTAŞ AYDIN-Aydın/Efeler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY3SS037713",
        "city_name": "Aydın",
        "client_code": "00274",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "SURTAŞ AYDIN",
        "distrit_name": "Efeler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "SURTAŞ AYDIN-Aydın/Efeler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY7SS038394",
        "city_name": "Aydın",
        "client_code": "00274",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:51\"}",
        "dealer_name": "SURTAŞ AYDIN",
        "distrit_name": "Efeler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "SURTAŞ AYDIN-Aydın/Efeler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ9SS064379",
        "city_name": "Aydın",
        "client_code": "00274",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "SURTAŞ AYDIN",
        "distrit_name": "Efeler",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "SURTAŞ AYDIN-Aydın/Efeler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ630124",
        "city_name": "Aydın",
        "client_code": "00274",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "SURTAŞ AYDIN",
        "distrit_name": "Efeler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "SURTAŞ AYDIN-Aydın/Efeler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS4SW018020",
        "city_name": "Aydın",
        "client_code": "TR8250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-08 16:16:56\"}",
        "dealer_name": "SURTAŞ AYDIN",
        "distrit_name": "Efeler",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "SURTAŞ AYDIN-Aydın/Efeler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS9SW027439",
        "city_name": "Aydın",
        "client_code": "TR8250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "SURTAŞ AYDIN",
        "distrit_name": "Efeler",
        "groupage_status": "NO_GROUPAGE",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "SURTAŞ AYDIN-Aydın/Efeler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNSXSW028678",
        "city_name": "Aydın",
        "client_code": "TR8250",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:35\"}",
        "dealer_name": "SURTAŞ AYDIN",
        "distrit_name": "Efeler",
        "groupage_status": "NO_GROUPAGE",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "SURTAŞ AYDIN-Aydın/Efeler",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHZ0SU286165",
        "city_name": "Muğla",
        "client_code": "TR8080",
        "color": null,
        "customs_status": null,
        "dealer_name": "TURGUT",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "TURGUT-Muğla/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3UKZKX7SJ611682",
        "city_name": "Muğla",
        "client_code": "00230",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:52\"}",
        "dealer_name": "TURGUT",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "TURGUT-Muğla/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ631777",
        "city_name": "Muğla",
        "client_code": "00230",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "TURGUT",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "TURGUT-Muğla/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUHZKX8S4090712",
        "city_name": "Muğla",
        "client_code": "TR8080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:51\"}",
        "dealer_name": "TURGUT",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "TURGUT-Muğla/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS1SW026799",
        "city_name": "Muğla",
        "client_code": "TR8080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "TURGUT",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "TURGUT-Muğla/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHPXSJ655747",
        "city_name": "Muğla",
        "client_code": "TR8080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:00\"}",
        "dealer_name": "TURGUT",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO CARGO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "TURGUT-Muğla/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "W0VEDYHZXSJ649867",
        "city_name": "Muğla",
        "client_code": "TR8080",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:22:04\"}",
        "dealer_name": "TURGUT",
        "distrit_name": "Merkez",
        "groupage_status": "NO_GROUPAGE",
        "model": "COMBO",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "TURGUT-Muğla/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXEVJYHV4SU285881",
        "city_name": "Muğla",
        "client_code": "TR8081",
        "color": null,
        "customs_status": null,
        "dealer_name": "TURGUT MİLAS",
        "distrit_name": "Milas",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "PDI / PDI-1",
        "pdi_order": "YENİ",
        "pdi_status": null,
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "TURGUT MİLAS-Muğla/Milas",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "PDI"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3FPHNS2SY538877",
        "city_name": "Muğla",
        "client_code": "00258",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:49\"}",
        "dealer_name": "TURGUT MİLAS",
        "distrit_name": "Milas",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "408",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "TURGUT MİLAS-Muğla/Milas",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ634253",
        "city_name": "Muğla",
        "client_code": "00258",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "TURGUT MİLAS",
        "distrit_name": "Milas",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "TURGUT MİLAS-Muğla/Milas",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS9SJ631779",
        "city_name": "Muğla",
        "client_code": "00258",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "TURGUT MİLAS",
        "distrit_name": "Milas",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "TURGUT MİLAS-Muğla/Milas",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4073840",
        "city_name": "Muğla",
        "client_code": "TR8081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "TURGUT MİLAS",
        "distrit_name": "Milas",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "TURGUT MİLAS-Muğla/Milas",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "OPEL",
        "chassis_no": "VXKUSHNS7SW019825",
        "city_name": "Muğla",
        "client_code": "TR8081",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-08 16:16:57\"}",
        "dealer_name": "TURGUT MİLAS",
        "distrit_name": "Milas",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "MOKKA",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "TURGUT MİLAS-Muğla/Milas",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4084500",
        "city_name": "İstanbul",
        "client_code": "TUR-OPE-886",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "TURKRENT",
        "distrit_name": "Ataşehir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "TURKRENT-İstanbul/Ataşehir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4084359",
        "city_name": "İstanbul",
        "client_code": "TUR-OPE-886",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "TURKRENT",
        "distrit_name": "Ataşehir",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "TURKRENT-İstanbul/Ataşehir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4084362",
        "city_name": "İstanbul",
        "client_code": "TUR-OPE-886",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-30 11:21:54\"}",
        "dealer_name": "TURKRENT",
        "distrit_name": "Ataşehir",
        "groupage_status": "NO_GROUPAGE",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "TURKRENT-İstanbul/Ataşehir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS065972",
        "city_name": "Denizli",
        "client_code": "00225",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "TURKUAZ",
        "distrit_name": "Merkezefendi",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "TURKUAZ-Denizli/Merkezefendi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY2SS066054",
        "city_name": "Denizli",
        "client_code": "00225",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:32\"}",
        "dealer_name": "TURKUAZ",
        "distrit_name": "Merkezefendi",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "TURKUAZ-Denizli/Merkezefendi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS068696",
        "city_name": "Denizli",
        "client_code": "00225",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "TURKUAZ",
        "distrit_name": "Merkezefendi",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "TURKUAZ-Denizli/Merkezefendi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ0SS067316",
        "city_name": "Denizli",
        "client_code": "00225",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:33\"}",
        "dealer_name": "TURKUAZ",
        "distrit_name": "Merkezefendi",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "TURKUAZ-Denizli/Merkezefendi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ3SS063664",
        "city_name": "Denizli",
        "client_code": "00225",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "TURKUAZ",
        "distrit_name": "Merkezefendi",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "TURKUAZ-Denizli/Merkezefendi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KCZKZ8SS064373",
        "city_name": "Denizli",
        "client_code": "00225",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-05-02 14:56:34\"}",
        "dealer_name": "TURKUAZ",
        "distrit_name": "Merkezefendi",
        "groupage_status": "NO_GROUPAGE",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "RIHTIM / XX-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "TURKUAZ-Denizli/Merkezefendi",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "HAYDARPAŞA LİMANI",
        "zone_name": "RIHTIM"
    },
    {
        "blg_date": "2025-04-26",
        "brand": "OPEL",
        "chassis_no": "VXEVLEHZ5SU287232",
        "city_name": "Trabzon",
        "client_code": "TR2600",
        "color": null,
        "customs_status": null,
        "dealer_name": "VARDALLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "NO_GROUPAGE",
        "model": "VIVARO",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": "COMPLETED",
        "pdi_status": "1",
        "priority": 1,
        "process_date": "2025-04-25",
        "shipping_info": "VARDALLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "İZMİT DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPYXSS015434",
        "city_name": "Trabzon",
        "client_code": "00282",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-02-01 03:26:16\"}",
        "dealer_name": "VARDALLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 5008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "VARDALLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS0SJ630410",
        "city_name": "Trabzon",
        "client_code": "00282",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "VARDALLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "VARDALLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ630383",
        "city_name": "Trabzon",
        "client_code": "00282",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "VARDALLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "VARDALLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS1SJ630397",
        "city_name": "Trabzon",
        "client_code": "00282",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "VARDALLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "VARDALLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS2SJ628349",
        "city_name": "Trabzon",
        "client_code": "00282",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "VARDALLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "VARDALLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS3SJ630398",
        "city_name": "Trabzon",
        "client_code": "00282",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:53\"}",
        "dealer_name": "VARDALLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "VARDALLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS5SJ630399",
        "city_name": "Trabzon",
        "client_code": "00282",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "VARDALLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "VARDALLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ630377",
        "city_name": "Trabzon",
        "client_code": "00282",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "VARDALLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "VARDALLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS6SJ630380",
        "city_name": "Trabzon",
        "client_code": "00282",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "VARDALLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "VARDALLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS7SJ627956",
        "city_name": "Trabzon",
        "client_code": "00282",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "VARDALLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "VARDALLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNS8SJ630381",
        "city_name": "Trabzon",
        "client_code": "00282",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:54\"}",
        "dealer_name": "VARDALLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "VARDALLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-30",
        "brand": "PEUGEOT",
        "chassis_no": "VR3USHNSXSJ630379",
        "city_name": "Trabzon",
        "client_code": "00282",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:55\"}",
        "dealer_name": "VARDALLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "2008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-29",
        "shipping_info": "VARDALLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-01",
        "brand": "CITROEN",
        "chassis_no": "VR7EDYHP9SJ638574",
        "city_name": "Trabzon",
        "client_code": "01478",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:40\"}",
        "dealer_name": "VARDALLAR",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "BERLINGO VAN",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-30",
        "shipping_info": "VARDALLAR-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "COMMERCIAL",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK0S4049116",
        "city_name": "Trabzon",
        "client_code": "WIR-OPE-520",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:09\"}",
        "dealer_name": "WISH RENT",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "WISH RENT-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK1S4073618",
        "city_name": "Trabzon",
        "client_code": "WIR-OPE-520",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:59\"}",
        "dealer_name": "WISH RENT",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "WISH RENT-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK2S4049117",
        "city_name": "Trabzon",
        "client_code": "WIR-OPE-520",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:09\"}",
        "dealer_name": "WISH RENT",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "WISH RENT-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK3S4073619",
        "city_name": "Trabzon",
        "client_code": "WIR-OPE-520",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:00\"}",
        "dealer_name": "WISH RENT",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "WISH RENT-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4049118",
        "city_name": "Trabzon",
        "client_code": "WIR-OPE-520",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:09\"}",
        "dealer_name": "WISH RENT",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "WISH RENT-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK4S4073595",
        "city_name": "Trabzon",
        "client_code": "WIR-OPE-520",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:37\"}",
        "dealer_name": "WISH RENT",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "WISH RENT-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4049119",
        "city_name": "Trabzon",
        "client_code": "WIR-OPE-520",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:10\"}",
        "dealer_name": "WISH RENT",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "WISH RENT-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNK6S4052960",
        "city_name": "Trabzon",
        "client_code": "WIR-OPE-520",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-21 15:07:10\"}",
        "dealer_name": "WISH RENT",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "WISH RENT-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4046577",
        "city_name": "Trabzon",
        "client_code": "WIR-OPE-520",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-12 10:58:05\"}",
        "dealer_name": "WISH RENT",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "WISH RENT-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-06",
        "brand": "OPEL",
        "chassis_no": "VXKUPHNKXS4073617",
        "city_name": "Trabzon",
        "client_code": "WIR-OPE-520",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:56:02\"}",
        "dealer_name": "WISH RENT",
        "distrit_name": "Ortahisar",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "CORSA",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "WISH RENT-Trabzon/Ortahisar",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNS6SE027311",
        "city_name": "İzmir",
        "client_code": "00000351",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:39\"}",
        "dealer_name": "YAĞIZ PARK",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "YAĞIZ PARK-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE027313",
        "city_name": "İzmir",
        "client_code": "00000351",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:39\"}",
        "dealer_name": "YAĞIZ PARK",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "YAĞIZ PARK-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "CITROEN",
        "chassis_no": "VR7BDHNSXSE028039",
        "city_name": "İzmir",
        "client_code": "00000351",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-19 14:33:39\"}",
        "dealer_name": "YAĞIZ PARK",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "C4 X",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "YAĞIZ PARK-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-04-29",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY0SS037751",
        "city_name": "Kahramanmaraş",
        "client_code": "00117",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-04-25 21:55:50\"}",
        "dealer_name": "ZABUNOĞLU",
        "distrit_name": "Merkez",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "INVOICE",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": null,
        "priority": 0,
        "process_date": "2025-04-28",
        "shipping_info": "ZABUNOĞLU-Kahramanmaraş/Merkez",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    },
    {
        "blg_date": "2025-05-03",
        "brand": "PEUGEOT",
        "chassis_no": "VR3KAHPY8SS023113",
        "city_name": "İzmir",
        "client_code": "00001869",
        "color": null,
        "customs_status": "{\"clearance_date\": \"2025-03-03 03:04:31\"}",
        "dealer_name": "ZİRAAT ADNAN MENDERES",
        "distrit_name": "Gaziemir",
        "groupage_status": "GROUPAGE_COMPLETED",
        "model": "New 3008",
        "order_type": "SHIPPING_BLOCKING",
        "park_address": "STOK / AA-1",
        "pdi_order": null,
        "pdi_status": "1",
        "priority": 0,
        "process_date": "2025-02-28",
        "shipping_info": "ZİRAAT ADNAN MENDERES-İzmir/Gaziemir",
        "status": "AVAILABLE",
        "vehicle_origin": "milli",
        "vehicle_type": "PASSENGER",
        "warehouse_name": "SAMANDIRA DEPO",
        "zone_name": "STOK"
    }
]